import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  viewBox: "0 0 1781.000000 1782.000000",
  preserveAspectRatio: "xMidYMid meet"
}
const _hoisted_2 = {
  transform: "translate(0.000000,1782.000000) scale(0.100000,-0.100000)",
  stroke: "none"
}
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = ["fill"]
const _hoisted_8 = ["fill"]
const _hoisted_9 = ["fill"]
const _hoisted_10 = ["fill"]
const _hoisted_11 = ["fill"]
const _hoisted_12 = ["fill"]
const _hoisted_13 = ["fill"]
const _hoisted_14 = ["fill"]
const _hoisted_15 = ["fill"]
const _hoisted_16 = ["fill"]
const _hoisted_17 = ["fill"]
const _hoisted_18 = ["fill"]
const _hoisted_19 = ["fill"]
const _hoisted_20 = ["fill"]
const _hoisted_21 = ["fill"]
const _hoisted_22 = ["fill"]
const _hoisted_23 = ["fill"]
const _hoisted_24 = ["fill"]
const _hoisted_25 = ["fill"]
const _hoisted_26 = ["fill"]
const _hoisted_27 = ["fill"]
const _hoisted_28 = ["fill"]
const _hoisted_29 = ["fill"]
const _hoisted_30 = ["fill"]
const _hoisted_31 = ["fill"]
const _hoisted_32 = ["fill"]
const _hoisted_33 = ["fill"]
const _hoisted_34 = ["fill"]
const _hoisted_35 = ["fill"]
const _hoisted_36 = ["fill"]
const _hoisted_37 = ["fill"]
const _hoisted_38 = ["fill"]
const _hoisted_39 = ["fill"]
const _hoisted_40 = ["fill"]
const _hoisted_41 = ["fill"]
const _hoisted_42 = ["fill"]
const _hoisted_43 = ["fill"]
const _hoisted_44 = ["fill"]
const _hoisted_45 = ["fill"]
const _hoisted_46 = ["fill"]
const _hoisted_47 = ["fill"]
const _hoisted_48 = ["fill"]
const _hoisted_49 = ["fill"]
const _hoisted_50 = ["fill"]
const _hoisted_51 = ["fill"]
const _hoisted_52 = ["fill"]
const _hoisted_53 = ["fill"]
const _hoisted_54 = ["fill"]
const _hoisted_55 = ["fill"]
const _hoisted_56 = ["fill"]
const _hoisted_57 = ["fill"]
const _hoisted_58 = ["fill"]
const _hoisted_59 = ["fill"]
const _hoisted_60 = ["fill"]
const _hoisted_61 = ["fill"]
const _hoisted_62 = ["fill"]
const _hoisted_63 = ["fill"]
const _hoisted_64 = ["fill"]
const _hoisted_65 = ["fill"]
const _hoisted_66 = ["fill"]
const _hoisted_67 = ["fill"]
const _hoisted_68 = ["fill"]
const _hoisted_69 = ["fill"]
const _hoisted_70 = ["fill"]
const _hoisted_71 = ["fill"]
const _hoisted_72 = ["fill"]
const _hoisted_73 = ["fill"]
const _hoisted_74 = ["fill"]
const _hoisted_75 = ["fill"]
const _hoisted_76 = ["fill"]
const _hoisted_77 = ["fill"]
const _hoisted_78 = ["fill"]
const _hoisted_79 = ["fill"]
const _hoisted_80 = ["fill"]
const _hoisted_81 = ["fill"]
const _hoisted_82 = ["fill"]
const _hoisted_83 = ["fill"]
const _hoisted_84 = ["fill"]
const _hoisted_85 = ["fill"]
const _hoisted_86 = ["fill"]
const _hoisted_87 = ["fill"]
const _hoisted_88 = ["fill"]
const _hoisted_89 = ["fill"]
const _hoisted_90 = ["fill"]
const _hoisted_91 = ["fill"]
const _hoisted_92 = ["fill"]
const _hoisted_93 = ["fill"]
const _hoisted_94 = ["fill"]
const _hoisted_95 = ["fill"]
const _hoisted_96 = ["fill"]
const _hoisted_97 = ["fill"]
const _hoisted_98 = ["fill"]
const _hoisted_99 = ["fill"]
const _hoisted_100 = ["fill"]
const _hoisted_101 = ["fill"]
const _hoisted_102 = ["fill"]
const _hoisted_103 = ["fill"]
const _hoisted_104 = ["fill"]
const _hoisted_105 = ["fill"]
const _hoisted_106 = ["fill"]
const _hoisted_107 = ["fill"]
const _hoisted_108 = ["fill"]
const _hoisted_109 = ["fill"]
const _hoisted_110 = ["fill"]
const _hoisted_111 = ["fill"]
const _hoisted_112 = ["fill"]
const _hoisted_113 = ["fill"]
const _hoisted_114 = ["fill"]
const _hoisted_115 = ["fill"]
const _hoisted_116 = ["fill"]
const _hoisted_117 = ["fill"]
const _hoisted_118 = ["fill"]
const _hoisted_119 = ["fill"]
const _hoisted_120 = ["fill"]
const _hoisted_121 = ["fill"]
const _hoisted_122 = ["fill"]
const _hoisted_123 = ["fill"]
const _hoisted_124 = ["fill"]
const _hoisted_125 = ["fill"]
const _hoisted_126 = ["fill"]
const _hoisted_127 = ["fill"]
const _hoisted_128 = ["fill"]
const _hoisted_129 = ["fill"]
const _hoisted_130 = ["fill"]
const _hoisted_131 = ["fill"]
const _hoisted_132 = ["fill"]
const _hoisted_133 = ["fill"]
const _hoisted_134 = ["fill"]
const _hoisted_135 = ["fill"]
const _hoisted_136 = ["fill"]
const _hoisted_137 = ["fill"]
const _hoisted_138 = ["fill"]
const _hoisted_139 = ["fill"]
const _hoisted_140 = ["fill"]
const _hoisted_141 = ["fill"]
const _hoisted_142 = ["fill"]
const _hoisted_143 = ["fill"]
const _hoisted_144 = ["fill"]
const _hoisted_145 = ["fill"]
const _hoisted_146 = ["fill"]
const _hoisted_147 = ["fill"]
const _hoisted_148 = ["fill"]
const _hoisted_149 = ["fill"]
const _hoisted_150 = ["fill"]
const _hoisted_151 = ["fill"]
const _hoisted_152 = ["fill"]
const _hoisted_153 = ["fill"]
const _hoisted_154 = ["fill"]
const _hoisted_155 = ["fill"]
const _hoisted_156 = ["fill"]
const _hoisted_157 = ["fill"]
const _hoisted_158 = ["fill"]
const _hoisted_159 = ["fill"]
const _hoisted_160 = ["fill"]
const _hoisted_161 = ["fill"]
const _hoisted_162 = ["fill"]
const _hoisted_163 = ["fill"]
const _hoisted_164 = ["fill"]
const _hoisted_165 = ["fill"]
const _hoisted_166 = ["fill"]
const _hoisted_167 = ["fill"]
const _hoisted_168 = ["fill"]
const _hoisted_169 = ["fill"]
const _hoisted_170 = ["fill"]
const _hoisted_171 = ["fill"]
const _hoisted_172 = ["fill"]
const _hoisted_173 = ["fill"]
const _hoisted_174 = ["fill"]
const _hoisted_175 = ["fill"]
const _hoisted_176 = ["fill"]
const _hoisted_177 = ["fill"]
const _hoisted_178 = ["fill"]
const _hoisted_179 = ["fill"]
const _hoisted_180 = ["fill"]
const _hoisted_181 = ["fill"]
const _hoisted_182 = ["fill"]
const _hoisted_183 = ["fill"]
const _hoisted_184 = ["fill"]
const _hoisted_185 = ["fill"]
const _hoisted_186 = ["fill"]
const _hoisted_187 = ["fill"]
const _hoisted_188 = ["fill"]
const _hoisted_189 = ["fill"]
const _hoisted_190 = ["fill"]
const _hoisted_191 = ["fill"]
const _hoisted_192 = ["fill"]
const _hoisted_193 = ["fill"]
const _hoisted_194 = ["fill"]
const _hoisted_195 = ["fill"]
const _hoisted_196 = ["fill"]
const _hoisted_197 = ["fill"]
const _hoisted_198 = ["fill"]
const _hoisted_199 = ["fill"]
const _hoisted_200 = ["fill"]
const _hoisted_201 = ["fill"]
const _hoisted_202 = ["fill"]
const _hoisted_203 = ["fill"]
const _hoisted_204 = ["fill"]
const _hoisted_205 = ["fill"]
const _hoisted_206 = ["fill"]
const _hoisted_207 = ["fill"]
const _hoisted_208 = ["fill"]
const _hoisted_209 = ["fill"]
const _hoisted_210 = ["fill"]
const _hoisted_211 = ["fill"]
const _hoisted_212 = ["fill"]
const _hoisted_213 = ["fill"]
const _hoisted_214 = ["fill"]
const _hoisted_215 = ["fill"]
const _hoisted_216 = ["fill"]
const _hoisted_217 = ["fill"]
const _hoisted_218 = ["fill"]
const _hoisted_219 = ["fill"]
const _hoisted_220 = ["fill"]
const _hoisted_221 = ["fill"]
const _hoisted_222 = ["fill"]
const _hoisted_223 = ["fill"]
const _hoisted_224 = ["fill"]
const _hoisted_225 = ["fill"]
const _hoisted_226 = ["fill"]
const _hoisted_227 = ["fill"]
const _hoisted_228 = ["fill"]
const _hoisted_229 = ["fill"]
const _hoisted_230 = ["fill"]
const _hoisted_231 = ["fill"]
const _hoisted_232 = ["fill"]
const _hoisted_233 = ["fill"]
const _hoisted_234 = ["fill"]
const _hoisted_235 = ["fill"]
const _hoisted_236 = ["fill"]
const _hoisted_237 = ["fill"]
const _hoisted_238 = ["fill"]
const _hoisted_239 = ["fill"]
const _hoisted_240 = ["fill"]
const _hoisted_241 = ["fill"]
const _hoisted_242 = ["fill"]
const _hoisted_243 = ["fill"]
const _hoisted_244 = ["fill"]
const _hoisted_245 = ["fill"]
const _hoisted_246 = ["fill"]
const _hoisted_247 = ["fill"]
const _hoisted_248 = ["fill"]
const _hoisted_249 = ["fill"]
const _hoisted_250 = ["fill"]
const _hoisted_251 = ["fill"]
const _hoisted_252 = ["fill"]
const _hoisted_253 = ["fill"]
const _hoisted_254 = ["fill"]
const _hoisted_255 = ["fill"]
const _hoisted_256 = ["fill"]
const _hoisted_257 = ["fill"]
const _hoisted_258 = ["fill"]
const _hoisted_259 = ["fill"]
const _hoisted_260 = ["fill"]
const _hoisted_261 = ["fill"]
const _hoisted_262 = ["fill"]
const _hoisted_263 = ["fill"]
const _hoisted_264 = ["fill"]
const _hoisted_265 = ["fill"]
const _hoisted_266 = ["fill"]
const _hoisted_267 = ["fill"]
const _hoisted_268 = ["fill"]
const _hoisted_269 = ["fill"]
const _hoisted_270 = ["fill"]
const _hoisted_271 = ["fill"]
const _hoisted_272 = ["fill"]
const _hoisted_273 = ["fill"]
const _hoisted_274 = ["fill"]
const _hoisted_275 = ["fill"]
const _hoisted_276 = ["fill"]
const _hoisted_277 = ["fill"]
const _hoisted_278 = ["fill"]
const _hoisted_279 = ["fill"]
const _hoisted_280 = ["fill"]
const _hoisted_281 = ["fill"]
const _hoisted_282 = ["fill"]
const _hoisted_283 = ["fill"]
const _hoisted_284 = ["fill"]
const _hoisted_285 = ["fill"]
const _hoisted_286 = ["fill"]
const _hoisted_287 = ["fill"]
const _hoisted_288 = ["fill"]
const _hoisted_289 = ["fill"]
const _hoisted_290 = ["fill"]
const _hoisted_291 = ["fill"]
const _hoisted_292 = ["fill"]
const _hoisted_293 = ["fill"]
const _hoisted_294 = ["fill"]
const _hoisted_295 = ["fill"]
const _hoisted_296 = ["fill"]
const _hoisted_297 = ["fill"]
const _hoisted_298 = ["fill"]
const _hoisted_299 = ["fill"]
const _hoisted_300 = ["fill"]
const _hoisted_301 = ["fill"]
const _hoisted_302 = ["fill"]
const _hoisted_303 = ["fill"]
const _hoisted_304 = ["fill"]
const _hoisted_305 = ["fill"]
const _hoisted_306 = ["fill"]
const _hoisted_307 = ["fill"]
const _hoisted_308 = ["fill"]
const _hoisted_309 = ["fill"]
const _hoisted_310 = ["fill"]
const _hoisted_311 = ["fill"]
const _hoisted_312 = ["fill"]
const _hoisted_313 = ["fill"]
const _hoisted_314 = ["fill"]
const _hoisted_315 = ["fill"]
const _hoisted_316 = ["fill"]
const _hoisted_317 = ["fill"]
const _hoisted_318 = ["fill"]
const _hoisted_319 = ["fill"]
const _hoisted_320 = ["fill"]
const _hoisted_321 = ["fill"]
const _hoisted_322 = ["fill"]
const _hoisted_323 = ["fill"]
const _hoisted_324 = ["fill"]
const _hoisted_325 = ["fill"]
const _hoisted_326 = ["fill"]
const _hoisted_327 = ["fill"]
const _hoisted_328 = ["fill"]
const _hoisted_329 = ["fill"]
const _hoisted_330 = ["fill"]
const _hoisted_331 = ["fill"]
const _hoisted_332 = ["fill"]
const _hoisted_333 = ["fill"]
const _hoisted_334 = ["fill"]
const _hoisted_335 = ["fill"]
const _hoisted_336 = ["fill"]
const _hoisted_337 = ["fill"]
const _hoisted_338 = ["fill"]
const _hoisted_339 = ["fill"]
const _hoisted_340 = ["fill"]
const _hoisted_341 = ["fill"]
const _hoisted_342 = ["fill"]
const _hoisted_343 = ["fill"]
const _hoisted_344 = ["fill"]
const _hoisted_345 = ["fill"]
const _hoisted_346 = ["fill"]
const _hoisted_347 = ["fill"]
const _hoisted_348 = ["fill"]
const _hoisted_349 = ["fill"]
const _hoisted_350 = ["fill"]
const _hoisted_351 = ["fill"]
const _hoisted_352 = ["fill"]
const _hoisted_353 = ["fill"]
const _hoisted_354 = ["fill"]
const _hoisted_355 = ["fill"]
const _hoisted_356 = ["fill"]
const _hoisted_357 = ["fill"]
const _hoisted_358 = ["fill"]
const _hoisted_359 = ["fill"]
const _hoisted_360 = ["fill"]
const _hoisted_361 = ["fill"]
const _hoisted_362 = ["fill"]
const _hoisted_363 = ["fill"]
const _hoisted_364 = ["fill"]
const _hoisted_365 = ["fill"]
const _hoisted_366 = ["fill"]
const _hoisted_367 = ["fill"]
const _hoisted_368 = ["fill"]
const _hoisted_369 = ["fill"]
const _hoisted_370 = ["fill"]
const _hoisted_371 = ["fill"]
const _hoisted_372 = ["fill"]
const _hoisted_373 = ["fill"]
const _hoisted_374 = ["fill"]
const _hoisted_375 = ["fill"]
const _hoisted_376 = ["fill"]
const _hoisted_377 = ["fill"]
const _hoisted_378 = ["fill"]
const _hoisted_379 = ["fill"]
const _hoisted_380 = ["fill"]
const _hoisted_381 = ["fill"]
const _hoisted_382 = ["fill"]
const _hoisted_383 = ["fill"]
const _hoisted_384 = ["fill"]
const _hoisted_385 = ["fill"]
const _hoisted_386 = ["fill"]
const _hoisted_387 = ["fill"]
const _hoisted_388 = ["fill"]
const _hoisted_389 = ["fill"]
const _hoisted_390 = ["fill"]
const _hoisted_391 = ["fill"]
const _hoisted_392 = ["fill"]
const _hoisted_393 = ["fill"]
const _hoisted_394 = ["fill"]
const _hoisted_395 = ["fill"]
const _hoisted_396 = ["fill"]
const _hoisted_397 = ["fill"]
const _hoisted_398 = ["fill"]
const _hoisted_399 = ["fill"]
const _hoisted_400 = ["fill"]
const _hoisted_401 = ["fill"]




export default /*@__PURE__*/_defineComponent({
  __name: 'MountainsCircleImage',
  props: {
    color: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8640 17799 c-563 -14 -1098 -80 -1670 -206 -1320 -291 -2563 -888\n-3629 -1742 -362 -290 -824 -731 -1118 -1068 -1278 -1462 -2021 -3211 -2189\n-5153 -21 -251 -30 -939 -15 -1208 141 -2483 1280 -4752 3186 -6348 2375\n-1988 5634 -2591 8578 -1587 1294 441 2460 1173 3434 2155 455 459 796 879\n1135 1398 832 1273 1306 2677 1428 4230 18 220 24 841 11 1075 -81 1492 -489\n2845 -1239 4110 -513 865 -1210 1677 -1999 2327 -1518 1251 -3436 1969 -5388\n2017 -143 3 -379 3 -525 0z m625 -39 c289 -13 743 -52 765 -65 7 -4 -153\n-1261 -161 -1269 -3 -3 -34 -1 -69 4 -242 33 -467 45 -895 45 -430 0 -653 -12\n-899 -46 -38 -5 -70 -8 -72 -6 -8 8 -172 1263 -166 1269 15 15 574 62 837 71\n207 7 459 6 660 -3z m-1540 -92 c8 -34 165 -1213 165 -1237 0 -16 -6 -21 -24\n-21 -47 0 -433 -69 -617 -110 -346 -76 -778 -208 -1092 -332 -71 -28 -132 -46\n-137 -42 -19 20 -491 1167 -483 1175 4 4 55 27 113 50 549 218 1165 390 1753\n489 208 35 263 43 304 49 7 0 15 -9 18 -21z m2534 -4 c635 -98 1278 -271 1889\n-509 67 -26 122 -51 122 -54 0 -8 -478 -1173 -484 -1178 -2 -3 -69 20 -148 50\n-519 200 -1136 363 -1623 428 -49 6 -93 15 -97 18 -4 3 29 285 72 626 44 340\n80 625 80 632 0 17 -3 17 189 -13z m2299 -683 c281 -124 728 -364 1031 -553\n261 -163 681 -458 681 -479 0 -8 -477 -640 -707 -936 l-63 -82 -133 97 c-437\n319 -969 625 -1437 826 -64 27 -104 50 -103 58 2 10 368 905 466 1140 l16 38\n78 -34 c43 -18 120 -52 171 -75z m-6819 -487 c137 -330 240 -589 235 -594 -5\n-5 -70 -35 -145 -68 -470 -208 -969 -497 -1399 -811 -97 -71 -127 -88 -136\n-78 -13 14 -758 980 -767 994 -12 19 452 344 763 535 212 130 448 261 675 373\n219 109 493 233 515 234 11 0 88 -174 259 -585z m3636 -65 c200 -11 477 -39\n486 -48 7 -7 -54 -498 -63 -507 -4 -3 -75 1 -160 10 -412 42 -997 47 -1363 11\n-93 -9 -192 -18 -220 -18 l-50 -2 -33 244 c-18 135 -31 250 -28 256 4 11 125\n26 406 51 237 21 691 23 1025 3z m-1475 -52 c0 -1 16 -117 35 -256 19 -140 33\n-256 32 -257 -2 -2 -63 -12 -137 -24 -477 -72 -977 -205 -1439 -381 -85 -33\n-155 -58 -156 -57 -19 26 -194 473 -188 478 13 14 273 113 453 173 404 135\n829 239 1255 306 128 20 145 22 145 18z m2260 -37 c358 -59 737 -152 1097\n-271 195 -64 492 -174 505 -187 6 -6 -172 -459 -188 -481 -2 -1 -60 20 -131\n47 -446 176 -977 318 -1468 393 -71 11 -131 21 -133 23 -3 4 57 484 63 504 3\n9 16 11 37 8 18 -3 116 -19 218 -36z m-6275 -930 c212 -274 385 -501 385 -503\n0 -2 -57 -51 -127 -108 -406 -329 -788 -711 -1116 -1111 -66 -82 -123 -148\n-127 -148 -11 0 -1005 759 -1008 771 -2 5 48 74 111 152 403 500 850 946 1357\n1355 68 55 128 98 132 96 4 -3 181 -229 393 -504z m10583 391 c493 -398 956\n-863 1350 -1354 70 -87 93 -123 86 -133 -12 -17 -992 -774 -1002 -773 -4 0\n-51 55 -104 122 -307 387 -737 818 -1137 1140 -69 55 -125 105 -123 109 5 19\n765 1008 774 1008 5 0 75 -53 156 -119z m-5331 79 c760 -28 1429 -156 2127\n-405 194 -69 291 -110 289 -121 -1 -8 -60 -153 -179 -442 l-13 -32 -53 21\nc-565 226 -1153 368 -1808 436 -240 25 -944 25 -1190 0 -545 -56 -1013 -156\n-1499 -322 -102 -35 -224 -80 -271 -99 -47 -19 -86 -33 -87 -32 -2 1 -47 109\n-102 239 -92 222 -98 238 -80 247 56 30 381 146 589 210 588 181 1244 288\n1860 303 58 2 119 4 135 5 17 1 143 -3 282 -8z m-3035 -256 c53 -126 97 -232\n97 -235 1 -3 -59 -32 -131 -64 -415 -181 -893 -457 -1281 -738 -116 -83 -141\n-97 -151 -86 -10 11 -169 216 -299 386 -24 32 600 446 1000 662 245 132 634\n314 658 307 6 -1 54 -106 107 -232z m5822 192 c374 -163 746 -365 1106 -601\n184 -120 440 -305 440 -317 0 -16 -302 -403 -314 -402 -6 1 -65 41 -131 89\n-361 264 -791 515 -1210 706 -110 50 -201 92 -203 94 -6 6 192 475 201 475 5\n0 55 -20 111 -44z m-5610 -700 c53 -126 96 -234 96 -240 0 -7 -60 -38 -132\n-70 -511 -225 -1064 -570 -1503 -936 -749 -624 -1372 -1444 -1760 -2315 -37\n-82 -68 -151 -70 -153 -7 -7 -475 193 -475 203 0 30 171 393 275 586 757 1397\n1911 2467 3350 3105 66 29 120 52 121 51 1 -1 45 -105 98 -231z m5476 147\nc190 -81 627 -319 865 -472 416 -266 766 -545 1129 -901 563 -553 984 -1124\n1332 -1805 107 -209 224 -462 224 -483 0 -10 -6 -13 -279 -127 -100 -42 -187\n-75 -193 -73 -5 2 -33 57 -62 123 -642 1458 -1867 2675 -3323 3302 -46 19 -83\n38 -83 42 0 3 43 112 96 243 l97 236 81 -35 c44 -19 97 -42 116 -50z m-2650\n57 c487 -20 868 -74 1320 -186 313 -78 880 -268 880 -295 0 -8 -476 -1174\n-486 -1191 -3 -4 -28 2 -57 14 -306 123 -680 227 -1032 288 l-160 27 -3 32\nc-4 41 -30 41 -39 1 -5 -27 -9 -30 -32 -26 -214 42 -1101 42 -1252 0 -12 -3\n-18 4 -22 26 -9 41 -37 41 -37 0 0 -16 -1 -30 -2 -30 -2 0 -82 -14 -178 -30\n-334 -57 -676 -153 -1022 -286 -26 -10 -49 -16 -51 -14 -3 5 -481 1150 -492\n1182 -5 13 17 25 122 66 652 253 1413 406 2123 425 52 2 115 4 140 5 25 1 151\n-3 280 -8z m-4685 -647 c83 -107 150 -201 150 -208 0 -7 -52 -54 -115 -105\n-363 -294 -749 -679 -1040 -1040 -51 -63 -96 -116 -101 -118 -10 -4 -409 299\n-409 310 0 11 165 214 308 378 162 186 486 510 672 672 165 144 367 308 378\n307 4 0 75 -88 157 -196z m9176 105 c410 -330 819 -739 1155 -1157 46 -57 81\n-107 79 -112 -8 -12 -395 -309 -404 -309 -4 0 -48 51 -98 113 -298 371 -681\n754 -1050 1051 l-123 98 97 126 c53 70 123 162 156 205 33 42 63 77 67 77 4 0\n58 -41 121 -92z m-6954 -531 c134 -320 245 -590 249 -600 5 -14 -6 -23 -57\n-44 -108 -46 -378 -181 -499 -251 -132 -75 -367 -227 -476 -307 -40 -30 -77\n-55 -81 -55 -3 0 -14 7 -24 16 -10 9 -26 14 -35 10 -15 -6 -16 -8 0 -24 9 -10\n16 -23 16 -29 0 -5 -60 -59 -132 -118 -171 -140 -533 -502 -673 -673 -99 -120\n-110 -131 -125 -117 -19 17 -36 19 -45 5 -4 -6 4 -19 17 -29 l23 -19 -32 -44\nc-82 -109 -223 -322 -300 -451 -87 -146 -238 -440 -288 -560 -16 -37 -33 -66\n-39 -64 -43 17 -1192 489 -1194 491 -5 5 90 212 179 389 237 473 503 875 857\n1297 136 161 561 586 722 722 405 340 813 613 1250 834 158 80 421 202 435\n203 6 0 119 -262 252 -582z m4853 518 c1361 -612 2476 -1689 3135 -3030 57\n-115 117 -243 134 -283 l31 -73 -38 -16 c-20 -8 -284 -119 -587 -246 -302\n-126 -557 -232 -565 -234 -10 -3 -21 11 -34 44 -37 94 -185 390 -256 513 -93\n161 -173 285 -282 438 l-88 124 22 18 c18 15 20 21 11 31 -10 9 -17 9 -34 -3\n-22 -14 -26 -11 -110 92 -199 244 -446 493 -692 698 -126 105 -136 116 -122\n132 19 21 19 36 0 44 -9 3 -19 -3 -25 -14 -6 -11 -15 -20 -20 -20 -6 0 -47 28\n-92 61 -265 197 -619 402 -941 545 -64 28 -87 43 -84 54 3 8 109 269 237 580\n128 311 236 575 241 587 10 26 3 28 159 -42z m4749 -950 c228 -343 396 -633\n570 -985 127 -257 234 -501 224 -510 -9 -9 -1161 -490 -1172 -490 -4 0 -24 42\n-45 93 -64 152 -258 541 -359 717 -150 262 -302 498 -474 734 -77 106 -92 131\n-81 142 7 7 235 184 507 394 l494 381 95 -128 c52 -70 160 -227 241 -348z\nm-13911 79 c279 -213 508 -388 509 -389 1 0 -38 -57 -88 -126 -316 -432 -612\n-945 -820 -1418 -30 -68 -59 -125 -64 -127 -9 -4 -1131 451 -1171 474 -9 5 1\n36 36 117 211 490 480 979 787 1435 99 145 295 419 301 420 1 0 231 -174 510\n-386z m6991 70 c406 -35 765 -111 1161 -243 976 -327 1825 -940 2445 -1766\n203 -270 345 -503 500 -816 260 -528 422 -1087 492 -1700 22 -194 25 -838 5\n-1019 -74 -667 -225 -1194 -502 -1755 -503 -1018 -1297 -1812 -2315 -2315\n-600 -296 -1208 -461 -1883 -511 -209 -15 -704 -7 -902 16 -1168 131 -2233\n643 -3055 1469 -1160 1166 -1681 2804 -1409 4431 321 1919 1734 3498 3609\n4034 605 173 1218 231 1854 175z m-6111 -742 c39 -30 72 -57 72 -59 0 -3 -44\n-66 -99 -142 -279 -386 -555 -865 -736 -1278 l-58 -132 -31 13 c-17 7 -123 50\n-236 96 -113 46 -207 85 -209 87 -13 10 168 400 294 635 169 315 386 661 589\n936 l76 102 132 -101 c73 -56 166 -126 206 -157z m11797 57 c135 -189 284\n-422 403 -629 167 -291 423 -823 405 -840 -8 -8 -438 -187 -461 -192 -7 -2\n-34 45 -66 117 -212 475 -449 886 -749 1299 -43 60 -81 115 -84 122 -2 6 83\n79 199 169 l203 156 23 -28 c12 -15 69 -94 127 -174z m2122 -1169 c245 -634\n414 -1283 511 -1958 8 -59 8 -63 -12 -67 -31 -7 -1213 -165 -1234 -165 -15 0\n-22 33 -54 228 -84 510 -233 1054 -412 1505 l-54 138 36 15 c21 8 282 118 582\n244 300 126 551 228 559 227 8 -1 40 -69 78 -167z m-15868 -76 c317 -130 580\n-240 585 -244 4 -5 -14 -66 -42 -137 -123 -312 -249 -725 -328 -1073 -36 -159\n-104 -533 -116 -640 -2 -20 -8 -25 -28 -23 -95 8 -1237 157 -1243 163 -10 9\n33 287 88 565 101 508 256 1038 442 1508 26 64 51 117 56 117 6 0 269 -106\n586 -236z m889 -365 c118 -49 217 -91 219 -93 2 -1 -23 -72 -56 -157 -176\n-462 -309 -962 -381 -1439 -12 -74 -22 -135 -23 -137 -5 -4 -506 62 -511 68\n-8 7 37 287 79 495 61 303 141 601 242 904 50 149 154 427 169 451 7 13 10 12\n262 -92z m13708 64 c137 -328 304 -877 388 -1278 44 -211 97 -545 87 -545 -3\n0 -118 -16 -256 -35 -137 -18 -251 -32 -253 -31 -2 2 -12 62 -23 132 -72 466\n-195 940 -360 1383 -44 117 -79 215 -77 217 7 7 454 193 465 193 7 1 20 -16\n29 -36z m-13181 -280 c116 -48 211 -87 213 -88 2 -2 -16 -49 -39 -106 -214\n-538 -360 -1166 -421 -1814 -20 -213 -17 -923 5 -1135 68 -651 210 -1241 435\n-1805 l20 -51 -233 -97 c-128 -53 -237 -97 -243 -97 -19 0 -174 431 -252 701\n-376 1297 -365 2706 30 3989 64 209 180 533 210 590 12 23 -15 31 275 -87z\nm12704 -38 c258 -678 405 -1356 452 -2094 13 -208 7 -816 -11 -1001 -54 -579\n-164 -1111 -334 -1620 -77 -230 -161 -446 -173 -443 -17 3 -458 185 -465 192\n-4 4 8 47 28 96 59 152 161 456 208 627 245 880 300 1815 160 2728 -72 465\n-213 984 -378 1389 -14 35 -24 67 -21 69 14 14 471 200 477 194 4 -4 29 -66\n57 -137z m-11844 -315 c325 -133 591 -244 593 -245 2 -1 -15 -47 -36 -101\n-114 -286 -218 -663 -271 -984 l-28 -165 -31 -3 c-41 -4 -42 -28 -1 -37 26 -6\n30 -10 25 -33 -41 -208 -42 -977 -2 -1257 0 -5 -11 -11 -26 -13 -20 -2 -28 -9\n-28 -23 0 -14 7 -19 30 -19 33 0 32 3 51 -120 47 -314 146 -687 266 -1004 25\n-65 41 -122 36 -126 -6 -5 -920 -390 -1179 -497 -27 -11 -214 540 -298 877\n-172 695 -230 1434 -166 2131 43 471 141 953 282 1389 80 246 170 481 183 476\n5 -2 276 -113 600 -246z m11310 143 c159 -414 273 -827 345 -1247 32 -189 32\n-184 61 -446 15 -135 22 -279 26 -530 6 -402 -3 -584 -53 -990 -38 -306 -145\n-774 -253 -1105 -62 -190 -162 -455 -172 -455 -13 0 -1182 480 -1191 488 -4 4\n18 72 48 152 117 310 237 776 269 1042 7 54 8 57 38 60 42 4 47 27 7 35 -31 6\n-32 7 -26 47 42 301 42 990 0 1222 -5 28 -3 32 25 37 45 9 41 37 -4 37 -30 0\n-35 3 -35 24 0 55 -54 333 -101 526 -50 201 -138 483 -198 628 l-30 74 47 19\nc26 11 292 123 592 249 300 125 550 229 556 229 6 1 28 -43 49 -96z m2809\n-1220 c8 -40 24 -192 42 -393 21 -234 30 -962 15 -1215 -13 -224 -50 -615 -60\n-630 -6 -11 -1253 144 -1266 156 -3 3 1 64 10 135 57 503 59 1088 5 1613 -11\n102 -18 186 -17 188 3 2 1215 169 1249 172 10 1 18 -9 22 -26z m-16924 -69\nc333 -42 608 -79 612 -83 4 -3 3 -35 -2 -71 -33 -242 -45 -467 -45 -895 0\n-430 12 -653 46 -899 5 -38 8 -70 7 -71 -9 -7 -1264 -171 -1270 -166 -7 7 -43\n359 -59 596 -16 219 -16 861 0 1080 14 205 50 576 57 587 3 4 15 6 27 3 12 -2\n294 -39 627 -81z m957 -123 l208 -26 -2 -50 c0 -27 -9 -126 -18 -220 -36 -366\n-31 -951 11 -1363 9 -85 13 -156 10 -159 -10 -11 -499 -74 -507 -66 -8 10 -35\n269 -50 483 -14 201 -13 751 1 955 12 175 38 452 45 473 4 10 17 11 50 7 24\n-4 138 -19 252 -34z m14658 17 c9 -43 34 -324 46 -516 15 -249 6 -846 -16\n-1082 -16 -176 -31 -300 -37 -305 -2 -2 -507 62 -514 65 0 0 3 28 8 63 63 487\n61 1170 -5 1712 -2 18 15 21 228 51 289 40 283 40 290 12z m-14435 -1885 c1\n-29 46 -297 75 -441 81 -400 200 -809 339 -1162 25 -63 42 -117 38 -121 -18\n-17 -467 -198 -473 -192 -14 14 -123 308 -188 506 -119 360 -212 739 -271\n1097 -17 102 -33 200 -36 218 -2 17 -4 32 -2 33 18 4 479 67 496 68 12 1 22\n-2 22 -6z m14225 -32 l200 -26 -3 -35 c-2 -19 -19 -127 -38 -239 -56 -332\n-133 -651 -240 -998 -46 -149 -200 -572 -213 -585 -5 -6 -460 173 -480 188 -2\n2 23 74 57 161 170 446 295 909 372 1383 11 69 23 140 26 158 l5 33 57 -7 c31\n-4 147 -19 257 -33z m-14766 -136 c65 -487 228 -1104 428 -1623 30 -79 52\n-146 49 -149 -15 -15 -1171 -492 -1177 -485 -16 17 -138 346 -215 577 -161\n485 -272 945 -349 1450 -13 83 -20 153 -17 156 10 10 1256 177 1263 170 3 -3\n12 -46 18 -96z m15632 25 c343 -44 629 -82 635 -84 6 -3 10 -15 8 -28 -98\n-649 -201 -1093 -375 -1611 -65 -192 -194 -536 -207 -549 -6 -6 -1165 462\n-1180 476 -2 3 27 90 66 193 193 516 328 1027 404 1531 12 83 23 152 24 152 1\n0 282 -36 625 -80z m-12823 -972 c150 -339 352 -688 550 -955 l61 -82 -24 -19\nc-22 -17 -23 -21 -10 -32 13 -10 19 -9 35 5 19 17 21 17 42 -11 183 -235 531\n-593 756 -778 72 -60 132 -113 132 -118 0 -5 -6 -17 -12 -28 -18 -29 10 -47\n30 -19 7 10 17 19 23 19 5 0 42 -24 82 -53 263 -195 614 -400 920 -538 65 -29\n116 -58 114 -63 -3 -6 -114 -277 -247 -602 l-243 -592 -71 30 c-39 16 -165 76\n-281 133 -1138 559 -2080 1438 -2724 2540 -146 249 -386 744 -365 752 5 2 270\n114 589 248 319 134 586 244 593 244 7 1 29 -36 50 -81z m10002 -168 c311\n-128 575 -236 587 -241 22 -8 22 -8 -17 -98 -246 -567 -599 -1128 -1016 -1616\n-164 -192 -497 -525 -689 -689 -393 -336 -826 -626 -1280 -856 -174 -88 -426\n-204 -430 -198 -8 13 -495 1188 -495 1195 0 5 26 20 58 33 101 41 353 167 492\n246 139 79 399 247 505 327 l60 46 23 -22 c30 -28 51 -10 28 24 -15 24 -13 25\n87 106 239 192 527 479 725 723 47 58 87 107 89 109 2 2 12 -4 23 -14 19 -17\n22 -17 36 -3 14 13 13 17 -10 32 l-26 16 68 93 c137 185 254 370 380 602 62\n114 166 331 193 402 6 17 15 24 27 20 9 -2 271 -109 582 -237z m-11241 -343\nc19 -45 76 -167 127 -272 524 -1072 1349 -1988 2364 -2627 248 -155 586 -335\n825 -438 55 -24 104 -47 108 -50 10 -8 -182 -480 -196 -480 -20 0 -274 118\n-482 224 -638 326 -1186 721 -1704 1231 -566 556 -1004 1154 -1352 1845 -88\n176 -209 443 -204 449 4 4 467 199 475 200 3 1 20 -36 39 -82z m12127 -21\nc126 -52 230 -98 232 -104 5 -15 -118 -285 -224 -490 -484 -941 -1170 -1754\n-2017 -2393 -335 -253 -709 -485 -1075 -668 -172 -86 -412 -193 -424 -189 -9\n3 -211 470 -205 474 1 1 56 25 122 54 180 78 520 254 695 359 466 281 833 566\n1219 945 408 403 726 805 1021 1295 129 214 342 633 401 789 5 12 13 22 18 22\n4 0 111 -42 237 -94z m-12592 -311 c190 -419 445 -856 711 -1220 48 -66 88\n-125 89 -131 1 -11 -50 -53 -296 -242 l-106 -82 -84 112 c-276 373 -561 854\n-756 1273 -104 225 -129 287 -117 292 6 2 109 46 230 97 121 52 225 94 231 95\n5 1 50 -87 98 -194z m13124 93 c122 -50 222 -94 222 -99 0 -4 -32 -78 -70\n-165 -90 -202 -262 -537 -374 -729 -148 -252 -495 -764 -519 -765 -12 0 -407\n301 -407 311 0 4 42 66 93 136 217 298 412 617 581 953 103 203 131 262 196\n415 16 37 24 46 38 41 9 -4 117 -48 240 -98z m-13688 -203 c52 -125 209 -446\n289 -595 155 -285 351 -594 544 -859 54 -74 95 -137 90 -141 -30 -27 -989\n-763 -999 -767 -38 -14 -501 682 -740 1112 -164 297 -420 844 -399 852 6 2\n271 113 590 247 319 134 583 241 586 237 3 -3 21 -42 39 -86z m14573 -161\nc533 -218 558 -230 552 -252 -10 -39 -123 -289 -220 -487 -221 -449 -486 -888\n-787 -1302 -62 -84 -118 -152 -125 -151 -7 2 -234 172 -504 378 -270 206 -496\n378 -502 382 -6 3 23 51 70 115 233 316 437 645 636 1023 58 111 198 409 241\n513 l15 38 33 -14 c18 -8 284 -117 591 -243z m-13077 -1236 c296 -369 672\n-745 1051 -1051 62 -50 113 -94 113 -99 0 -9 -299 -402 -309 -406 -8 -3 -166\n123 -306 243 -261 224 -586 549 -810 810 -120 140 -246 298 -243 306 2 5 396\n315 404 318 1 1 46 -54 100 -121z m11413 -184 c12 -10 3 -26 -51 -96 -301\n-384 -832 -915 -1216 -1215 -46 -36 -84 -64 -86 -62 -1 2 -73 95 -159 206\nl-156 202 152 125 c368 301 692 625 993 993 l125 152 192 -146 c106 -80 198\n-152 206 -159z m576 -438 c264 -201 481 -370 483 -374 3 -10 -204 -266 -367\n-452 -174 -199 -592 -617 -791 -791 -176 -154 -427 -359 -440 -359 -12 0 -775\n989 -775 1004 0 7 45 49 100 93 418 333 890 808 1194 1200 l64 82 26 -18 c14\n-11 242 -184 506 -385z m-12428 275 c295 -375 737 -816 1144 -1144 l126 -102\n-61 -80 c-449 -592 -710 -931 -716 -933 -4 -1 -71 48 -148 111 -487 392 -976\n882 -1363 1365 l-99 124 27 21 c238 189 981 757 988 756 6 0 52 -53 102 -118z\nm4140 -50 c278 -104 629 -196 920 -243 l142 -22 3 -30 c4 -40 25 -44 33 -6 7\n31 8 32 49 26 304 -43 977 -43 1224 1 30 5 32 4 32 -26 0 -24 4 -31 20 -31 16\n0 20 7 20 34 l0 33 63 7 c254 28 733 151 1044 269 l141 53 12 -25 c45 -100\n490 -1174 487 -1177 -7 -7 -305 -117 -435 -160 -333 -110 -809 -219 -1122\n-258 -406 -50 -588 -59 -990 -53 -327 5 -403 10 -765 53 -93 11 -352 58 -505\n91 -299 65 -784 214 -1012 312 l-47 20 43 103 c23 57 135 327 247 601 158 386\n207 497 219 493 8 -3 88 -32 177 -65z m-2371 -868 c413 -300 824 -537 1299\n-749 72 -32 119 -59 117 -66 -3 -14 -184 -460 -189 -467 -6 -8 -208 83 -435\n196 -419 207 -761 415 -1131 686 l-107 79 28 36 c16 21 86 113 156 205 74 96\n133 166 140 164 7 -3 62 -41 122 -84z m8520 -80 c71 -92 141 -183 156 -203\nl27 -37 -112 -83 c-157 -116 -484 -331 -662 -436 -245 -144 -886 -460 -899\n-443 -16 22 -195 474 -189 480 5 3 58 28 118 54 407 175 979 507 1325 769 47\n35 90 65 96 65 6 1 69 -74 140 -166z m-6702 -277 c1174 -452 2485 -547 3726\n-270 291 65 676 182 944 288 50 20 91 34 92 33 2 -1 48 -110 103 -240 97 -232\n99 -238 78 -247 -12 -4 -47 -18 -77 -30 -548 -220 -1249 -389 -1865 -449 -451\n-44 -974 -42 -1425 5 -455 47 -925 145 -1369 284 -220 69 -546 192 -546 205 0\n13 189 475 194 475 2 0 67 -24 145 -54z m-2155 -91 c437 -319 965 -622 1439\n-826 56 -24 102 -48 102 -54 0 -21 -475 -1168 -486 -1172 -27 -10 -604 266\n-894 428 -318 177 -664 400 -943 606 l-127 95 17 23 c82 109 758 995 760 995\n1 0 60 -43 132 -95z m9449 -400 c210 -272 385 -500 387 -508 4 -8 -35 -43\n-102 -93 -450 -335 -977 -651 -1482 -888 -192 -91 -372 -169 -375 -164 -8 12\n-486 1165 -486 1173 0 6 51 32 113 59 498 217 1100 569 1497 873 30 24 58 43\n61 43 3 0 177 -223 387 -495z m-7435 -54 c441 -165 916 -288 1381 -360 70 -11\n130 -21 132 -23 4 -5 -61 -506 -66 -511 -7 -6 -277 37 -462 73 -300 58 -701\n166 -988 265 -147 51 -393 146 -403 155 -8 7 180 480 190 480 2 0 99 -36 216\n-79z m5220 -157 c54 -130 95 -240 90 -244 -4 -4 -81 -35 -171 -69 -521 -196\n-1024 -328 -1559 -409 l-122 -19 -5 26 c-12 55 -67 484 -63 487 2 2 73 15 158\n29 310 51 631 123 893 201 161 48 472 155 576 198 47 19 90 35 95 35 6 1 54\n-105 108 -235z m-3358 -261 c372 -34 1074 -22 1427 26 l58 8 5 -31 c14 -80 65\n-480 61 -483 -7 -7 -122 -21 -316 -40 -268 -25 -1016 -25 -1285 0 -232 22\n-313 32 -320 38 -4 4 52 477 60 505 2 7 21 8 62 3 32 -5 144 -16 248 -26z\nm3724 -615 c133 -317 241 -579 241 -582 0 -10 -325 -132 -580 -217 -406 -135\n-755 -225 -1170 -303 -207 -38 -437 -73 -443 -66 -3 4 -148 1064 -170 1249 -2\n11 48 23 218 51 542 91 1059 233 1545 425 68 27 107 38 111 31 4 -6 115 -271\n248 -588z m-5862 538 c459 -179 979 -320 1493 -405 l225 -38 -3 -39 c-2 -21\n-38 -307 -80 -634 l-77 -595 -30 3 c-84 9 -379 58 -534 88 -488 98 -979 239\n-1433 414 -100 39 -186 74 -191 79 -6 6 89 250 228 588 131 318 239 581 242\n586 7 12 15 9 160 -47z m1988 -470 c504 -50 1072 -46 1569 10 76 8 140 14 141\n12 3 -4 173 -1262 171 -1265 -9 -11 -399 -48 -671 -64 -260 -15 -946 -6 -1190\n15 -198 18 -404 42 -409 47 -2 2 33 289 78 637 l81 634 40 -6 c22 -3 108 -12\n190 -20z"
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8750 17490 c0 -82 3 -100 15 -100 12 0 15 18 15 100 0 82 -3 100\n-15 100 -12 0 -15 -18 -15 -100z"
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8820 17575 c0 -11 19 -15 89 -17 l90 -3 -85 -103 c-46 -57 -84 -113\n-84 -123 0 -17 8 -19 95 -19 77 0 95 3 95 15 0 11 -17 15 -74 17 l-74 3 84\n105 c46 58 84 113 84 123 0 15 -12 17 -110 17 -90 0 -110 -3 -110 -15z"
      }, null, 8, _hoisted_5),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8750 17330 c0 -11 7 -20 15 -20 8 0 15 9 15 20 0 11 -7 20 -15 20\n-8 0 -15 -9 -15 -20z"
      }, null, 8, _hoisted_6),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8861 17193 c-18 -16 -21 -31 -23 -113 l-3 -95 -112 -3 -113 -3 0\n-34 0 -35 115 0 c140 0 144 -5 45 -70 -25 -16 -63 -45 -85 -64 -40 -34 -40\n-34 -21 -55 18 -20 28 -21 233 -21 l213 0 0 30 0 30 -167 0 -168 0 49 35 c27\n19 60 35 73 35 20 0 23 5 23 40 l0 40 125 0 125 0 0 35 0 35 -125 0 -125 0 0\n75 0 75 50 0 50 0 0 40 0 40 -69 0 c-51 0 -74 -5 -90 -17z"
      }, null, 8, _hoisted_7),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M6928 17374 c-3 -3 1 -30 9 -61 16 -64 11 -73 -45 -73 -25 0 -44 10\n-81 45 -40 37 -52 44 -71 37 -21 -8 -20 -10 28 -50 27 -23 55 -42 61 -42 16 0\n14 -6 -14 -34 -32 -32 -32 -70 1 -103 29 -29 55 -28 155 4 l55 18 -35 133\nc-32 118 -45 145 -63 126z m45 -193 c12 -47 6 -56 -53 -69 -60 -14 -90 -4 -90\n32 0 29 18 44 72 61 55 17 60 15 71 -24z"
      }, null, 8, _hoisted_8),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M6583 17275 c-20 -9 -35 -23 -39 -40 -8 -34 4 -45 21 -20 27 38 36\n45 60 45 26 0 55 -24 55 -45 0 -8 -27 -20 -70 -30 -38 -9 -70 -19 -70 -22 0\n-15 33 -64 49 -73 52 -27 124 4 136 60 14 61 -37 141 -89 140 -11 -1 -35 -7\n-53 -15z m111 -103 c8 -14 -18 -55 -41 -63 -17 -6 -29 -2 -50 15 l-28 24 50\n15 c61 19 63 19 69 9z"
      }, null, 8, _hoisted_9),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M6450 17234 c0 -9 7 -43 16 -76 14 -56 14 -61 -2 -80 -21 -22 -63\n-21 -75 2 -5 8 -17 43 -26 77 -14 47 -21 60 -31 54 -11 -7 -10 -20 3 -72 23\n-89 38 -109 80 -109 21 0 43 8 54 19 14 14 22 16 30 8 24 -24 24 8 1 98 -15\n59 -29 95 -37 95 -7 0 -13 -7 -13 -16z"
      }, null, 8, _hoisted_10),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M6747 16907 l-228 -61 7 -31 c3 -16 8 -31 9 -33 2 -2 45 8 96 22 51\n14 95 24 96 22 2 -2 12 -33 23 -70 l19 -67 -22 -8 c-12 -5 -62 -19 -110 -31\nl-89 -24 6 -30 c4 -16 8 -31 10 -33 2 -3 46 7 97 21 123 34 126 34 138 -11 18\n-62 15 -69 -40 -92 -28 -12 -64 -30 -80 -40 l-30 -19 29 -21 30 -21 83 39 c46\n21 133 55 194 75 60 21 111 39 113 40 7 7 -22 56 -33 56 -6 0 -45 -11 -85 -25\n-40 -14 -77 -25 -81 -25 -8 0 -32 90 -25 97 2 2 48 17 102 32 97 26 99 28 97\n55 -1 16 -4 31 -7 34 -3 3 -51 -7 -107 -22 -56 -15 -105 -24 -109 -19 -4 4\n-14 36 -23 71 -11 47 -12 64 -4 67 7 2 49 14 95 26 45 11 82 26 82 33 0 20\n-12 56 -19 55 -3 0 -109 -28 -234 -62z"
      }, null, 8, _hoisted_11),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M10842 17280 c-22 -84 -22 -110 -3 -110 5 0 18 37 29 83 12 46 24 91\n28 100 4 12 1 17 -13 17 -15 0 -23 -17 -41 -90z"
      }, null, 8, _hoisted_12),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M10930 17262 c-13 -48 -25 -93 -28 -101 -3 -8 1 -12 13 -10 12 3 25\n25 39 68 23 71 48 94 84 80 27 -10 29 -42 7 -114 -9 -27 -13 -55 -11 -62 11\n-29 25 -9 45 67 17 60 19 84 11 100 -15 28 -48 43 -81 36 -16 -3 -29 -2 -29 3\n0 5 -6 11 -14 14 -10 4 -19 -18 -36 -81z"
      }, null, 8, _hoisted_13),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M11169 17263 c-14 -3 -39 -68 -39 -101 0 -5 20 -15 44 -21 58 -14 66\n-14 66 4 0 8 -14 17 -35 21 -25 4 -35 12 -35 24 0 49 70 65 127 30 37 -22 48\n-53 40 -113 -7 -50 -52 -97 -95 -97 -38 0 -92 35 -92 60 0 14 -7 20 -21 20\n-16 0 -19 -4 -14 -22 25 -82 156 -116 213 -55 26 28 52 88 52 123 0 92 -105\n156 -211 127z"
      }, null, 8, _hoisted_14),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M10800 17120 c0 -11 7 -20 15 -20 8 0 15 9 15 20 0 11 -7 20 -15 20\n-8 0 -15 -9 -15 -20z"
      }, null, 8, _hoisted_15),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M10781 16956 l-23 -24 24 -12 c41 -22 127 -90 138 -109 9 -19 6 -18\n-78 4 -48 13 -88 23 -89 22 -1 -1 -4 -14 -8 -29 -7 -28 -6 -29 145 -68 60 -16\n60 -16 47 -49 l-10 -28 -51 13 c-37 10 -52 10 -57 2 -5 -7 -20 0 -45 20 -45\n37 -51 38 -76 15 -19 -17 -19 -18 13 -44 l33 -27 -35 -17 c-19 -10 -35 -19\n-37 -20 -3 -3 15 -43 23 -53 1 -1 24 8 51 22 44 22 49 23 61 8 18 -25 17 -27\n-37 -52 -53 -25 -57 -30 -38 -59 11 -19 13 -19 61 5 57 29 73 27 81 -13 6 -27\n13 -31 124 -60 64 -17 120 -28 123 -25 4 4 10 17 13 28 6 20 0 23 -64 39 -38\n9 -72 21 -75 25 -5 8 54 40 74 40 5 0 22 -16 37 -35 29 -38 41 -42 68 -22 16\n12 16 14 -3 39 -29 37 -26 46 17 50 33 3 37 6 40 32 l4 29 -66 -7 c-53 -5 -66\n-4 -66 8 0 8 -18 18 -45 25 -46 11 -56 28 -36 60 8 12 24 10 107 -12 53 -14\n100 -24 104 -22 4 3 10 15 12 28 4 23 -1 26 -83 47 -49 12 -86 26 -84 31 10\n15 75 30 139 32 67 2 70 4 59 46 -6 23 -8 24 -90 18 -60 -3 -97 -12 -132 -29\nl-49 -24 -34 45 c-28 38 -139 129 -159 131 -3 0 -16 -11 -28 -24z m179 -362\nc64 -17 99 -34 69 -34 -8 0 -35 -13 -60 -29 l-45 -28 -31 59 c-24 45 -27 58\n-14 54 9 -3 45 -12 81 -22z"
      }, null, 8, _hoisted_16),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12836 16628 c-67 -109 -85 -149 -70 -155 8 -3 16 -4 17 -2 2 2 18\n30 37 61 19 32 42 61 53 64 20 6 67 -20 67 -37 0 -6 -16 -40 -36 -76 -27 -47\n-34 -67 -25 -76 13 -13 10 -17 55 64 20 36 36 75 36 87 0 26 -45 62 -76 62\n-15 0 -24 6 -24 15 0 22 -18 18 -34 -7z"
      }, null, 8, _hoisted_17),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13014 16506 c-27 -19 -54 -75 -54 -110 0 -32 37 -72 74 -82 58 -14\n126 51 126 120 0 61 -96 108 -146 72z m98 -33 c23 -21 23 -50 -2 -90 -22 -37\n-58 -50 -89 -34 -39 22 -37 74 7 124 19 22 60 22 84 0z"
      }, null, 8, _hoisted_18),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13187 16361 c-20 -37 -37 -78 -37 -89 0 -26 45 -62 77 -62 l24 0\n-22 -40 c-17 -29 -20 -43 -12 -51 8 -8 15 -5 26 12 22 36 127 220 127 224 0 1\n-6 5 -14 8 -9 4 -26 -15 -51 -58 -38 -64 -64 -82 -95 -65 -32 17 -31 41 5 105\n38 68 42 85 22 85 -7 0 -29 -31 -50 -69z"
      }, null, 8, _hoisted_19),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13425 16291 c-11 -3 -29 -11 -40 -18 -16 -9 -17 -13 -6 -27 12 -15\n16 -15 31 -1 45 40 130 -2 130 -65 0 -68 -62 -140 -120 -140 -30 0 -80 53 -80\n84 0 16 -6 26 -15 26 -18 0 -20 -38 -3 -75 14 -31 75 -65 116 -65 99 0 177\n165 111 236 -37 40 -85 58 -124 45z"
      }, null, 8, _hoisted_20),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12794 16185 c-17 -27 -17 -28 7 -46 l24 -18 -24 -44 c-42 -77 -47\n-82 -76 -69 -36 17 -40 15 -54 -15 -11 -23 -10 -29 5 -40 9 -7 22 -14 27 -16\n6 -2 -11 -40 -37 -86 -27 -45 -45 -86 -40 -90 5 -4 74 -45 154 -91 80 -45 159\n-91 177 -102 l32 -19 15 30 c16 29 15 29 -24 53 l-40 23 37 52 36 52 48 -27\nc48 -26 49 -26 63 -7 24 31 19 43 -24 65 -22 11 -40 23 -40 26 0 13 82 114 93\n114 7 0 26 -9 42 -20 38 -25 38 -25 58 9 l17 28 -198 114 c-108 62 -211 121\n-229 132 l-32 18 -17 -26z m239 -182 c24 -15 35 -28 31 -36 -7 -12 -60 -83\n-75 -100 -4 -5 -43 12 -88 38 l-81 47 33 51 c18 29 37 58 41 65 7 12 33 0 139\n-65z m-191 -144 c29 -18 63 -38 76 -46 l23 -14 -33 -45 c-18 -25 -36 -48 -39\n-50 -4 -2 -39 14 -78 37 l-72 41 19 32 c29 49 47 76 49 76 2 0 26 -14 55 -31z"
      }, null, 8, _hoisted_21),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4752 16543 c-9 -4 -5 -20 18 -59 16 -29 30 -57 30 -62 0 -12 -123\n-77 -127 -66 -2 5 -17 30 -33 56 -20 33 -34 46 -45 42 -8 -3 -13 -9 -12 -13 2\n-3 34 -59 72 -124 54 -95 70 -115 81 -106 11 9 9 18 -11 53 -14 24 -25 47 -25\n52 0 7 110 74 122 74 2 0 14 -20 28 -45 23 -42 42 -56 53 -37 5 7 -111 215\n-129 231 -5 5 -15 6 -22 4z"
      }, null, 8, _hoisted_22),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4457 16368 c-18 -18 -36 -31 -41 -30 -5 2 -15 1 -23 -3 -12 -4 -10\n-11 9 -34 12 -15 35 -49 50 -75 22 -37 33 -46 56 -46 49 0 102 46 102 88 0 29\n-24 24 -28 -6 -6 -41 -67 -67 -90 -39 -9 10 -1 24 33 57 30 30 45 53 45 70 0\n59 -63 69 -113 18z m80 -14 c4 -10 -7 -29 -31 -52 -30 -31 -38 -34 -46 -22\n-15 23 -12 51 7 72 20 22 61 24 70 2z"
      }, null, 8, _hoisted_23),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4318 16294 c-9 -8 86 -169 100 -169 21 0 18 11 -28 93 -41 75 -57\n92 -72 76z"
      }, null, 8, _hoisted_24),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4860 16130 c-33 -39 -74 -96 -91 -126 -23 -40 -36 -54 -47 -49 -9 3\n-52 9 -95 12 -86 7 -97 1 -97 -48 0 -26 2 -26 86 -32 48 -3 88 -8 89 -9 2 -2\n-3 -34 -11 -73 -19 -98 -19 -95 26 -95 35 0 40 3 40 23 0 96 78 263 166 357\nl65 68 -30 21 c-16 12 -32 21 -35 21 -3 0 -32 -32 -66 -70z"
      }, null, 8, _hoisted_25),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4948 16050 c-56 -72 -102 -163 -123 -245 -21 -84 -20 -113 6 -117\n17 -2 5 -13 -50 -43 -39 -22 -71 -42 -71 -45 0 -3 8 -15 18 -28 l18 -23 98 56\nc54 31 99 55 101 53 1 -2 7 -13 14 -25 11 -22 12 -22 47 -6 24 12 33 21 28 32\n-18 45 -16 47 75 100 50 29 91 55 91 57 0 5 -20 45 -25 52 -1 1 -33 -15 -71\n-37 -38 -22 -71 -36 -72 -30 -7 18 7 39 27 39 12 0 23 11 30 31 6 18 11 33 11\n34 0 2 -24 8 -52 15 -90 20 -89 20 -79 39 5 9 28 39 50 66 l40 48 -24 19 c-13\n10 -27 18 -32 18 -4 -1 -29 -28 -55 -60z m19 -195 c2 -1 -2 -27 -8 -59 -10\n-47 -17 -60 -40 -72 -15 -7 -30 -14 -33 -14 -8 0 3 56 21 113 13 42 18 47 36\n41 12 -4 23 -7 24 -9z"
      }, null, 8, _hoisted_26),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4440 16077 c0 -19 10 -27 25 -20 17 6 8 33 -11 33 -8 0 -14 -6 -14\n-13z"
      }, null, 8, _hoisted_27),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8620 16315 c0 -23 3 -25 50 -25 28 0 50 -4 50 -8 0 -4 -20 -28 -45\n-52 -50 -49 -66 -96 -45 -136 16 -28 68 -47 104 -38 28 7 66 48 66 70 0 21\n-44 17 -58 -6 -14 -22 -42 -26 -60 -8 -21 21 -14 36 42 97 48 52 86 108 86\n126 0 3 -43 5 -95 5 -95 0 -95 0 -95 -25z"
      }, null, 8, _hoisted_28),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8850 16200 l0 -140 25 0 c25 0 25 1 25 91 0 49 4 88 8 85 5 -3 32\n-43 60 -90 47 -77 56 -86 82 -86 l30 0 0 140 0 140 -25 0 c-25 0 -25 -1 -25\n-91 0 -49 -4 -88 -8 -85 -5 3 -32 43 -60 90 -47 77 -56 86 -82 86 l-30 0 0\n-140z"
      }, null, 8, _hoisted_29),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M7108 16133 c-15 -4 -15 -10 3 -76 11 -40 22 -81 26 -91 3 -11 -29\n12 -76 55 -60 53 -88 73 -104 71 -12 -2 -24 -6 -26 -8 -5 -5 59 -256 68 -266\n4 -4 16 -5 28 -2 l21 6 -24 86 c-13 47 -22 87 -21 89 2 1 39 -30 82 -70 59\n-53 86 -71 103 -69 13 2 22 10 22 20 -1 32 -67 256 -76 258 -5 1 -17 0 -26 -3z"
      }, null, 8, _hoisted_30),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M6759 16042 c-14 -6 -11 -23 19 -139 32 -123 37 -133 59 -133 12 0\n23 6 23 13 0 7 12 29 26 50 14 21 24 47 22 59 -3 20 -4 19 -31 -7 -15 -16 -29\n-26 -31 -24 -2 2 -15 44 -28 93 -23 90 -30 100 -59 88z"
      }, null, 8, _hoisted_31),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M10600 16133 c-63 -18 -90 -65 -66 -115 14 -26 13 -30 -10 -53 -31\n-32 -30 -50 5 -86 38 -38 88 -40 121 -4 l23 25 -24 8 c-16 6 -28 5 -37 -5 -23\n-23 -47 -12 -47 22 0 23 5 30 25 35 31 7 38 36 10 43 -42 11 -17 94 26 85 13\n-2 39 -32 39 -44 0 -1 10 -5 23 -8 19 -6 22 -4 22 17 0 46 -64 93 -110 80z"
      }, null, 8, _hoisted_32),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M10739 15956 c-34 -131 -35 -135 -15 -140 29 -7 32 -3 50 72 25 99\n31 104 50 36 34 -120 43 -139 67 -151 18 -10 25 -10 30 0 10 19 72 258 68 261\n-2 2 -13 6 -25 10 -18 5 -22 -1 -38 -66 -28 -110 -31 -111 -60 -16 -14 47 -26\n91 -26 97 0 12 -32 31 -52 31 -8 0 -26 -48 -49 -134z"
      }, null, 8, _hoisted_33),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2946 15239 c-14 -11 -33 -33 -41 -49 -9 -17 -25 -30 -45 -33 -40 -8\n-40 -31 0 -25 26 4 30 1 30 -17 0 -52 90 -134 148 -135 39 0 90 30 112 65 57\n92 -18 215 -131 215 -32 0 -55 -7 -73 -21z m128 -28 c37 -25 66 -69 66 -103 0\n-33 -41 -84 -76 -92 -35 -9 -93 21 -121 64 -30 44 -29 59 7 71 32 12 31 34 -1\n26 -27 -7 -23 8 7 32 33 26 80 27 118 2z"
      }, null, 8, _hoisted_34),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2792 15088 c-16 -20 122 -158 140 -140 10 10 -2 27 -58 83 -57 57\n-73 68 -82 57z"
      }, null, 8, _hoisted_35),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2699 14991 c-16 -16 -29 -39 -29 -51 0 -15 -5 -20 -14 -17 -7 3 -18\n1 -24 -5 -10 -10 -1 -19 113 -111 21 -17 25 -18 52 -3 38 19 65 60 61 92 -4\n33 -22 31 -26 -3 -5 -36 -29 -63 -58 -63 -36 0 -38 17 -5 62 37 50 40 91 9\n112 -32 22 -45 20 -79 -13z m68 -27 c6 -15 -5 -42 -33 -79 -15 -20 -15 -20\n-30 -1 -8 11 -14 29 -14 40 0 43 63 76 77 40z"
      }, null, 8, _hoisted_36),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2961 14916 c-9 -10 -8 -16 3 -25 10 -9 16 -8 25 3 9 10 8 16 -3 25\n-10 9 -16 8 -25 -3z"
      }, null, 8, _hoisted_37),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3250 14875 l-34 -35 -33 32 -33 32 -27 -27 -27 -27 27 -28 c33 -35\n33 -39 0 -74 -25 -27 -26 -29 -10 -45 16 -16 18 -15 45 10 15 15 33 27 39 27\n25 0 24 -23 -3 -51 l-28 -29 59 -60 c57 -57 58 -60 32 -60 -15 0 -27 -5 -27\n-11 0 -5 -4 -8 -8 -5 -5 3 -24 -10 -42 -29 -19 -19 -37 -35 -41 -35 -3 0 -9\n42 -12 93 -6 113 -20 153 -59 173 -44 23 -67 12 -141 -65 -82 -84 -86 -108\n-29 -163 l37 -37 25 19 25 19 -28 28 c-15 16 -27 34 -27 39 0 14 83 94 98 94\n22 0 33 -52 39 -182 5 -115 8 -128 26 -134 15 -5 34 9 81 55 34 34 65 58 69\n55 17 -17 3 -43 -60 -106 -57 -57 -65 -69 -53 -82 20 -25 30 -20 91 40 55 54\n57 56 68 35 14 -25 20 -26 48 -2 l23 19 -30 64 c-31 64 -39 105 -19 92 6 -3\n24 6 40 22 23 22 32 25 41 16 9 -9 4 -20 -22 -47 -32 -33 -33 -36 -17 -52 16\n-16 19 -15 51 17 30 28 38 31 51 20 13 -11 19 -9 40 10 20 18 22 25 12 41 -9\n15 -7 23 18 49 27 28 28 31 12 47 -16 16 -19 15 -46 -11 -20 -19 -36 -26 -47\n-22 -15 6 -13 11 14 39 l32 33 -78 77 -77 77 -27 -27 c-23 -23 -29 -24 -43\n-13 -14 12 -12 17 20 50 34 35 35 37 17 53 -17 16 -20 15 -52 -18z m89 -148\nc8 -10 3 -21 -24 -47 -29 -28 -36 -31 -50 -20 -14 12 -12 17 17 47 36 37 41\n39 57 20z m31 -102 c-30 -31 -36 -34 -49 -20 -13 13 -11 19 19 50 30 31 36 34\n49 20 13 -13 11 -19 -19 -50z"
      }, null, 8, _hoisted_38),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2575 14871 c-3 -7 15 -36 44 -67 55 -60 61 -81 33 -107 -29 -26 -42\n-21 -103 39 -45 45 -58 52 -67 41 -17 -20 96 -129 134 -129 29 0 74 41 74 67\n0 8 6 12 14 9 37 -14 18 19 -48 85 -46 46 -76 69 -81 62z"
      }, null, 8, _hoisted_39),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14726 15229 c-31 -33 -56 -68 -56 -78 0 -29 39 -71 65 -71 17 0 23\n-4 19 -14 -14 -36 19 -19 80 43 83 83 83 119 1 42 -54 -51 -89 -63 -113 -39\n-23 23 -12 53 39 104 45 46 56 74 29 74 -4 0 -33 -27 -64 -61z"
      }, null, 8, _hoisted_40),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14907 15113 c-12 -11 13 -31 34 -26 42 11 76 -55 49 -97 -8 -12 -20\n-5 -65 40 -54 53 -57 54 -71 35 -37 -49 -24 -114 28 -141 40 -21 78 -11 117\n30 45 47 46 99 2 138 -29 26 -78 37 -94 21z m17 -112 c38 -38 38 -39 17 -51\n-43 -23 -89 17 -77 66 8 32 16 31 60 -15z"
      }, null, 8, _hoisted_41),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15037 14922 l-37 -38 40 -39 c31 -30 43 -36 52 -27 9 9 6 18 -15 40\n-27 28 -27 29 -9 45 10 9 26 17 35 17 22 0 77 -48 88 -78 20 -52 -34 -132 -98\n-148 -60 -15 -133 58 -113 112 7 16 5 24 -6 28 -10 4 -18 -4 -25 -21 -18 -48\n16 -110 78 -142 57 -29 134 0 181 69 45 67 10 163 -72 201 -23 10 -46 19 -51\n19 -6 0 -28 -17 -48 -38z"
      }, null, 8, _hoisted_42),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14537 14943 c-17 -3 -27 -9 -24 -16 3 -7 15 -36 28 -65 12 -29 20\n-55 17 -57 -2 -3 -28 5 -57 17 -45 19 -53 20 -62 8 -5 -8 -8 -25 -7 -38 3 -19\n15 -27 68 -46 l65 -22 3 -42 c2 -23 0 -42 -5 -42 -4 0 -35 27 -68 60 l-60 60\n-93 -93 -92 -92 150 -150 150 -150 148 148 c81 81 151 147 156 147 5 0 18 -7\n28 -16 16 -16 19 -15 37 7 11 13 20 27 21 31 0 15 -217 188 -237 188 -10 0\n-43 -32 -43 -42 0 -3 29 -27 65 -54 35 -27 65 -51 65 -54 0 -3 -25 -30 -55\n-60 l-55 -54 -27 26 c-26 26 -26 29 -15 78 7 28 12 75 12 103 0 85 -46 228\n-72 226 -7 -1 -26 -4 -41 -6z m91 -480 c-6 -7 -15 -13 -22 -13 -6 0 -50 39\n-98 87 -83 83 -87 88 -71 105 16 18 21 15 110 -74 71 -71 90 -95 81 -105z\nm-73 -73 c-14 -13 -25 -5 -107 77 -80 81 -90 94 -78 108 12 14 24 6 107 -77\n83 -82 91 -94 78 -108z"
      }, null, 8, _hoisted_43),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8585 15764 c-11 -2 -59 -6 -106 -9 -81 -6 -86 -8 -82 -28 4 -21 8\n-22 81 -16 42 3 78 5 80 4 1 -1 3 -19 5 -41 l2 -39 -70 -5 c-47 -3 -70 -9 -69\n-17 1 -7 2 -18 3 -24 1 -8 22 -10 71 -5 l70 7 0 -25 c0 -14 1 -29 3 -33 1 -5\n-31 -11 -70 -14 -80 -6 -86 -9 -77 -33 5 -12 20 -16 68 -16 33 0 78 3 100 7\nl39 6 -8 136 c-3 75 -10 138 -13 142 -4 3 -16 4 -27 3z"
      }, null, 8, _hoisted_44),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8706 15749 c-36 -28 -37 -89 -1 -117 21 -17 23 -21 10 -32 -25 -21\n-19 -76 11 -99 22 -17 41 -21 110 -21 l84 0 0 145 0 145 -94 0 c-79 0 -97 -3\n-120 -21z m154 -64 c0 -45 0 -45 -34 -45 -92 0 -132 70 -48 83 79 12 82 11 82\n-38z m4 -107 c12 -47 9 -49 -51 -46 -48 2 -58 6 -61 22 -5 27 24 46 69 46 30\n0 38 -4 43 -22z"
      }, null, 8, _hoisted_45),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8970 15745 c0 -25 1 -25 85 -25 l85 0 0 -40 0 -40 -75 0 c-73 0 -75\n-1 -75 -25 0 -24 2 -25 70 -25 l70 0 0 -35 0 -35 -75 7 -75 6 0 -27 0 -26 105\n0 105 0 0 139 c0 162 10 151 -132 151 -87 0 -88 0 -88 -25z"
      }, null, 8, _hoisted_46),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9323 15753 c-25 -5 -73 -50 -73 -69 0 -7 10 -16 21 -19 16 -5 28 0\n46 19 59 63 128 6 115 -96 -9 -74 -80 -105 -121 -52 -17 21 -25 24 -46 17\nl-25 -8 20 -32 c40 -66 155 -66 203 -1 45 61 31 186 -26 222 -25 17 -82 26\n-114 19z"
      }, null, 8, _hoisted_47),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8290 15686 l0 -54 -44 -6 c-64 -10 -96 -38 -96 -86 0 -22 8 -47 19\n-61 18 -22 25 -24 107 -21 48 1 89 4 91 6 3 3 -13 170 -23 239 -5 31 -10 37\n-30 37 -22 0 -24 -4 -24 -54z m19 -158 c1 -26 -2 -28 -43 -28 -49 0 -71 18\n-61 49 6 19 18 25 70 33 22 4 33 -13 34 -54z"
      }, null, 8, _hoisted_48),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5421 15486 c-10 -12 -4 -29 29 -87 22 -39 39 -73 37 -75 -2 -2 -43\n19 -92 47 -76 42 -94 48 -112 40 -13 -6 -23 -15 -23 -20 0 -10 117 -222 131\n-236 6 -6 15 -3 25 7 15 15 13 22 -25 92 -24 42 -39 76 -35 76 3 0 46 -23 95\n-51 75 -43 91 -48 109 -39 12 6 20 17 18 24 -7 31 -124 236 -134 236 -6 0 -17\n-6 -23 -14z"
      }, null, 8, _hoisted_49),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5135 15328 c-11 -6 -21 -12 -23 -13 -3 -2 25 -119 45 -190 3 -12\n-28 12 -73 56 -71 69 -81 76 -101 66 -13 -5 -23 -14 -23 -20 0 -20 73 -277 79\n-277 3 0 14 7 24 15 18 13 18 17 -8 100 -14 48 -24 89 -22 91 2 3 33 -26 69\n-65 63 -68 64 -69 91 -55 32 17 32 15 6 116 -11 44 -18 82 -16 84 2 3 32 -27\n66 -65 56 -63 65 -69 82 -58 10 6 19 16 19 20 0 10 -181 207 -189 207 -3 0\n-15 -6 -26 -12z"
      }, null, 8, _hoisted_50),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4781 15134 c-24 -20 -31 -34 -31 -63 0 -42 29 -81 61 -81 18 0 20\n-4 14 -29 -14 -64 75 -96 131 -48 24 21 36 68 22 83 -11 10 -43 -12 -43 -30 0\n-30 -31 -44 -51 -24 -15 14 -15 21 -5 47 16 36 7 55 -18 42 -13 -7 -24 -6 -39\n5 -47 32 -10 100 39 73 17 -9 25 -8 38 6 15 15 15 17 -3 31 -31 22 -81 17\n-115 -12z"
      }, null, 8, _hoisted_51),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12219 15400 c-81 -136 -82 -151 -4 -131 25 6 51 9 56 5 12 -7 40 27\n33 38 -3 5 -18 8 -35 8 -16 0 -29 3 -29 6 0 4 20 40 45 81 25 40 45 78 45 83\n0 5 -9 14 -19 20 -18 9 -27 -2 -92 -110z"
      }, null, 8, _hoisted_52),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12429 15404 c-14 -18 -17 -15 69 -65 57 -33 61 -42 33 -78 l-18 -24\n-59 36 c-53 32 -60 35 -71 20 -16 -21 -12 -26 52 -63 l55 -31 -16 -30 -15 -30\n-47 27 c-26 15 -56 33 -67 40 -18 12 -22 11 -33 -6 -10 -17 -4 -24 72 -69 46\n-28 88 -51 94 -51 9 0 142 214 142 230 0 8 -161 110 -173 110 -2 0 -10 -7 -18\n-16z"
      }, null, 8, _hoisted_53),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12609 15170 c-39 -66 -70 -122 -68 -123 2 -1 11 -8 21 -15 14 -12\n22 -3 65 68 l48 80 3 -109 c2 -102 4 -110 26 -125 24 -15 24 -15 96 106 68\n113 72 122 55 134 -10 7 -21 11 -25 9 -4 -3 -27 -37 -51 -77 l-44 -73 -5 109\nc-4 97 -7 110 -27 123 -21 14 -24 10 -94 -107z"
      }, null, 8, _hoisted_54),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5172 14599 c-53 -34 -85 -119 -44 -119 27 0 43 15 36 33 -8 21 38\n67 67 67 33 0 79 -56 79 -96 0 -39 -34 -68 -73 -62 -23 3 -57 -16 -57 -32 0\n-5 13 -11 29 -15 62 -13 151 55 151 117 0 38 -26 94 -54 113 -30 22 -95 18\n-134 -6z"
      }, null, 8, _hoisted_55),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5010 14483 c-128 -85 -151 -105 -139 -119 10 -12 22 -7 75 31 l63\n45 20 -26 21 -26 -55 -40 c-30 -21 -55 -43 -55 -48 0 -23 25 -18 70 14 58 42\n61 42 77 16 11 -17 7 -23 -47 -60 -37 -27 -57 -47 -53 -56 3 -8 8 -14 12 -14\n11 0 161 105 161 113 0 7 -97 153 -120 179 -3 4 -17 0 -30 -9z"
      }, null, 8, _hoisted_56),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4740 14292 c-77 -59 -95 -89 -77 -130 11 -23 48 -39 66 -27 7 4 11\n-5 11 -22 0 -68 53 -70 143 -5 37 26 67 51 67 55 0 6 -100 145 -129 179 -4 4\n-40 -18 -81 -50z m76 -33 c19 -21 19 -21 -11 -46 -40 -33 -67 -43 -82 -31 -21\n17 -15 35 24 67 45 37 45 37 69 10z m58 -78 c17 -19 16 -21 -24 -50 -67 -48\n-101 -12 -38 41 40 33 40 33 62 9z"
      }, null, 8, _hoisted_57),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4501 14104 c-76 -62 -90 -83 -64 -91 5 -2 36 18 67 43 l57 47 22\n-22 22 -23 -54 -48 c-48 -43 -59 -70 -29 -70 5 0 30 18 55 40 25 22 49 40 53\n40 4 0 14 -8 24 -18 15 -18 13 -21 -44 -67 -53 -42 -59 -51 -46 -63 12 -12 24\n-6 90 49 42 35 76 66 76 69 0 5 -115 147 -139 173 -5 4 -45 -22 -90 -59z"
      }, null, 8, _hoisted_58),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4347 13973 c-16 -16 -15 -19 13 -48 l31 -32 -41 -40 c-47 -47 -55\n-97 -20 -128 36 -32 74 -23 137 32 32 28 58 55 58 62 0 12 -142 171 -154 171\n-3 0 -14 -8 -24 -17z m99 -138 c16 -25 16 -27 -7 -51 -27 -29 -72 -30 -77 -1\n-4 18 43 77 60 77 4 0 15 -11 24 -25z"
      }, null, 8, _hoisted_59),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4146 13770 c-34 -11 -82 -54 -102 -92 -23 -44 -17 -83 17 -122 59\n-67 140 -66 202 3 45 50 54 90 30 138 -31 62 -89 91 -147 73z m60 -59 c17 -10\n36 -33 43 -50 12 -26 11 -34 -3 -56 -25 -38 -60 -57 -90 -49 -28 7 -76 57 -76\n79 0 30 26 69 55 81 38 17 35 17 71 -5z"
      }, null, 8, _hoisted_60),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3960 13505 c-31 -32 -33 -36 -18 -51 15 -15 19 -14 50 21 18 21 33\n43 33 49 0 24 -33 14 -65 -19z"
      }, null, 8, _hoisted_61),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3804 13427 c-52 -52 -63 -87 -39 -123 15 -23 22 -26 56 -20 31 5 37\n3 33 -8 -11 -28 15 -56 51 -56 55 0 125 83 110 131 -4 11 -10 19 -14 19 -13 0\n-42 -36 -35 -43 12 -11 -26 -57 -47 -57 -25 0 -35 25 -20 56 9 20 8 26 -4 31\n-9 3 -24 -2 -35 -12 -22 -20 -53 -17 -58 6 -4 23 36 69 62 69 15 0 27 9 34 25\n11 24 10 25 -20 25 -23 0 -41 -11 -74 -43z"
      }, null, 8, _hoisted_62),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3687 13286 c-14 -20 -15 -30 -6 -50 10 -21 7 -30 -22 -70 -30 -42\n-35 -46 -64 -40 -26 5 -34 1 -48 -19 l-16 -24 114 -22 c137 -26 138 -26 159\n-2 16 18 15 24 -42 136 l-58 117 -17 -26z m53 -156 c11 -22 17 -40 13 -40 -18\n0 -83 21 -83 27 0 7 41 53 47 53 1 0 12 -18 23 -40z"
      }, null, 8, _hoisted_63),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3502 13047 c-24 -31 -20 -37 53 -88 41 -29 75 -56 75 -59 0 -4 -14\n-26 -30 -49 l-31 -42 -79 55 c-78 55 -83 56 -103 20 -6 -11 179 -142 187 -133\n18 21 116 164 116 170 0 4 -40 36 -89 72 -65 48 -92 62 -99 54z"
      }, null, 8, _hoisted_64),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3342 12820 c-10 -17 -10 -25 2 -48 13 -26 12 -30 -19 -73 -28 -39\n-37 -45 -61 -42 -22 3 -32 -1 -42 -17 -7 -12 -12 -24 -9 -26 2 -2 59 -10 126\n-17 l123 -13 15 23 c15 22 12 28 -48 128 -35 58 -66 105 -69 105 -3 0 -11 -9\n-18 -20z m66 -145 l22 -35 -29 0 c-16 0 -36 3 -45 6 -14 5 -14 9 1 35 10 16\n20 29 23 29 3 0 15 -16 28 -35z"
      }, null, 8, _hoisted_65),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3139 12604 c-11 -14 -10 -18 9 -32 l21 -17 -42 -67 c-53 -83 -51\n-82 -75 -69 -19 10 -42 -1 -42 -21 0 -14 78 -49 82 -36 3 7 36 -5 91 -35 l87\n-46 25 39 c14 22 36 57 49 78 l24 38 -51 31 c-59 36 -93 69 -99 97 -1 11 -17\n28 -34 38 -29 17 -32 17 -45 2z m127 -165 c39 -24 42 -37 15 -70 l-20 -24 -63\n34 c-35 19 -65 35 -66 37 -2 1 8 23 23 48 l27 47 26 -26 c13 -14 40 -34 58\n-46z"
      }, null, 8, _hoisted_66),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12281 14776 l4 -83 -38 -28 c-23 -16 -46 -25 -58 -22 -10 3 -19 4\n-19 2 0 -2 -3 -10 -6 -18 -3 -10 5 -18 25 -25 26 -9 35 -7 70 19 64 46 76 39\n45 -23 -25 -49 -25 -52 -8 -65 10 -7 21 -10 26 -5 4 4 34 57 67 117 l61 110\n-22 18 c-22 18 -22 18 -50 -38 -16 -31 -33 -53 -38 -50 -6 3 -10 38 -10 77 0\n56 -4 74 -17 84 -10 7 -22 14 -27 14 -4 0 -6 -38 -5 -84z"
      }, null, 8, _hoisted_67),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12460 14652 c-76 -75 -77 -176 -2 -227 46 -32 108 -34 145 -5 92 73\n91 196 -3 249 -58 32 -96 28 -140 -17z m135 -37 c38 -38 28 -102 -23 -148 -29\n-26 -80 -19 -105 15 -18 24 -19 32 -9 66 15 48 57 92 89 92 13 0 35 -11 48\n-25z"
      }, null, 8, _hoisted_68),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12750 14442 c-30 -47 -58 -90 -61 -95 -4 -6 -22 -1 -42 12 -35 21\n-36 21 -46 3 -9 -17 0 -26 75 -76 47 -32 92 -55 100 -52 14 6 20 36 7 36 -5 0\n-18 9 -31 18 l-24 18 61 94 c33 51 58 97 55 102 -3 4 -13 12 -22 17 -15 8 -27\n-4 -72 -77z"
      }, null, 8, _hoisted_69),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12928 14389 c-32 -12 -34 -18 -14 -44 12 -17 18 -18 40 -7 56 25\n108 -31 82 -91 -14 -35 -69 -87 -90 -87 -25 0 -66 41 -66 66 0 16 -8 27 -22\n33 -54 20 -40 -71 17 -115 40 -30 102 -35 139 -10 37 24 76 80 82 118 13 87\n-87 168 -168 137z"
      }, null, 8, _hoisted_70),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13160 14209 c-54 -22 -100 -92 -100 -151 0 -74 86 -146 158 -134 70\n11 145 115 128 179 -9 37 -55 88 -93 103 -37 16 -58 17 -93 3z m108 -69 c34\n-32 29 -82 -11 -127 -43 -47 -88 -50 -124 -9 -12 15 -23 36 -23 48 0 25 35 84\n58 98 28 16 77 11 100 -10z"
      }, null, 8, _hoisted_71),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13400 14027 c-33 -17 -51 -54 -39 -84 7 -20 6 -23 -16 -23 -27 0\n-65 -42 -65 -73 0 -11 30 -49 68 -88 l67 -68 98 107 97 107 -57 53 c-32 30\n-72 60 -90 68 -38 17 -32 17 -63 1z m95 -81 l39 -33 -25 -30 -25 -30 -31 26\nc-41 35 -54 61 -42 83 14 27 41 22 84 -16z m-80 -98 l36 -31 -26 -26 -26 -26\n-35 38 c-29 31 -33 41 -24 57 15 28 34 25 75 -12z"
      }, null, 8, _hoisted_72),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13561 13802 c-8 -15 -3 -26 28 -56 36 -35 38 -36 54 -18 16 17 15\n20 -21 55 -43 42 -48 44 -61 19z"
      }, null, 8, _hoisted_73),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13684 13701 c-39 -24 -70 -63 -84 -107 -10 -29 -9 -43 5 -80 37 -97\n142 -122 221 -52 65 57 80 114 45 178 -38 73 -122 100 -187 61z m130 -61 c42\n-41 13 -118 -57 -153 -33 -16 -38 -17 -65 -3 -66 34 -55 120 22 167 35 22 70\n18 100 -11z"
      }, null, 8, _hoisted_74),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13819 13401 c-41 -41 -38 -77 9 -138 69 -86 59 -86 172 12 55 48\n102 91 105 95 2 4 -4 15 -15 25 -20 18 -21 18 -53 -13 -18 -18 -36 -32 -40\n-32 -4 0 -25 18 -46 40 -48 51 -88 54 -132 11z m114 -59 l27 -28 -22 -21 c-39\n-35 -46 -35 -73 1 -22 29 -24 38 -15 55 15 29 51 26 83 -7z"
      }, null, 8, _hoisted_75),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14127 13316 c-16 -12 -13 -18 34 -77 l51 -64 -27 -22 c-14 -13 -29\n-23 -34 -23 -4 0 -24 23 -45 51 -25 32 -44 48 -53 45 -8 -4 -17 -6 -19 -6 -14\n0 1 -29 38 -72 l41 -49 -22 -22 -22 -22 -53 58 c-45 52 -54 57 -65 43 -7 -8\n-9 -21 -5 -28 15 -24 107 -133 116 -136 6 -3 155 109 212 159 5 4 -22 46 -59\n93 -38 47 -69 86 -69 86 -1 0 -9 -7 -19 -14z"
      }, null, 8, _hoisted_76),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14240 13053 c-13 -17 -19 -35 -16 -48 5 -19 2 -21 -23 -17 -22 3\n-33 -2 -50 -23 -11 -15 -21 -36 -21 -45 0 -18 69 -129 93 -148 9 -8 37 8 107\n59 52 39 102 74 110 79 12 7 8 18 -24 64 -61 88 -81 106 -120 106 -26 0 -40\n-7 -56 -27z m106 -60 c41 -44 41 -52 7 -77 l-26 -19 -24 27 c-29 34 -39 72\n-23 91 18 22 29 19 66 -22z m-87 -84 c25 -33 23 -52 -7 -68 -17 -9 -24 -5 -46\n27 -30 44 -32 58 -9 70 22 13 36 7 62 -29z"
      }, null, 8, _hoisted_77),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14465 12866 c-17 -12 -15 -16 24 -74 22 -33 41 -65 41 -69 0 -5 -13\n-17 -30 -26 l-29 -18 -37 56 c-39 58 -45 63 -62 42 -9 -10 -3 -26 24 -65 36\n-54 36 -65 4 -82 -16 -9 -25 -1 -60 49 -37 52 -44 58 -60 48 -10 -6 -16 -16\n-13 -22 44 -74 106 -154 116 -148 7 3 58 38 115 75 l103 69 -17 27 c-93 145\n-100 152 -119 138z"
      }, null, 8, _hoisted_78),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14572 12593 c2 -24 7 -28 29 -25 28 3 67 -24 70 -48 4 -37 -4 -52\n-43 -80 -74 -54 -147 -30 -135 44 4 24 1 39 -9 47 -24 19 -44 -7 -44 -58 0\n-38 5 -50 35 -80 34 -34 38 -35 91 -31 72 6 133 47 153 104 13 36 12 44 -4 78\n-22 45 -67 76 -113 76 -30 0 -33 -2 -30 -27z"
      }, null, 8, _hoisted_79),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8060 15190 c0 -33 3 -40 20 -40 21 0 27 30 14 64 -13 33 -34 17 -34\n-24z"
      }, null, 8, _hoisted_80),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9716 15199 c-9 -46 -8 -49 14 -49 16 0 20 7 20 30 0 17 0 33 1 38 0\n4 -6 8 -14 10 -9 2 -17 -9 -21 -29z"
      }, null, 8, _hoisted_81),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8074 15088 c3 -13 6 -31 6 -40 0 -12 8 -18 21 -18 17 0 20 4 15 23\n-3 12 -6 30 -6 40 0 11 -8 17 -21 17 -17 0 -20 -4 -15 -22z"
      }, null, 8, _hoisted_82),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9700 15070 c0 -45 23 -57 34 -17 11 41 7 57 -14 57 -17 0 -20 -7\n-20 -40z"
      }, null, 8, _hoisted_83),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8090 14963 c0 -16 4 -34 9 -42 14 -22 31 -3 31 35 0 27 -4 34 -20\n34 -15 0 -20 -7 -20 -27z"
      }, null, 8, _hoisted_84),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9686 14968 c-11 -42 -7 -58 14 -58 17 0 20 7 20 40 0 45 -23 57 -34\n18z"
      }, null, 8, _hoisted_85),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8108 14830 c4 -42 8 -45 31 -31 19 12 5 71 -18 71 -13 0 -16 -8 -13\n-40z"
      }, null, 8, _hoisted_86),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9670 14830 c0 -45 23 -57 34 -17 11 41 7 57 -14 57 -17 0 -20 -7\n-20 -40z"
      }, null, 8, _hoisted_87),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8124 14719 c3 -17 6 -35 6 -39 0 -5 8 -6 18 -3 27 7 18 73 -10 73\n-18 0 -20 -5 -14 -31z"
      }, null, 8, _hoisted_88),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9656 14734 c-10 -27 -7 -52 8 -57 20 -8 26 2 26 40 0 35 -23 47 -34\n17z"
      }, null, 8, _hoisted_89),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8153 14633 c-7 -3 -13 -20 -13 -39 0 -27 4 -34 20 -34 15 0 20 7 20\n28 0 33 -11 50 -27 45z"
      }, null, 8, _hoisted_90),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9638 14596 c-3 -26 0 -36 13 -39 12 -3 19 4 23 25 9 45 8 48 -13 48\n-14 0 -20 -9 -23 -34z"
      }, null, 8, _hoisted_91),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8164 14512 c-7 -4 -9 -21 -7 -39 4 -25 10 -33 25 -33 16 0 19 5 14\n23 -3 12 -6 30 -6 40 0 18 -8 21 -26 9z"
      }, null, 8, _hoisted_92),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9626 14497 c-11 -41 -7 -57 14 -57 16 0 20 7 20 34 0 40 -25 56 -34\n23z"
      }, null, 8, _hoisted_93),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8174 14386 c-9 -24 4 -66 22 -66 11 0 14 9 12 37 -3 38 -24 56 -34\n29z"
      }, null, 8, _hoisted_94),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9610 14376 c0 -13 -3 -31 -6 -40 -4 -11 0 -16 14 -16 24 0 40 59 20\n72 -21 13 -28 9 -28 -16z"
      }, null, 8, _hoisted_95),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8189 14275 c-3 -2 -3 -20 -1 -40 3 -26 9 -35 23 -35 20 0 24 17 13\n58 -6 20 -24 29 -35 17z"
      }, null, 8, _hoisted_96),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9596 14265 c-13 -36 -7 -65 15 -65 17 0 20 5 17 37 -3 39 -21 55\n-32 28z"
      }, null, 8, _hoisted_97),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8205 14123 c8 -45 10 -47 28 -40 9 3 12 17 9 41 -3 28 -9 36 -24 36\n-18 0 -19 -4 -13 -37z"
      }, null, 8, _hoisted_98),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9580 14136 c0 -13 -3 -31 -6 -40 -4 -11 0 -16 14 -16 14 0 21 9 26\n31 7 35 1 49 -20 49 -8 0 -14 -10 -14 -24z"
      }, null, 8, _hoisted_99),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3832 14378 c-8 -8 4 -27 49 -76 32 -36 58 -66 56 -68 -1 -2 -47 8\n-101 22 l-99 25 -21 -20 -21 -21 100 -100 c94 -94 100 -99 117 -83 18 16 16\n20 -49 86 -37 38 -61 67 -53 65 8 -2 59 -14 112 -27 80 -21 99 -22 112 -12 9\n8 16 18 16 23 0 13 -181 198 -194 198 -7 0 -17 -5 -24 -12z"
      }, null, 8, _hoisted_100),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3602 14148 l-21 -22 51 -95 52 -95 -50 29 c-27 16 -69 41 -94 56\nl-45 28 -22 -21 c-23 -21 -23 -21 -4 -52 10 -17 43 -71 71 -121 29 -49 55 -92\n57 -94 2 -3 12 4 23 15 19 19 19 20 -30 98 -27 44 -48 81 -46 83 2 2 39 -18\n82 -46 62 -39 82 -48 97 -40 39 22 37 33 -28 148 l-37 64 29 -18 c15 -10 52\n-34 81 -54 41 -27 57 -33 70 -25 9 6 17 15 19 21 2 6 -40 39 -94 73 -54 35\n-107 69 -118 76 -18 12 -24 11 -43 -8z"
      }, null, 8, _hoisted_101),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3325 13886 c-67 -61 -69 -65 -53 -82 17 -17 19 -17 57 20 l39 38 3\n-80 c4 -68 8 -84 28 -106 66 -70 186 20 140 105 -10 19 -12 20 -29 4 -10 -9\n-16 -24 -13 -36 11 -42 -46 -68 -67 -30 -5 11 -10 55 -10 98 -1 43 -6 91 -13\n106 l-12 28 -70 -65z"
      }, null, 8, _hoisted_102),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13830 14425 c-11 -14 -7 -22 25 -55 l39 -40 -67 0 c-134 0 -189 -70\n-113 -146 36 -36 84 -46 104 -21 17 20 -4 42 -39 42 -42 0 -60 26 -35 54 15\n16 33 20 116 23 136 4 141 11 60 93 -35 36 -67 65 -71 65 -4 0 -12 -7 -19 -15z"
      }, null, 8, _hoisted_103),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13990 14264 c-11 -13 -5 -23 41 -70 l53 -54 -27 -27 -27 -27 -50 49\nc-47 47 -51 48 -67 32 -16 -16 -15 -20 32 -67 l49 -50 -22 -22 -22 -22 -54 53\nc-47 46 -57 52 -70 41 -14 -11 -8 -21 46 -82 34 -39 68 -73 76 -75 13 -5 202\n171 202 188 0 10 -131 149 -140 149 -4 0 -13 -7 -20 -16z"
      }, null, 8, _hoisted_104),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14097 13982 c-92 -92 -96 -98 -80 -115 16 -16 21 -14 86 50 56 54\n68 63 63 43 -3 -14 -16 -64 -28 -112 -21 -81 -21 -89 -6 -104 22 -22 36 -13\n137 89 76 77 82 86 71 106 -11 21 -13 20 -77 -39 -36 -34 -67 -60 -69 -58 -1\n2 8 48 22 102 24 93 24 99 8 117 -9 11 -20 19 -23 19 -4 0 -50 -44 -104 -98z"
      }, null, 8, _hoisted_105),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5015 13961 c-3 -5 6 -22 19 -38 19 -21 27 -25 36 -17 9 9 8 18 -5\n38 -18 26 -39 34 -50 17z"
      }, null, 8, _hoisted_106),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5097 13873 c-12 -11 -7 -27 13 -52 16 -19 23 -21 35 -11 12 10 11\n16 -7 41 -22 30 -30 34 -41 22z"
      }, null, 8, _hoisted_107),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5171 13776 c-10 -12 -9 -20 6 -40 18 -25 43 -31 49 -11 2 6 -7 23\n-20 38 -20 24 -24 26 -35 13z"
      }, null, 8, _hoisted_108),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5242 13678 c-13 -16 30 -74 47 -64 17 11 13 31 -12 55 -19 17 -26\n19 -35 9z"
      }, null, 8, _hoisted_109),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5313 13582 c-8 -5 -4 -16 12 -36 17 -22 27 -26 39 -19 15 8 15 12\n-4 36 -23 29 -28 31 -47 19z"
      }, null, 8, _hoisted_110),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5391 13491 c-10 -6 -10 -13 -3 -28 18 -33 38 -45 50 -30 15 18 -27\n71 -47 58z"
      }, null, 8, _hoisted_111),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5461 13396 c-17 -20 32 -77 50 -59 9 9 6 18 -10 42 -26 36 -25 35\n-40 17z"
      }, null, 8, _hoisted_112),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5537 13303 c-12 -11 -7 -27 13 -52 16 -19 23 -21 35 -11 12 10 11\n16 -7 41 -22 30 -30 34 -41 22z"
      }, null, 8, _hoisted_113),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5611 13206 c-10 -12 -9 -20 6 -40 18 -25 43 -31 49 -11 2 6 -7 23\n-20 38 -20 24 -24 26 -35 13z"
      }, null, 8, _hoisted_114),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5683 13109 c-15 -15 23 -70 43 -62 19 7 17 24 -5 51 -22 25 -23 26\n-38 11z"
      }, null, 8, _hoisted_115),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3844 12788 c-4 -6 4 -21 20 -35 23 -20 31 -22 43 -11 13 11 11 15\n-13 35 -33 26 -40 28 -50 11z"
      }, null, 8, _hoisted_116),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3941 12716 c-9 -11 -5 -19 19 -36 23 -16 35 -19 42 -12 8 8 7 16 -2\n27 -23 28 -47 36 -59 21z"
      }, null, 8, _hoisted_117),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4034 12639 c-3 -6 6 -22 22 -34 25 -20 31 -22 43 -10 12 12 11 17\n-10 34 -27 23 -45 26 -55 10z"
      }, null, 8, _hoisted_118),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4132 12568 c-9 -9 -4 -17 20 -34 17 -13 35 -21 39 -18 16 10 9 32\n-16 48 -29 19 -28 19 -43 4z"
      }, null, 8, _hoisted_119),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4227 12495 c-4 -8 5 -23 20 -35 21 -16 29 -18 40 -8 13 10 11 16\n-13 35 -34 27 -40 28 -47 8z"
      }, null, 8, _hoisted_120),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4326 12433 c-13 -13 -5 -31 20 -48 32 -20 56 -6 34 20 -18 21 -46\n36 -54 28z"
      }, null, 8, _hoisted_121),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4414 12349 c-3 -6 6 -22 22 -34 25 -20 31 -22 43 -10 12 12 11 17\n-10 34 -27 23 -45 26 -55 10z"
      }, null, 8, _hoisted_122),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4514 12278 c-8 -13 43 -61 57 -53 16 11 10 32 -16 49 -29 19 -32 19\n-41 4z"
      }, null, 8, _hoisted_123),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4611 12206 c-9 -11 -6 -18 15 -35 32 -25 40 -26 47 -6 4 9 -5 22\n-22 35 -24 17 -31 18 -40 6z"
      }, null, 8, _hoisted_124),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4706 12143 c-13 -13 -5 -31 20 -48 32 -20 56 -6 34 20 -18 21 -46\n36 -54 28z"
      }, null, 8, _hoisted_125),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12746 13944 c-16 -22 -16 -28 -4 -40 12 -12 17 -10 36 16 23 30 22\n50 -1 50 -7 0 -20 -12 -31 -26z"
      }, null, 8, _hoisted_126),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12681 13854 c-12 -15 -20 -32 -18 -38 7 -21 26 -16 46 12 17 25 19\n32 7 41 -11 9 -18 6 -35 -15z"
      }, null, 8, _hoisted_127),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12601 13752 c-17 -25 -19 -32 -7 -41 11 -9 18 -6 35 15 12 15 20 32\n18 38 -7 21 -26 16 -46 -12z"
      }, null, 8, _hoisted_128),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12532 13660 c-23 -30 -22 -50 1 -50 7 0 20 12 31 26 16 22 16 28 4\n40 -12 12 -17 10 -36 -16z"
      }, null, 8, _hoisted_129),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12461 13566 c-24 -26 -27 -42 -7 -49 11 -4 56 41 56 57 0 15 -31 11\n-49 -8z"
      }, null, 8, _hoisted_130),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12381 13461 c-19 -27 -20 -29 -3 -36 12 -4 24 2 39 21 12 15 20 31\n17 36 -10 16 -33 7 -53 -21z"
      }, null, 8, _hoisted_131),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12311 13372 c-17 -25 -19 -32 -7 -41 11 -9 18 -6 35 15 12 15 20 32\n18 38 -7 21 -26 16 -46 -12z"
      }, null, 8, _hoisted_132),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12236 13274 c-16 -22 -16 -28 -4 -40 12 -12 17 -10 36 16 23 30 22\n50 -1 50 -7 0 -20 -12 -31 -26z"
      }, null, 8, _hoisted_133),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12170 13185 c-13 -14 -20 -31 -17 -39 9 -23 21 -20 45 13 17 23 19\n31 8 40 -9 8 -19 5 -36 -14z"
      }, null, 8, _hoisted_134),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12090 13080 c-20 -28 -20 -31 -4 -37 18 -7 58 31 51 50 -7 22 -26\n17 -47 -13z"
      }, null, 8, _hoisted_135),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13918 12776 c-23 -20 -25 -26 -13 -36 11 -9 20 -8 39 7 25 18 31 43\n11 49 -5 2 -22 -7 -37 -20z"
      }, null, 8, _hoisted_136),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13826 12704 c-25 -22 -27 -27 -15 -39 12 -12 18 -10 43 11 25 22 27\n27 15 39 -12 12 -18 10 -43 -11z"
      }, null, 8, _hoisted_137),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13726 12627 c-24 -20 -26 -24 -13 -35 12 -11 20 -9 43 11 16 14 24\n29 20 35 -10 17 -17 15 -50 -11z"
      }, null, 8, _hoisted_138),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13635 12555 c-23 -18 -27 -26 -19 -35 13 -13 41 -2 62 23 10 11 9\n17 -1 25 -10 8 -20 5 -42 -13z"
      }, null, 8, _hoisted_139),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13540 12482 c-16 -13 -21 -25 -17 -36 6 -16 9 -16 37 4 30 21 35 40\n13 47 -5 2 -20 -5 -33 -15z"
      }, null, 8, _hoisted_140),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13446 12408 c-18 -16 -23 -27 -17 -37 7 -11 14 -10 40 8 18 13 28\n27 24 36 -7 20 -18 19 -47 -7z"
      }, null, 8, _hoisted_141),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13351 12336 c-27 -20 -29 -25 -17 -35 12 -10 20 -9 40 6 26 18 33\n38 17 47 -4 3 -22 -5 -40 -18z"
      }, null, 8, _hoisted_142),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13256 12264 c-25 -22 -27 -27 -15 -39 12 -12 18 -10 43 11 25 22 27\n27 15 39 -12 12 -18 10 -43 -11z"
      }, null, 8, _hoisted_143),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13156 12187 c-24 -20 -26 -24 -13 -35 12 -11 20 -9 43 11 16 14 24\n29 20 35 -10 17 -17 15 -50 -11z"
      }, null, 8, _hoisted_144),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13065 12115 c-23 -18 -27 -26 -19 -35 13 -13 41 -2 62 23 10 11 9\n17 -1 25 -10 8 -20 5 -42 -13z"
      }, null, 8, _hoisted_145),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M16215 13427 c-56 -34 -71 -48 -73 -70 -4 -33 22 -77 44 -77 11 0 14\n-5 10 -16 -13 -34 8 -31 82 12 90 53 96 59 88 73 -5 7 -31 -2 -75 -26 -67 -37\n-68 -37 -94 -20 -50 32 -34 61 60 113 49 27 61 43 37 51 -5 2 -41 -16 -79 -40z"
      }, null, 8, _hoisted_146),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15890 13278 c0 -2 7 -25 15 -52 19 -64 19 -76 -2 -46 -9 14 -18 27\n-19 29 -3 3 -173 -90 -192 -105 -2 -1 18 -39 44 -84 31 -54 43 -85 37 -91 -7\n-7 -23 12 -48 56 -35 64 -38 66 -58 52 -12 -8 -21 -18 -19 -23 8 -22 178 -314\n182 -314 3 1 13 7 24 15 17 13 17 16 -13 68 -17 30 -31 60 -31 66 0 28 22 5\n61 -64 24 -41 46 -75 51 -75 6 0 174 95 187 106 2 2 -4 15 -13 30 -28 42 -13\n37 34 -11 l44 -45 22 21 23 22 -25 33 c-24 31 -124 114 -137 114 -4 0 -7 -7\n-7 -15 0 -8 -3 -15 -7 -15 -7 0 -83 122 -83 133 0 3 9 3 20 0 17 -5 20 -1 19\n28 0 19 -8 63 -17 99 -17 64 -17 65 -54 68 -21 2 -38 2 -38 0z m14 -209 c23\n-41 26 -53 15 -60 -16 -10 -19 -8 -53 53 -25 44 -25 53 4 57 3 1 18 -22 34\n-50z m-70 -45 c31 -55 30 -50 12 -57 -18 -7 -70 77 -62 99 8 21 20 11 50 -42z\nm167 -126 c17 -33 18 -42 8 -49 -19 -11 -71 71 -57 88 14 17 25 9 49 -39z\nm-75 -34 c22 -37 24 -48 13 -54 -19 -12 -71 69 -57 88 14 17 14 17 44 -34z"
      }, null, 8, _hoisted_147),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M16322 13235 c-86 -50 -94 -56 -84 -71 10 -17 182 83 175 102 -7 19\n-7 19 -91 -31z"
      }, null, 8, _hoisted_148),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M16173 13145 c-7 -20 2 -29 21 -22 9 4 13 13 10 22 -8 19 -23 19 -31\n0z"
      }, null, 8, _hoisted_149),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M16430 13114 c-43 -25 -50 -26 -142 -20 -82 6 -97 5 -92 -7 6 -16 55\n-27 122 -27 23 0 42 -3 42 -7 0 -3 -16 -35 -35 -71 -29 -52 -33 -67 -23 -79\n10 -12 19 -1 55 70 38 76 48 88 93 113 46 25 58 43 34 51 -5 1 -29 -9 -54 -23z"
      }, null, 8, _hoisted_150),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15582 13089 c-59 -35 -61 -19 16 -153 42 -73 44 -80 28 -92 -16 -11\n-16 -14 -1 -44 13 -26 21 -31 40 -26 21 5 29 -3 75 -84 28 -49 55 -92 60 -95\n12 -7 100 44 100 59 0 7 -6 21 -14 31 -12 17 -17 18 -41 7 -16 -7 -32 -9 -36\n-5 -4 4 -51 82 -103 173 l-95 164 30 18 c29 18 29 18 12 45 -9 16 -17 29 -18\n30 0 1 -24 -12 -53 -28z"
      }, null, 8, _hoisted_151),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M1475 13426 c-5 -12 0 -37 14 -70 33 -75 32 -81 -14 -84 -72 -4 -103\n-12 -109 -28 -5 -14 5 -15 84 -8 l90 7 21 -49 c11 -27 25 -60 30 -73 7 -18 13\n-21 21 -13 9 9 5 28 -14 77 l-26 65 36 1 c57 2 95 13 100 28 4 11 -10 13 -77\n7 -64 -6 -81 -5 -82 6 0 7 -15 45 -33 83 -27 56 -35 66 -41 51z"
      }, null, 8, _hoisted_152),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M1837 13252 l-27 -19 28 -39 c16 -22 50 -58 76 -81 l48 -42 -36 -60\n-35 -61 27 -14 c27 -14 27 -14 60 45 18 32 36 59 40 59 4 0 23 -11 43 -23 l37\n-22 -42 -70 -41 -70 -80 32 c-44 17 -88 34 -97 37 -16 4 -18 17 -18 105 l0\n101 -35 0 -35 0 0 -100 0 -100 -35 0 c-49 0 -91 -24 -103 -59 -8 -23 -6 -37 9\n-69 11 -22 28 -47 39 -57 18 -16 20 -16 49 1 l31 18 -26 27 c-36 38 -29 63 19\n67 24 2 37 -1 37 -9 0 -19 62 -149 71 -149 18 0 59 24 59 34 0 7 -6 20 -13 31\n-7 11 -18 32 -25 48 l-12 27 33 -14 c66 -28 87 -39 87 -47 0 -4 -16 -34 -35\n-66 -19 -32 -35 -63 -35 -70 0 -16 43 -39 47 -26 2 6 10 19 18 29 14 18 14 18\n15 -3 0 -27 -2 -26 57 -12 43 11 45 13 39 42 -8 39 -8 39 -41 27 -35 -13 -39\n-9 -24 24 15 32 22 32 67 4 l35 -21 18 22 c28 34 23 48 -21 71 -22 11 -40 22\n-40 24 0 1 27 49 59 106 l60 102 -107 64 c-66 39 -127 85 -159 119 -29 30 -53\n55 -55 55 -2 0 -15 -8 -31 -18z"
      }, null, 8, _hoisted_153),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M1324 13157 c-19 -17 -27 -33 -27 -56 0 -21 -4 -30 -13 -27 -7 3 -14\n-1 -17 -8 -7 -18 161 -112 176 -97 13 13 17 8 -61 55 -58 35 -63 41 -60 69 5\n54 30 57 110 14 55 -30 73 -36 79 -26 6 10 -10 24 -56 50 -89 52 -98 54 -131\n26z"
      }, null, 8, _hoisted_154),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2663 13001 c-11 -18 -6 -24 65 -68 l77 -48 -109 -5 c-97 -4 -110 -7\n-123 -26 -13 -20 -9 -24 101 -93 62 -39 118 -71 123 -71 4 0 13 8 20 18 10 16\n1 24 -70 68 l-81 49 115 3 c109 2 117 4 126 25 9 20 1 27 -100 90 -133 83\n-129 82 -144 58z"
      }, null, 8, _hoisted_155),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2492 12730 c-6 -11 -12 -25 -12 -32 0 -7 33 -45 72 -85 40 -40 68\n-73 62 -73 -5 0 -53 13 -104 30 l-95 29 -17 -22 c-10 -12 -18 -24 -18 -27 0\n-3 46 -52 103 -108 l103 -103 14 27 c14 26 13 27 -60 95 -41 37 -73 68 -70 68\n3 1 47 -13 99 -29 52 -16 95 -29 96 -27 1 1 9 13 18 26 16 24 15 26 -49 98\n-36 40 -64 73 -61 73 3 0 44 -14 92 -31 48 -16 88 -29 90 -27 1 2 7 13 14 25\n10 21 6 23 -117 64 -70 23 -132 44 -137 46 -6 2 -16 -6 -23 -17z"
      }, null, 8, _hoisted_156),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2272 12379 c-7 -12 -12 -22 -10 -24 13 -11 234 -145 239 -145 14 0\n19 38 9 64 -5 15 -10 40 -10 56 0 23 -15 40 -36 40 -2 0 -4 -16 -4 -35 0 -19\n-2 -35 -5 -35 -3 0 -41 23 -85 50 -44 28 -81 50 -82 50 -2 0 -9 -9 -16 -21z"
      }, null, 8, _hoisted_157),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15044 12929 c-23 -12 -48 -55 -39 -69 3 -5 -10 -6 -29 -3 -70 11\n-101 -66 -50 -126 33 -39 87 -45 82 -9 -2 14 -11 24 -23 26 -11 2 -26 11 -32\n20 -24 30 27 58 54 31 21 -21 43 -3 37 30 -5 24 -1 32 19 46 44 28 85 -10 58\n-54 -9 -14 6 -51 21 -51 4 0 15 14 23 31 18 35 8 84 -24 113 -23 21 -71 28\n-97 15z"
      }, null, 8, _hoisted_158),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15200 12750 c-13 -8 -9 -20 23 -80 l38 -70 -35 -17 c-20 -9 -37 -15\n-39 -12 -2 2 -18 30 -36 61 -29 52 -34 56 -51 46 -18 -12 -18 -15 16 -75 l35\n-62 -30 -15 -29 -16 -37 65 c-37 67 -41 70 -64 56 -11 -7 -4 -26 34 -95 25\n-47 50 -88 53 -90 9 -5 236 120 240 132 3 11 -89 182 -98 182 -3 0 -12 -5 -20\n-10z"
      }, null, 8, _hoisted_159),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15229 12452 c-111 -62 -116 -67 -106 -89 l10 -22 86 46 85 47 -25\n-45 c-94 -163 -91 -155 -72 -177 18 -21 18 -21 133 43 114 64 128 77 111 103\n-7 11 -24 5 -83 -27 -41 -23 -77 -41 -80 -41 -3 0 17 41 44 90 45 80 49 94 40\n115 -7 14 -15 25 -19 24 -5 -1 -60 -31 -124 -67z"
      }, null, 8, _hoisted_160),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M17165 11367 c-104 -31 -110 -36 -109 -92 0 -39 5 -52 28 -71 15 -13\n31 -24 37 -24 18 0 8 28 -16 44 -29 19 -34 66 -10 86 19 15 16 18 49 -47 26\n-53 51 -69 86 -58 32 10 43 40 30 80 -6 18 -18 39 -26 46 -9 8 -11 16 -5 23\n22 26 -5 31 -64 13z m59 -59 c20 -28 20 -52 2 -67 -20 -17 -41 -5 -59 35 -23\n47 -22 54 12 54 20 0 35 -8 45 -22z"
      }, null, 8, _hoisted_161),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M16515 11208 c-82 -23 -151 -42 -153 -43 -1 -1 26 -109 60 -239 44\n-166 67 -236 77 -236 14 0 323 80 329 85 9 7 -12 75 -23 75 -17 0 -47 120 -32\n125 7 3 43 13 80 23 37 10 68 21 68 25 -1 4 -1 15 -1 25 -1 41 -14 46 -82 29\n-36 -9 -72 -19 -81 -22 -12 -5 -19 6 -32 50 -9 31 -13 65 -10 75 10 33 -5 70\n-29 69 -11 0 -88 -19 -171 -41z m144 -111 c8 -31 13 -59 10 -62 -3 -2 -19 -7\n-35 -11 -33 -6 -28 -13 -60 98 -3 11 4 19 23 26 41 15 47 11 62 -51z m-130\n-33 c14 -60 11 -68 -31 -78 -25 -6 -28 -3 -37 31 -24 93 -24 91 1 96 53 10 54\n9 67 -49z m181 -156 c6 -24 13 -51 16 -61 6 -18 -5 -25 -45 -29 -21 -3 -26 3\n-37 47 -18 65 -17 73 4 78 43 12 51 7 62 -35z m-126 -49 c9 -34 15 -63 13 -66\n-3 -2 -20 -6 -38 -9 l-34 -6 -16 61 -16 61 31 9 c17 5 34 10 37 10 3 1 13 -27\n23 -60z"
      }, null, 8, _hoisted_162),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M17193 11142 c-59 -16 -93 -30 -93 -39 0 -17 8 -17 106 9 66 17 84\n26 84 40 0 10 -1 18 -2 17 -2 0 -45 -12 -95 -27z"
      }, null, 8, _hoisted_163),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M17020 11085 c0 -8 9 -15 20 -15 11 0 20 7 20 15 0 8 -9 15 -20 15\n-11 0 -20 -7 -20 -15z"
      }, null, 8, _hoisted_164),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M17134 11033 c-76 -21 -91 -28 -87 -43 4 -16 12 -15 111 11 59 16\n114 26 124 23 28 -9 34 -45 9 -65 -23 -19 -27 -34 -11 -44 15 -9 60 41 60 68\n0 13 -9 36 -21 51 -26 33 -60 33 -185 -1z"
      }, null, 8, _hoisted_165),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M568 11383 c-3 -11 14 -40 40 -71 25 -30 41 -57 36 -61 -5 -5 -33\n-16 -62 -26 -44 -14 -72 -37 -72 -59 0 -3 30 7 68 21 104 40 101 41 154 -28\n36 -46 49 -57 54 -45 4 9 -7 32 -27 58 -18 24 -36 48 -41 54 -5 8 12 18 51 33\n50 18 81 44 68 57 -2 2 -32 -7 -67 -21 -35 -14 -69 -25 -76 -25 -7 0 -36 29\n-64 65 -28 36 -53 65 -55 65 -2 0 -5 -8 -7 -17z"
      }, null, 8, _hoisted_166),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M1057 11243 c-3 -5 -15 -47 -27 -93 -12 -47 -25 -88 -29 -93 -4 -4\n-29 -1 -56 8 -55 16 -62 13 -71 -32 -6 -30 -5 -31 50 -47 31 -9 56 -19 56 -22\n0 -3 -11 -45 -25 -94 -14 -49 -25 -93 -25 -98 0 -14 54 -22 62 -9 3 5 16 50\n29 99 22 86 29 95 63 82 21 -8 20 -18 -10 -129 -15 -53 -25 -97 -23 -99 2 -2\n16 -6 31 -10 25 -6 28 -3 38 36 6 24 14 53 18 66 l7 23 38 -33 c36 -31 37 -35\n27 -67 -5 -19 -9 -35 -7 -36 1 -1 14 -5 29 -9 26 -6 28 -4 42 46 8 29 20 75\n27 101 11 46 13 48 40 42 25 -6 30 -3 39 20 15 40 12 55 -10 55 -31 0 -32 17\n-6 115 25 94 23 108 -19 103 -12 -2 -23 -15 -28 -35 -8 -27 -14 -32 -51 -35\n-22 -3 -43 -3 -46 -1 -2 2 3 30 12 63 l16 59 -30 6 c-16 4 -31 5 -32 3 -3 -3\n-20 -65 -46 -165 -11 -43 -28 -53 -58 -34 -11 7 -9 26 12 106 15 54 25 99 24\n101 -9 8 -57 14 -61 7z m223 -230 c1 -25 -35 -153 -42 -153 -18 0 -68 44 -68\n59 0 36 22 90 38 94 29 8 72 7 72 0z"
      }, null, 8, _hoisted_167),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M497 11117 c-4 -11 15 -20 76 -36 45 -12 90 -25 100 -28 14 -4 18 0\n15 13 -2 12 -23 23 -65 35 -106 30 -120 31 -126 16z"
      }, null, 8, _hoisted_168),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M730 11056 c0 -21 20 -30 33 -17 9 9 8 14 -3 21 -21 14 -30 12 -30\n-4z"
      }, null, 8, _hoisted_169),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M477 11043 c-15 -14 -5 -21 56 -38 92 -25 116 -55 83 -101 -14 -18\n-16 -18 -83 -1 -81 21 -93 21 -93 4 0 -13 109 -47 153 -47 37 0 60 32 55 80\n-2 29 0 40 10 40 8 0 12 5 10 12 -2 6 -42 22 -89 34 -95 27 -93 26 -102 17z"
      }, null, 8, _hoisted_170),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M1767 11099 c-4 -13 -7 -27 -7 -31 0 -4 42 -32 93 -62 l92 -56 -111\n0 -112 0 -6 -26 c-4 -15 -6 -28 -4 -29 15 -15 248 -142 252 -137 3 3 6 16 6\n28 0 18 -16 31 -81 66 l-81 43 100 3 c100 3 100 3 105 30 3 15 3 30 1 33 -2 4\n-36 26 -76 49 -40 24 -75 45 -77 46 -10 9 9 10 97 4 91 -5 93 -4 99 18 3 13 4\n25 2 26 -2 2 -67 7 -145 11 l-141 7 -6 -23z"
      }, null, 8, _hoisted_171),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M1680 10770 c-75 -75 11 -205 96 -145 19 13 22 12 32 -10 13 -27 56\n-34 92 -15 23 12 43 70 34 96 -8 23 -34 54 -45 54 -15 0 -20 -39 -8 -58 7 -11\n9 -27 6 -36 -9 -24 -51 -17 -55 9 -2 11 -11 26 -20 32 -13 11 -17 9 -26 -10\n-16 -31 -60 -34 -80 -6 -18 27 -5 59 24 59 15 0 20 7 20 25 0 20 -5 25 -25 25\n-14 0 -34 -9 -45 -20z"
      }, null, 8, _hoisted_172),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15855 10973 c-71 -19 -131 -36 -133 -38 -7 -6 19 -45 30 -45 6 0 26\n-12 45 -26 32 -24 63 -27 63 -5 0 5 -10 17 -22 25 -12 9 -19 18 -16 21 3 3 45\n16 93 30 48 13 89 25 91 27 5 6 -8 48 -15 47 -3 0 -64 -16 -136 -36z"
      }, null, 8, _hoisted_173),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M16000 10822 c0 -4 9 -38 20 -77 20 -70 17 -84 -17 -85 -6 0 -18 -3\n-26 -6 -12 -4 -19 11 -33 65 -16 63 -21 70 -39 65 -11 -4 -21 -7 -22 -8 -2 -1\n6 -32 16 -69 21 -71 21 -71 -20 -80 -25 -6 -26 -4 -44 68 -17 67 -21 74 -40\n69 -11 -4 -21 -7 -22 -8 -3 -2 48 -190 53 -195 3 -4 169 38 240 60 l32 10 -27\n99 c-23 89 -28 100 -48 100 -13 0 -23 -3 -23 -8z"
      }, null, 8, _hoisted_174),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2135 9500 c-27 -29 -33 -131 -11 -165 20 -31 65 -33 91 -5 l18 20\n19 -20 c45 -48 98 -1 98 86 0 42 -5 59 -22 76 l-22 22 -7 -28 c-6 -20 -4 -33\n7 -43 17 -18 18 -34 1 -57 -19 -26 -51 -17 -55 17 -5 38 -37 37 -45 -2 -11\n-53 -60 -47 -60 8 0 17 7 39 16 49 20 22 22 62 4 62 -8 0 -22 -9 -32 -20z"
      }, null, 8, _hoisted_175),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2100 9250 c0 -23 6 -33 25 -42 22 -10 25 -17 25 -69 0 -55 -2 -59\n-30 -74 -23 -12 -30 -22 -30 -45 l0 -29 117 55 c175 82 175 90 17 173 -64 34\n-118 61 -120 61 -2 0 -4 -14 -4 -30z m143 -132 c-53 -23 -53 -23 -53 22 l0 40\n46 -22 45 -23 -38 -17z"
      }, null, 8, _hoisted_176),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2090 8929 l0 -31 100 7 100 8 0 -62 0 -61 -100 0 -100 0 0 -30 c0\n-30 1 -30 53 -30 28 0 82 3 120 7 l67 6 0 108 0 109 -120 0 -120 0 0 -31z"
      }, null, 8, _hoisted_177),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2090 8663 c0 -23 6 -31 30 -40 24 -9 30 -17 30 -41 0 -16 3 -43 6\n-59 5 -24 2 -31 -20 -41 -21 -9 -26 -19 -26 -46 l0 -34 107 64 c59 35 111 64\n115 64 5 0 8 15 8 33 0 32 -2 33 -108 74 -59 23 -115 45 -124 49 -15 5 -18 1\n-18 -23z m188 -99 c4 -3 -74 -44 -83 -44 -3 0 -5 18 -5 40 l0 40 43 -17 c23\n-9 44 -17 45 -19z"
      }, null, 8, _hoisted_178),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2098 8383 c-33 -4 -38 -8 -38 -29 0 -22 4 -25 27 -22 26 3 28 0 34\n-42 20 -146 20 -138 -4 -142 -14 -2 -23 -11 -25 -25 -3 -18 1 -23 20 -23 39 0\n68 12 68 26 0 8 9 14 20 14 10 0 53 5 95 11 l76 12 -6 56 c-3 31 -8 73 -11 94\nl-6 37 -83 0 c-92 0 -115 5 -115 26 0 8 -3 13 -7 12 -5 -1 -25 -3 -45 -5z\nm225 -128 c3 -22 5 -40 4 -41 -3 -4 -151 -23 -154 -21 -1 1 -5 25 -8 52 l-7\n50 80 0 80 0 5 -40z"
      }, null, 8, _hoisted_179),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15628 9803 c-32 -24 -58 -51 -58 -60 0 -11 -3 -13 -12 -5 -7 5 -32\n15 -54 21 -28 7 -43 18 -47 31 -6 23 -37 17 -37 -7 0 -33 23 -53 75 -68 72\n-21 72 -41 0 -50 -52 -7 -55 -9 -55 -36 0 -26 3 -28 28 -24 15 3 76 11 136 19\n59 8 110 17 113 20 3 2 2 14 -2 26 -7 21 -11 22 -66 16 -77 -9 -78 8 -5 59 51\n35 55 40 49 69 -3 17 -6 32 -7 32 -1 1 -27 -18 -58 -43z"
      }, null, 8, _hoisted_180),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15535 9556 c-56 -25 -70 -51 -70 -127 0 -60 3 -72 26 -94 34 -34 90\n-47 151 -34 158 34 131 270 -31 269 -25 -1 -59 -7 -76 -14z m143 -69 c47 -43\n12 -122 -60 -134 -130 -20 -161 134 -33 160 31 7 68 -4 93 -26z"
      }, null, 8, _hoisted_181),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15470 9193 c0 -113 9 -153 31 -153 16 0 19 8 19 44 l0 43 120 8 120\n7 0 29 0 29 -92 -6 c-51 -3 -105 -7 -120 -9 -27 -4 -28 -3 -28 40 0 41 -2 45\n-25 45 -25 0 -25 -1 -25 -77z"
      }, null, 8, _hoisted_182),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15672 9002 c-9 -25 -6 -30 19 -45 23 -13 29 -23 29 -50 0 -52 -29\n-72 -102 -72 -51 0 -63 4 -79 24 -26 31 -24 67 5 92 16 14 22 27 18 45 -5 29\n-12 30 -44 4 -83 -65 -47 -196 60 -219 111 -23 192 32 192 131 0 50 -18 82\n-60 103 -27 14 -29 14 -38 -13z"
      }, null, 8, _hoisted_183),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15575 8731 c-74 -18 -105 -60 -105 -142 0 -42 5 -55 34 -87 34 -36\n36 -37 110 -37 72 0 77 2 108 32 27 27 32 41 35 90 2 35 -1 68 -9 82 -25 47\n-109 77 -173 62z m113 -73 c47 -39 28 -120 -32 -136 -37 -11 -97 -2 -121 18\n-39 32 -22 109 28 130 27 12 105 4 125 -12z"
      }, null, 8, _hoisted_184),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15488 8401 c-26 -21 -29 -32 -43 -147 l-6 -50 114 -12 c63 -7 126\n-12 140 -12 29 0 31 8 42 122 6 63 5 69 -19 93 -31 31 -78 33 -107 4 -18 -18\n-22 -19 -32 -5 -21 26 -60 29 -89 7z m202 -91 c0 -58 -8 -70 -44 -70 -18 0\n-35 2 -38 5 -11 11 10 99 27 111 29 22 55 0 55 -46z m-132 33 c5 -10 7 -35 5\n-55 -5 -36 -7 -38 -40 -38 l-35 0 7 48 c4 26 9 50 12 55 8 14 42 7 51 -10z"
      }, null, 8, _hoisted_185),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2580 9741 c0 -13 6 -21 18 -21 9 0 27 -3 40 -6 18 -5 22 -2 22 15 0\n13 -6 21 -17 21 -10 0 -28 3 -40 6 -19 5 -23 2 -23 -15z"
      }, null, 8, _hoisted_186),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2702 9723 c2 -13 14 -19 41 -21 33 -3 38 -1 35 15 -2 13 -14 19 -41\n21 -33 3 -38 1 -35 -15z"
      }, null, 8, _hoisted_187),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2820 9711 c0 -15 7 -21 25 -22 14 -1 31 -2 37 -3 7 -1 14 7 16 17 2\n11 -3 17 -15 17 -10 0 -28 3 -40 6 -19 5 -23 2 -23 -15z"
      }, null, 8, _hoisted_188),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2942 9693 c4 -21 55 -30 72 -13 14 14 -9 30 -47 30 -22 0 -28 -4\n-25 -17z"
      }, null, 8, _hoisted_189),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3060 9682 c0 -24 59 -40 72 -20 13 21 9 28 -16 28 -13 0 -31 3 -40\n6 -11 4 -16 0 -16 -14z"
      }, null, 8, _hoisted_190),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3180 9660 c0 -16 7 -20 34 -20 36 0 56 24 30 34 -34 13 -64 6 -64\n-14z"
      }, null, 8, _hoisted_191),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3298 9652 c-5 -16 1 -21 24 -26 45 -9 48 -8 48 14 0 13 -7 20 -19\n20 -11 0 -26 3 -34 6 -9 3 -16 -2 -19 -14z"
      }, null, 8, _hoisted_192),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3417 9636 c-8 -20 2 -26 40 -26 21 0 33 5 33 14 0 26 -64 37 -73 12z"
      }, null, 8, _hoisted_193),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3535 9622 c-7 -19 -7 -19 38 -27 33 -6 37 -5 37 13 0 15 -8 21 -35\n24 -24 3 -36 -1 -40 -10z"
      }, null, 8, _hoisted_194),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3650 9600 c0 -17 7 -20 40 -20 41 0 57 21 24 34 -34 13 -64 7 -64\n-14z"
      }, null, 8, _hoisted_195),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3678 8243 c-20 -3 -28 -10 -28 -25 0 -16 5 -19 23 -14 12 3 30 6 40\n6 10 0 17 8 17 20 0 11 -6 19 -12 19 -7 -1 -25 -4 -40 -6z"
      }, null, 8, _hoisted_196),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3543 8223 c-7 -2 -13 -11 -13 -19 0 -23 74 -15 78 9 3 13 -3 17 -25\n16 -15 0 -34 -3 -40 -6z"
      }, null, 8, _hoisted_197),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3443 8213 c-32 -4 -44 -25 -23 -38 21 -13 70 6 70 26 0 10 -3 18 -7\n17 -5 0 -23 -3 -40 -5z"
      }, null, 8, _hoisted_198),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3312 8193 c-16 -3 -22 -9 -18 -20 3 -8 6 -16 6 -17 0 -1 16 0 35 2\n26 3 35 9 35 23 0 19 -10 21 -58 12z"
      }, null, 8, _hoisted_199),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3180 8160 c0 -20 22 -26 54 -14 30 12 18 34 -19 34 -28 0 -35 -4\n-35 -20z"
      }, null, 8, _hoisted_200),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3083 8163 c-15 -3 -23 -12 -23 -25 0 -14 5 -18 16 -14 9 3 26 6 39\n6 18 0 22 4 18 20 -5 20 -9 21 -50 13z"
      }, null, 8, _hoisted_201),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2953 8144 c-7 -3 -13 -12 -13 -20 0 -11 10 -14 38 -12 25 2 37 8 37\n18 0 15 -39 24 -62 14z"
      }, null, 8, _hoisted_202),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2853 8132 c-26 -2 -33 -8 -33 -24 0 -18 4 -20 31 -14 17 3 35 6 40\n6 11 0 12 27 2 32 -5 2 -23 2 -40 0z"
      }, null, 8, _hoisted_203),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2718 8113 c-36 -9 -20 -33 22 -33 33 0 40 3 40 20 0 20 -20 24 -62\n13z"
      }, null, 8, _hoisted_204),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2580 8080 c0 -21 30 -27 64 -14 33 13 17 34 -24 34 -33 0 -40 -3\n-40 -20z"
      }, null, 8, _hoisted_205),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15150 9730 c0 -15 7 -20 28 -20 15 0 33 4 41 9 22 14 3 31 -35 31\n-27 0 -34 -4 -34 -20z"
      }, null, 8, _hoisted_206),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15058 9733 c-20 -3 -28 -10 -28 -25 0 -16 5 -19 23 -14 12 3 30 6\n40 6 10 0 17 8 17 20 0 11 -6 19 -12 19 -7 -1 -25 -4 -40 -6z"
      }, null, 8, _hoisted_207),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14923 9713 c-7 -2 -13 -11 -13 -19 0 -23 74 -15 78 9 3 13 -3 17\n-25 16 -15 0 -34 -3 -40 -6z"
      }, null, 8, _hoisted_208),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14828 9702 c-31 -3 -38 -7 -38 -24 0 -18 4 -20 36 -15 42 7 47 10\n42 29 -2 9 -16 12 -40 10z"
      }, null, 8, _hoisted_209),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14692 9683 c-21 -4 -29 -35 -9 -34 4 1 21 1 37 1 23 0 30 4 30 20 0\n20 -9 22 -58 13z"
      }, null, 8, _hoisted_210),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14557 9664 c-3 -3 -3 -12 0 -20 9 -25 73 -14 73 12 0 14 -60 21 -73\n8z"
      }, null, 8, _hoisted_211),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14459 9653 c-21 -3 -26 -8 -22 -24 4 -15 11 -19 27 -15 11 3 27 6\n34 6 6 0 12 9 12 20 0 11 -6 19 -12 19 -7 -1 -25 -4 -39 -6z"
      }, null, 8, _hoisted_212),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14333 9633 c-28 -11 -13 -33 22 -33 28 0 35 4 35 20 0 20 -26 26\n-57 13z"
      }, null, 8, _hoisted_213),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14233 9622 c-26 -3 -33 -8 -33 -24 0 -18 4 -19 38 -13 44 8 46 10\n35 27 -5 8 -21 12 -40 10z"
      }, null, 8, _hoisted_214),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14098 9603 c-10 -2 -18 -12 -18 -21 0 -14 8 -17 41 -14 31 3 39 8\n37 21 -3 16 -29 23 -60 14z"
      }, null, 8, _hoisted_215),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14080 8222 c0 -24 59 -40 72 -20 13 21 9 28 -16 28 -13 0 -31 3 -40\n6 -11 4 -16 0 -16 -14z"
      }, null, 8, _hoisted_216),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14200 8201 c0 -17 6 -21 36 -21 28 0 35 3 32 18 -2 11 -14 18 -36\n20 -27 3 -32 0 -32 -17z"
      }, null, 8, _hoisted_217),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14317 8189 c-3 -12 4 -19 25 -23 45 -9 48 -8 48 13 0 26 -67 35 -73\n10z"
      }, null, 8, _hoisted_218),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14437 8176 c-8 -20 2 -26 40 -26 21 0 33 5 33 14 0 26 -64 37 -73\n12z"
      }, null, 8, _hoisted_219),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14553 8163 c-7 -18 -5 -20 40 -28 33 -6 37 -5 37 13 0 15 -8 21 -36\n24 -24 3 -38 0 -41 -9z"
      }, null, 8, _hoisted_220),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14670 8140 c0 -17 7 -20 40 -20 45 0 57 23 18 34 -42 11 -58 7 -58\n-14z"
      }, null, 8, _hoisted_221),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14790 8126 c0 -7 10 -16 23 -20 41 -11 57 -7 57 14 0 17 -7 20 -40\n20 -27 0 -40 -4 -40 -14z"
      }, null, 8, _hoisted_222),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14910 8110 c0 -17 7 -20 40 -20 45 0 57 23 18 34 -42 11 -58 7 -58\n-14z"
      }, null, 8, _hoisted_223),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15030 8095 c0 -16 42 -30 65 -21 8 3 15 12 15 21 0 11 -11 15 -40\n15 -29 0 -40 -4 -40 -15z"
      }, null, 8, _hoisted_224),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15150 8082 c0 -15 8 -21 35 -24 24 -3 36 1 40 10 7 19 7 19 -37 27\n-34 6 -38 5 -38 -13z"
      }, null, 8, _hoisted_225),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M17415 9257 c-58 -50 -28 -148 48 -160 75 -11 127 27 127 94 0 56\n-26 81 -92 87 -47 4 -58 1 -83 -21z m130 -32 c30 -29 31 -49 5 -75 -14 -14\n-33 -20 -62 -20 -48 0 -78 22 -78 57 0 60 88 85 135 38z"
      }, null, 8, _hoisted_226),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M16700 9045 l0 -115 251 0 250 0 -3 38 -3 37 -217 3 -218 2 0 40 0\n40 138 0 c146 0 162 -5 162 -47 0 -17 6 -23 23 -23 41 0 50 14 43 64 -11 73\n-20 76 -238 76 l-188 0 0 -115z"
      }, null, 8, _hoisted_227),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M17495 9051 c-44 -3 -85 -9 -92 -14 -33 -21 -21 -127 17 -147 26 -14\n33 13 9 34 -25 21 -22 74 4 90 22 14 33 -1 42 -61 3 -23 13 -50 21 -58 18 -18\n65 -20 82 -3 15 15 16 73 1 100 -8 14 -8 23 0 31 12 12 15 38 4 35 -5 -1 -44\n-4 -88 -7z m49 -52 c31 -24 33 -65 4 -83 -25 -15 -44 8 -53 62 -8 49 6 55 49\n21z"
      }, null, 8, _hoisted_228),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M16697 8887 c-16 -11 -16 -17 3 -91 11 -44 20 -92 20 -108 l0 -28\n140 0 c109 0 142 -3 146 -14 6 -15 53 -9 60 8 2 6 -5 38 -16 70 -11 33 -17 62\n-14 65 9 9 93 -88 100 -115 7 -27 22 -30 49 -10 19 13 19 15 0 57 -26 58 -69\n105 -119 132 -34 18 -62 22 -163 25 l-123 4 0 -36 0 -36 90 0 c88 0 91 -1 100\n-26 21 -54 19 -55 -92 -52 l-102 3 -9 45 c-23 120 -32 135 -70 107z"
      }, null, 8, _hoisted_229),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M17312 8804 c3 -24 14 -30 111 -64 60 -21 111 -41 114 -43 2 -3 -48\n-22 -111 -43 -111 -37 -116 -40 -116 -66 l0 -28 140 0 c118 0 140 2 140 15 0\n12 -20 15 -117 15 -64 0 -113 3 -110 7 4 3 55 23 115 43 66 23 108 43 110 52\n2 12 -28 27 -110 56 l-113 41 113 0 c105 1 112 2 112 21 0 19 -7 20 -141 20\nl-140 0 3 -26z"
      }, null, 8, _hoisted_230),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M405 9160 c-65 -46 -74 -49 -132 -49 -56 -1 -63 -3 -63 -21 0 -18 7\n-20 62 -20 58 0 66 -3 134 -50 40 -27 75 -50 78 -50 3 0 6 8 6 18 0 11 -24 32\n-65 57 -36 22 -65 42 -65 45 1 3 30 23 65 45 40 25 65 46 65 57 0 25 -7 23\n-85 -32z"
      }, null, 8, _hoisted_231),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M1040 9085 c0 -84 0 -85 -25 -85 -24 0 -25 2 -25 70 l0 70 -195 0\n-195 0 0 -35 c0 -19 5 -35 10 -35 6 0 10 -67 10 -180 0 -113 -4 -180 -10 -180\n-5 0 -10 -16 -10 -35 l0 -35 195 0 195 0 0 86 c0 83 1 85 23 82 21 -3 22 -8\n25 -101 l3 -98 27 3 27 3 3 278 2 277 -30 0 -30 0 0 -85z m-320 -195 c0 -173\n-1 -180 -20 -180 -19 0 -20 7 -20 180 0 173 1 180 20 180 19 0 20 -7 20 -180z\nm210 145 c0 -34 -1 -34 -27 -24 -16 6 -38 20 -51 32 l-22 21 -22 -22 -22 -22\n29 -30 c15 -16 48 -37 72 -46 34 -13 43 -22 43 -40 0 -21 -5 -24 -34 -24 -19\n0 -46 -4 -60 -10 -23 -9 -26 -15 -26 -63 0 -63 11 -77 63 -77 34 0 38 2 35 23\n-2 14 -11 23 -26 25 -33 5 -21 26 16 30 l32 3 0 -51 0 -51 -77 3 -78 3 -3 165\nc-1 90 0 170 2 177 4 9 28 13 81 13 l75 0 0 -35z m108 -132 c3 -19 -1 -23 -22\n-23 -21 0 -26 5 -26 26 0 21 4 25 23 22 14 -2 23 -11 25 -25z"
      }, null, 8, _hoisted_232),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M274 8979 c-36 -10 -61 -36 -64 -64 -5 -45 1 -67 25 -90 35 -36 115\n-36 151 0 35 35 31 109 -6 136 -33 23 -68 29 -106 18z m96 -49 c32 -32 25 -66\n-17 -89 -33 -17 -81 -13 -103 9 -43 43 -9 100 60 100 27 0 47 -7 60 -20z"
      }, null, 8, _hoisted_233),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M221 8736 c-16 -19 -17 -66 -2 -94 8 -14 8 -22 1 -22 -5 0 -10 -7\n-10 -15 0 -12 18 -15 100 -15 82 0 100 3 100 15 0 12 -13 15 -59 15 -76 0\n-109 13 -117 45 -11 44 9 55 97 55 64 0 79 3 79 15 0 21 -172 22 -189 1z"
      }, null, 8, _hoisted_234),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M1650 9255 c-30 -7 -90 -20 -133 -30 -78 -17 -78 -17 -75 -47 3 -27\n8 -33 48 -44 25 -7 72 -20 105 -30 l60 -17 -105 -27 c-103 -25 -105 -27 -108\n-56 l-3 -31 128 -33 c70 -18 134 -35 141 -38 8 -3 12 6 12 25 0 29 -2 30 -82\n48 -46 10 -89 21 -96 25 -7 3 22 14 65 24 119 27 113 24 113 61 0 33 -2 35\n-57 50 -96 27 -125 37 -120 41 2 2 44 12 93 22 84 17 89 19 92 45 4 31 1 31\n-78 12z"
      }, null, 8, _hoisted_235),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M1440 8841 c0 -26 -3 -69 -6 -95 -7 -45 -6 -46 20 -46 25 0 26 3 26\n50 0 28 3 50 7 50 3 0 30 -22 59 -50 45 -43 59 -50 93 -50 66 0 101 66 70 133\n-10 21 -56 53 -64 45 -14 -15 -6 -49 15 -66 20 -17 23 -24 14 -39 -23 -37 -53\n-28 -118 36 -33 33 -73 65 -88 70 l-28 11 0 -49z"
      }, null, 8, _hoisted_236),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M16040 9120 c-38 -38 -38 -102 1 -141 25 -25 53 -21 57 8 2 14 -3 23\n-17 28 -26 8 -29 60 -5 69 27 10 32 8 105 -59 39 -36 74 -65 79 -65 5 0 15 -3\n24 -6 14 -5 16 6 16 90 0 96 0 96 -25 96 -23 0 -25 -3 -25 -50 0 -27 -4 -50\n-8 -50 -4 0 -24 16 -43 36 -62 65 -122 81 -159 44z"
      }, null, 8, _hoisted_237),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M16250 8841 l0 -81 -40 0 -40 0 0 70 c0 63 -2 70 -20 70 -18 0 -20\n-7 -20 -70 l0 -70 -35 0 -35 0 0 75 c0 73 -1 75 -25 75 l-25 0 0 -105 0 -105\n145 0 146 0 -3 108 c-3 102 -4 107 -25 110 -22 3 -23 1 -23 -77z"
      }, null, 8, _hoisted_238),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M1745 7348 c-66 -33 -122 -62 -123 -63 -2 -2 -1 -17 3 -34 l6 -30\n111 -3 110 -3 -78 -42 c-114 -61 -117 -63 -105 -96 l11 -27 140 0 141 0 -3 28\n-3 27 -99 -2 c-60 -2 -96 1 -90 6 5 5 44 28 86 51 73 39 78 43 72 68 -4 15 -9\n30 -11 35 -2 4 -48 7 -101 8 l-97 0 88 45 c66 34 87 49 83 60 -3 9 -6 20 -6\n25 0 15 -9 11 -135 -53z"
      }, null, 8, _hoisted_239),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M1877 6993 c-17 -4 -16 -8 9 -34 30 -31 31 -30 -46 -49 -107 -27\n-120 -31 -120 -43 1 -36 15 -36 145 -3 114 28 130 35 133 54 2 15 -2 22 -12\n22 -8 0 -31 14 -49 30 -19 17 -36 29 -38 29 -2 -1 -12 -3 -22 -6z"
      }, null, 8, _hoisted_240),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15830 7232 c-32 -26 -38 -90 -11 -122 20 -24 22 -24 35 -6 13 16 13\n21 -1 43 -15 22 -15 26 1 41 19 20 49 7 55 -24 3 -18 18 -34 32 -34 4 0 9 9\n12 20 7 27 33 35 63 21 34 -15 31 -64 -3 -69 -21 -3 -25 -12 -23 -49 1 -5 11\n-7 23 -5 68 10 97 112 44 158 -32 27 -73 31 -97 9 -16 -14 -19 -13 -34 10 -20\n30 -63 34 -96 7z"
      }, null, 8, _hoisted_241),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15767 7043 c-9 -18 -50 -184 -46 -188 7 -7 262 -75 266 -71 2 2 16\n47 30 101 22 82 24 98 12 106 -23 15 -28 11 -39 -33 -29 -114 -33 -118 -84\n-98 l-25 9 20 68 c10 37 19 69 19 70 0 2 -11 3 -24 3 -20 0 -25 -8 -41 -66\n-17 -63 -19 -65 -44 -59 -14 4 -28 9 -30 11 -3 3 3 33 12 68 9 36 17 69 17 75\n0 12 -37 15 -43 4z"
      }, null, 8, _hoisted_242),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M493 7111 c-72 -33 -95 -123 -52 -200 29 -53 47 -62 100 -49 24 6 45\n12 47 13 3 3 -13 71 -23 102 -2 7 -11 10 -18 7 -12 -4 -13 -12 -4 -40 12 -38\n1 -54 -36 -54 -25 0 -57 58 -57 103 0 47 31 81 88 97 48 12 103 -5 121 -38 16\n-30 13 -93 -5 -113 -21 -23 -10 -43 16 -29 41 22 42 115 2 169 -39 54 -105 65\n-179 32z"
      }, null, 8, _hoisted_243),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M1145 7068 c-74 -19 -143 -30 -210 -33 -97 -5 -100 -6 -109 -31 -4\n-14 -5 -28 -1 -32 4 -4 57 -7 118 -6 87 0 134 6 212 27 55 14 100 25 101 24 1\n-1 20 -74 43 -162 70 -264 70 -265 91 -265 31 0 32 16 6 114 -31 110 -31 116\n-10 116 13 0 15 7 10 31 -3 17 -6 36 -6 41 0 5 -10 8 -22 6 -19 -3 -24 4 -36\n47 -41 149 -43 155 -60 154 -9 -1 -66 -14 -127 -31z"
      }, null, 8, _hoisted_244),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M1098 6963 c-15 -4 -15 -9 3 -73 23 -85 23 -80 0 -80 -14 0 -22 14\n-35 60 -16 55 -19 60 -39 54 -30 -9 -29 -6 -16 -58 6 -26 10 -49 7 -51 -8 -9\n-70 43 -100 84 -25 34 -33 39 -48 31 -10 -6 -22 -15 -25 -20 -16 -26 90 -143\n140 -156 31 -8 31 -11 1 -65 -25 -45 -50 -158 -37 -171 4 -4 21 -11 39 -14\nl32 -6 0 44 c0 48 27 141 39 133 4 -2 13 -29 20 -60 10 -44 16 -55 29 -51 63\n19 73 19 78 -1 8 -30 54 -19 54 13 0 19 8 25 38 34 l39 10 -20 76 c-16 57 -18\n77 -9 83 19 11 4 71 -18 71 -12 0 -20 15 -30 55 -15 63 -18 66 -47 59 -20 -6\n-20 -8 -7 -57 17 -65 17 -77 0 -77 -8 0 -20 26 -32 70 -10 39 -23 69 -28 69\n-6 -1 -19 -3 -28 -6z m136 -234 c9 -47 7 -59 -8 -59 -12 0 -26 40 -26 76 0 28\n28 13 34 -17z m-85 -20 c15 -45 14 -59 -7 -59 -21 0 -47 76 -28 84 21 8 24 6\n35 -25z"
      }, null, 8, _hoisted_245),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M544 6811 c-53 -24 -70 -62 -52 -116 10 -28 22 -42 46 -52 30 -12 32\n-12 32 7 0 11 -6 20 -13 20 -20 0 -47 33 -47 57 0 20 29 53 47 53 5 0 18 -30\n28 -67 10 -38 19 -69 21 -71 6 -8 64 30 74 47 17 33 12 78 -12 105 -32 34 -74\n40 -124 17z m112 -46 c18 -28 11 -60 -16 -75 -17 -9 -20 -5 -30 32 -6 24 -13\n49 -15 56 -8 23 44 13 61 -13z"
      }, null, 8, _hoisted_246),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M608 6597 c-47 -12 -78 -26 -78 -34 0 -17 22 -16 90 2 48 13 57 13\n77 -1 25 -16 31 -55 11 -71 -7 -6 -43 -18 -80 -28 -65 -17 -79 -27 -58 -40 12\n-8 129 22 158 41 30 20 30 76 0 106 -14 14 -18 23 -10 26 17 5 4 22 -16 21 -9\n0 -52 -10 -94 -22z"
      }, null, 8, _hoisted_247),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M670 6399 c-67 -27 -88 -83 -49 -133 l20 -26 -34 0 c-19 0 -40 7 -47\n15 -15 18 -16 65 -2 74 7 4 8 12 2 21 -15 25 -40 -7 -40 -52 0 -31 7 -46 30\n-69 26 -26 34 -29 66 -23 80 15 198 51 202 62 2 7 -3 12 -11 12 -10 0 -13 8\n-9 25 7 40 -6 74 -38 90 -33 17 -54 18 -90 4z m98 -47 c18 -23 15 -40 -13 -67\n-27 -27 -91 -35 -113 -13 -17 17 -15 63 2 77 38 32 100 33 124 3z"
      }, null, 8, _hoisted_248),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M16494 7062 c-13 -8 -117 -389 -109 -401 2 -5 16 -11 30 -13 28 -6\n22 -18 71 167 15 58 30 105 34 105 4 0 20 -32 35 -70 31 -77 114 -222 147\n-257 30 -32 78 -46 112 -33 36 13 66 81 106 233 32 128 38 198 16 216 -13 11\n-101 41 -122 41 -10 0 -34 -41 -34 -59 0 -4 17 -13 39 -19 62 -19 65 -28 40\n-134 -12 -51 -30 -117 -41 -146 -16 -44 -24 -53 -41 -50 -31 5 -96 108 -174\n279 -66 145 -79 161 -109 141z"
      }, null, 8, _hoisted_249),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M17060 6856 c0 -21 21 -31 31 -15 5 8 3 17 -4 21 -18 12 -27 10 -27\n-6z"
      }, null, 8, _hoisted_250),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M17135 6840 c-11 -18 3 -25 95 -49 100 -25 100 -25 100 -7 0 9 -29\n22 -82 36 -44 12 -87 24 -94 27 -6 2 -15 -1 -19 -7z"
      }, null, 8, _hoisted_251),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M17044 6796 c-5 -13 8 -33 47 -72 29 -29 51 -55 48 -57 -2 -3 -35\n-14 -72 -27 -60 -19 -89 -41 -75 -55 3 -3 44 8 91 24 85 29 89 29 137 15 28\n-8 55 -12 60 -9 22 13 7 26 -49 41 -50 14 -64 24 -101 70 -23 29 -50 60 -61\n70 -18 16 -19 16 -25 0z"
      }, null, 8, _hoisted_252),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4717 5724 c-46 -39 -14 -62 32 -23 21 17 22 22 10 34 -12 12 -18 10\n-42 -11z"
      }, null, 8, _hoisted_253),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4616 5647 c-24 -20 -26 -24 -13 -35 12 -11 20 -9 43 11 16 14 24 29\n20 35 -10 17 -17 15 -50 -11z"
      }, null, 8, _hoisted_254),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4525 5575 c-23 -18 -27 -26 -19 -35 13 -13 41 -2 62 23 10 11 9 17\n-1 25 -10 8 -20 5 -42 -13z"
      }, null, 8, _hoisted_255),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4435 5506 c-20 -16 -26 -28 -22 -40 6 -16 9 -16 37 4 32 23 34 28\n22 47 -6 9 -15 6 -37 -11z"
      }, null, 8, _hoisted_256),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4336 5428 c-18 -16 -23 -27 -17 -37 7 -11 14 -10 40 8 18 13 28 27\n24 36 -7 20 -18 19 -47 -7z"
      }, null, 8, _hoisted_257),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4238 5356 c-23 -20 -25 -26 -13 -36 11 -9 20 -8 39 7 25 18 31 43\n11 49 -5 2 -22 -7 -37 -20z"
      }, null, 8, _hoisted_258),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4146 5284 c-25 -22 -27 -27 -15 -39 12 -12 18 -10 43 11 25 22 27\n27 15 39 -12 12 -18 10 -43 -11z"
      }, null, 8, _hoisted_259),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4046 5207 c-24 -20 -26 -24 -13 -35 12 -11 20 -9 43 11 16 14 24 29\n20 35 -10 17 -17 15 -50 -11z"
      }, null, 8, _hoisted_260),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3955 5135 c-23 -18 -27 -26 -19 -35 13 -13 41 -2 62 23 10 11 9 17\n-1 25 -10 8 -20 5 -42 -13z"
      }, null, 8, _hoisted_261),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3865 5066 c-20 -16 -26 -28 -22 -40 6 -16 9 -16 37 4 32 23 34 28\n22 47 -6 9 -15 6 -37 -11z"
      }, null, 8, _hoisted_262),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5683 4749 c-27 -32 -28 -35 -7 -43 16 -6 53 28 54 50 0 24 -26 20\n-47 -7z"
      }, null, 8, _hoisted_263),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5611 4654 c-17 -22 -19 -30 -9 -41 10 -13 16 -11 35 13 13 16 22 33\n20 38 -7 20 -26 16 -46 -10z"
      }, null, 8, _hoisted_264),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5540 4560 c-16 -23 -19 -35 -12 -42 8 -8 16 -7 27 2 28 23 36 47 21\n59 -11 9 -19 5 -36 -19z"
      }, null, 8, _hoisted_265),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5462 4461 c-18 -25 -19 -31 -7 -41 12 -10 19 -8 35 11 20 25 23 50\n5 56 -6 2 -21 -10 -33 -26z"
      }, null, 8, _hoisted_266),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5393 4368 c-12 -17 -20 -35 -17 -40 10 -16 32 -8 49 18 14 22 15 28\n3 40 -11 11 -17 8 -35 -18z"
      }, null, 8, _hoisted_267),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5320 4273 c-16 -21 -18 -29 -8 -40 10 -13 16 -11 35 13 27 34 28 40\n8 47 -8 4 -23 -5 -35 -20z"
      }, null, 8, _hoisted_268),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5245 4174 c-13 -20 -14 -29 -5 -38 9 -8 17 -4 36 17 13 16 22 33 19\n38 -11 17 -32 9 -50 -17z"
      }, null, 8, _hoisted_269),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5172 4081 c-18 -25 -19 -31 -7 -41 12 -10 19 -8 35 11 20 25 23 50\n5 56 -6 2 -21 -10 -33 -26z"
      }, null, 8, _hoisted_270),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5101 3984 c-21 -27 -20 -44 3 -44 17 0 49 47 41 60 -10 16 -22 12\n-44 -16z"
      }, null, 8, _hoisted_271),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5031 3894 c-12 -15 -20 -32 -18 -38 7 -21 26 -16 46 12 17 25 19 32\n7 41 -11 9 -18 6 -35 -15z"
      }, null, 8, _hoisted_272),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13041 5726 c-14 -17 31 -61 53 -53 23 9 20 21 -13 45 -23 17 -31 19\n-40 8z"
      }, null, 8, _hoisted_273),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13134 5648 c-4 -6 5 -21 21 -34 23 -18 32 -21 43 -11 12 9 10 15\n-12 34 -30 26 -42 28 -52 11z"
      }, null, 8, _hoisted_274),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13231 5577 c-14 -18 45 -65 62 -48 7 7 6 15 -3 26 -23 27 -47 36\n-59 22z"
      }, null, 8, _hoisted_275),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13326 5504 c-6 -16 28 -53 50 -54 25 0 21 28 -6 49 -35 25 -36 25\n-44 5z"
      }, null, 8, _hoisted_276),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13423 5434 c-8 -22 47 -70 59 -51 12 18 10 22 -22 46 -28 20 -31 20\n-37 5z"
      }, null, 8, _hoisted_277),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13514 5358 c-4 -6 5 -21 21 -34 23 -18 32 -21 43 -11 12 9 10 15\n-12 34 -30 26 -42 28 -52 11z"
      }, null, 8, _hoisted_278),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13611 5287 c-15 -18 45 -65 62 -48 8 8 4 18 -13 36 -27 29 -33 30\n-49 12z"
      }, null, 8, _hoisted_279),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13710 5215 c-10 -12 -8 -19 11 -35 25 -20 50 -23 56 -5 2 6 -10 21\n-26 33 -25 18 -31 19 -41 7z"
      }, null, 8, _hoisted_280),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13804 5138 c-8 -13 45 -60 58 -52 15 9 8 33 -14 48 -27 19 -35 20\n-44 4z"
      }, null, 8, _hoisted_281),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13897 5065 c-4 -9 6 -23 24 -36 26 -18 33 -19 40 -8 6 10 1 21 -17\n37 -29 26 -40 27 -47 7z"
      }, null, 8, _hoisted_282),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12077 4763 c-12 -11 -7 -27 13 -52 16 -19 23 -21 35 -11 12 10 11\n16 -7 41 -22 30 -30 34 -41 22z"
      }, null, 8, _hoisted_283),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12151 4666 c-10 -12 -9 -20 6 -40 18 -25 43 -31 49 -11 2 6 -7 23\n-20 38 -20 24 -24 26 -35 13z"
      }, null, 8, _hoisted_284),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12221 4571 c-11 -7 -9 -15 9 -39 22 -29 50 -34 50 -8 0 21 -44 56\n-59 47z"
      }, null, 8, _hoisted_285),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12287 4472 c-3 -4 5 -20 18 -36 17 -22 27 -26 39 -19 15 8 15 12 -4\n36 -21 26 -44 35 -53 19z"
      }, null, 8, _hoisted_286),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12367 4383 c-11 -10 -8 -19 14 -47 17 -21 24 -24 35 -15 12 9 10 16\n-7 40 -21 29 -30 34 -42 22z"
      }, null, 8, _hoisted_287),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12441 4286 c-17 -20 32 -77 50 -59 9 9 6 18 -10 42 -26 36 -25 35\n-40 17z"
      }, null, 8, _hoisted_288),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12517 4193 c-12 -11 -7 -27 13 -52 16 -19 23 -21 35 -11 12 10 11\n16 -7 41 -22 30 -30 34 -41 22z"
      }, null, 8, _hoisted_289),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12591 4096 c-10 -12 -9 -20 6 -40 18 -25 43 -31 49 -11 2 6 -7 23\n-20 38 -20 24 -24 26 -35 13z"
      }, null, 8, _hoisted_290),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12661 4001 c-11 -7 -9 -14 9 -39 21 -29 50 -34 50 -8 -1 10 -34 56\n-42 56 -1 0 -9 -4 -17 -9z"
      }, null, 8, _hoisted_291),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12727 3902 c-3 -4 5 -20 18 -36 17 -22 27 -26 39 -19 15 8 15 12 -4\n36 -21 26 -44 35 -53 19z"
      }, null, 8, _hoisted_292),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3450 5039 c-47 -33 -86 -63 -88 -67 -1 -4 4 -16 12 -27 13 -19 15\n-18 51 9 33 25 39 27 52 13 13 -13 13 -18 -1 -45 -22 -42 -20 -90 4 -130 22\n-35 74 -72 103 -72 34 0 86 32 107 65 35 57 21 117 -42 170 -28 23 -39 27 -80\n23 -34 -4 -51 -1 -60 9 -10 12 -5 21 27 48 34 28 38 35 26 49 -7 9 -16 16 -20\n16 -3 0 -44 -27 -91 -61z m190 -129 c37 -37 25 -89 -26 -121 -43 -26 -78 -19\n-99 21 -22 42 -19 58 16 91 37 34 80 38 109 9z"
      }, null, 8, _hoisted_293),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3719 4731 c-31 -26 -70 -58 -87 -72 -30 -23 -30 -24 -13 -46 l18\n-22 73 60 c40 32 76 59 80 59 4 0 24 -20 45 -45 35 -43 54 -52 62 -29 3 10\n-104 144 -115 144 -4 -1 -32 -22 -63 -49z"
      }, null, 8, _hoisted_294),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3843 4560 c-35 -21 -63 -66 -63 -102 0 -35 41 -100 79 -125 52 -35\n103 -31 149 11 33 31 37 39 37 84 0 57 -21 93 -75 130 -41 27 -85 28 -127 2z\nm131 -56 c35 -36 34 -77 -3 -115 -40 -40 -81 -39 -115 2 -34 40 -33 74 3 110\n38 37 79 38 115 3z"
      }, null, 8, _hoisted_295),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4011 4286 c-10 -12 -6 -22 23 -53 33 -36 36 -37 52 -21 17 17 17 19\n-16 53 -38 39 -43 41 -59 21z"
      }, null, 8, _hoisted_296),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4185 4270 c-9 -15 17 -48 35 -43 21 6 61 -42 53 -63 -6 -16 -36 -18\n-64 -4 -27 15 -35 -11 -14 -44 14 -21 15 -29 5 -41 -7 -8 -17 -15 -22 -15 -19\n0 -68 58 -62 73 3 9 -3 20 -15 26 -28 16 -31 14 -31 -16 0 -57 72 -133 127\n-133 34 0 55 28 51 67 -4 30 -2 33 24 33 18 0 33 8 44 25 15 23 15 27 -3 62\n-30 58 -109 104 -128 73z"
      }, null, 8, _hoisted_297),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4330 4012 c-58 -25 -107 -47 -109 -49 -3 -2 4 -13 16 -24 17 -17 24\n-19 41 -10 30 16 34 15 80 -24 36 -31 40 -39 35 -68 -4 -24 0 -37 16 -51 24\n-22 19 -33 60 124 28 106 29 115 14 132 -22 25 -33 23 -153 -30z m105 -29 c-3\n-10 -9 -30 -12 -45 -7 -34 -13 -35 -43 -3 -26 28 -27 26 15 48 39 21 49 21 40\n0z"
      }, null, 8, _hoisted_298),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4531 3840 c-61 -75 -71 -93 -61 -105 21 -25 34 -18 93 55 31 39 60\n70 65 70 4 -1 24 -16 45 -34 l37 -33 -56 -73 c-45 -57 -55 -76 -47 -89 6 -9\n16 -17 24 -18 15 -3 143 162 137 176 -3 7 -97 89 -149 128 -13 11 -26 -1 -88\n-77z"
      }, null, 8, _hoisted_299),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4773 3642 c-57 -31 -103 -58 -103 -61 0 -4 9 -12 19 -18 14 -9 26\n-9 49 -1 27 10 34 8 71 -21 33 -26 41 -39 41 -64 0 -22 7 -36 21 -45 12 -7 22\n-12 24 -10 1 2 10 56 20 121 17 113 17 119 0 137 -10 11 -23 20 -29 19 -6 -1\n-57 -26 -113 -57z m101 -39 c-9 -52 -15 -56 -48 -29 l-29 22 34 21 c47 29 51\n28 43 -14z"
      }, null, 8, _hoisted_300),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5035 3500 c-47 -61 -78 -86 -94 -75 -10 5 -51 -46 -51 -63 0 -18 33\n-24 42 -7 13 23 23 19 98 -32 63 -44 67 -48 57 -71 -9 -18 -8 -25 4 -33 8 -5\n16 -9 19 -9 11 0 42 69 35 80 -4 6 14 44 39 84 25 41 46 78 46 83 0 9 -132\n103 -144 103 -3 0 -26 -27 -51 -60z m109 -23 l28 -23 -37 -59 c-21 -33 -39\n-62 -41 -64 -2 -2 -23 9 -48 25 l-44 28 52 58 c28 31 53 58 56 58 3 0 18 -10\n34 -23z"
      }, null, 8, _hoisted_301),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14416 5344 c-12 -30 -6 -60 19 -96 43 -63 30 -74 -36 -32 -32 20\n-43 23 -55 13 -8 -6 -14 -17 -14 -23 0 -6 52 -43 114 -83 l115 -71 15 23 c15\n23 14 24 -35 54 -66 41 -57 55 32 48 69 -6 69 -6 85 24 l15 30 -86 -2 -87 -2\n-25 42 c-14 24 -22 49 -19 58 4 9 1 20 -6 25 -19 11 -25 10 -32 -8z"
      }, null, 8, _hoisted_302),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14240 5071 c-75 -78 -56 -172 45 -221 53 -25 97 -22 139 11 112 88\n47 249 -100 249 -42 0 -51 -4 -84 -39z m123 -22 c68 -35 87 -92 45 -136 -58\n-62 -187 15 -158 94 19 50 64 67 113 42z"
      }, null, 8, _hoisted_303),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14099 4878 c-18 -24 -48 -62 -67 -85 -32 -41 -33 -42 -13 -53 18 -9\n25 -6 48 19 l28 30 90 -68 91 -68 17 23 c17 23 16 23 -68 84 -46 33 -87 65\n-90 71 -4 5 4 23 16 40 18 26 19 33 8 40 -22 14 -25 12 -60 -33z"
      }, null, 8, _hoisted_304),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13955 4684 c-95 -48 -96 -167 -2 -235 72 -52 165 -31 201 46 12 25\n16 48 12 71 -8 39 -19 49 -43 35 -13 -7 -18 -22 -18 -57 0 -41 -4 -50 -26 -63\n-15 -8 -36 -12 -52 -7 -36 9 -97 71 -97 99 0 38 27 67 64 67 25 0 35 6 44 24\n9 20 8 25 -4 30 -25 9 -47 7 -79 -10z"
      }, null, 8, _hoisted_305),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13754 4461 c-11 -5 -35 -26 -53 -47 -30 -34 -33 -42 -29 -85 11\n-114 135 -185 226 -129 92 56 95 168 7 236 -38 29 -113 41 -151 25z m107 -65\nc67 -46 74 -113 15 -151 -36 -24 -78 -11 -120 36 -39 42 -43 58 -24 92 27 52\n74 60 129 23z"
      }, null, 8, _hoisted_306),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13490 4200 l-65 -59 100 -101 c55 -55 104 -100 109 -100 6 0 38 29\n73 64 70 73 79 103 42 151 -18 22 -28 26 -55 23 -30 -4 -34 -1 -34 19 0 34\n-34 63 -72 63 -26 -1 -47 -14 -98 -60z m119 -4 c15 -18 5 -40 -33 -75 l-27\n-25 -25 25 -25 26 36 31 c39 35 57 39 74 18z m99 -96 c2 -18 -7 -35 -33 -60\nl-35 -34 -27 27 -27 27 34 35 c42 43 83 46 88 5z"
      }, null, 8, _hoisted_307),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13475 3968 c-35 -31 -36 -36 -24 -56 8 -12 16 -22 19 -22 3 0 23 17\n43 38 37 38 37 39 18 56 -19 17 -21 16 -56 -16z"
      }, null, 8, _hoisted_308),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13234 3956 c-105 -46 -122 -161 -35 -239 46 -41 88 -53 135 -37 39\n13 93 68 102 105 14 58 -32 135 -100 166 -49 22 -61 23 -102 5z m121 -91 c48\n-62 21 -135 -49 -135 -66 0 -124 74 -104 133 23 64 106 65 153 2z"
      }, null, 8, _hoisted_309),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13022 3786 c-96 -78 -95 -63 -13 -170 91 -119 94 -122 121 -103 20\n14 19 16 -50 102 -38 48 -70 91 -70 95 0 4 22 25 50 46 47 36 49 39 33 56 -9\n10 -17 18 -17 17 -1 0 -25 -20 -54 -43z"
      }, null, 8, _hoisted_310),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12814 3626 c-17 -7 -41 -27 -53 -42 -20 -25 -22 -37 -18 -91 5 -52\n3 -62 -11 -68 -11 -4 -22 1 -32 17 -8 12 -24 33 -35 45 -18 20 -22 21 -38 9\n-17 -13 -13 -21 59 -130 76 -114 77 -115 100 -99 l24 15 -30 43 c-17 24 -30\n48 -30 53 0 18 31 22 54 7 65 -43 123 -36 179 20 37 37 37 95 1 150 -47 73\n-109 99 -170 71z m76 -51 c34 -17 70 -73 70 -107 0 -26 -21 -50 -53 -61 -26\n-10 -75 19 -97 56 -28 45 -26 81 6 106 32 25 37 25 74 6z"
      }, null, 8, _hoisted_311),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2375 5700 c-15 -17 -17 -30 -11 -100 7 -70 5 -81 -10 -87 -40 -15\n-78 47 -55 91 11 20 11 28 -2 46 l-15 21 -21 -27 c-25 -32 -27 -74 -5 -119 20\n-43 43 -63 82 -71 26 -5 36 -1 63 25 33 34 34 45 13 148 -5 25 -3 34 10 39 34\n13 77 -62 46 -81 -12 -8 10 -57 24 -52 6 2 17 15 25 28 33 59 -25 159 -91 159\n-22 0 -42 -7 -53 -20z"
      }, null, 8, _hoisted_312),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2469 5439 c-57 -51 -105 -97 -107 -103 -1 -6 4 -20 12 -31 14 -19\n15 -19 92 -1 139 32 137 34 51 -46 -76 -72 -78 -75 -66 -102 10 -21 18 -26 33\n-22 12 3 76 20 143 37 120 31 121 32 111 55 -6 13 -14 24 -18 24 -3 0 -46 -12\n-94 -26 -49 -14 -90 -24 -91 -22 -2 2 30 32 70 68 l73 64 -15 29 c-16 32 -22\n32 -145 3 -32 -8 -58 -10 -58 -5 0 5 3 9 8 9 4 0 35 26 69 58 59 53 62 58 50\n80 -13 23 -15 22 -118 -69z"
      }, null, 8, _hoisted_313),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2706 5151 c-10 -16 5 -40 26 -43 12 -2 26 -11 32 -21 9 -15 7 -21\n-8 -33 -25 -18 -31 -18 -50 1 -24 25 -45 9 -39 -30 5 -29 2 -36 -19 -46 -46\n-20 -90 25 -57 58 8 8 7 17 -3 32 -14 20 -16 20 -30 4 -25 -29 -29 -52 -14\n-87 28 -66 97 -86 141 -41 14 13 25 33 25 43 0 15 6 18 30 14 70 -10 96 74 41\n129 -29 28 -64 38 -75 20z"
      }, null, 8, _hoisted_314),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15211 5592 c-6 -11 -6 -24 0 -33 5 -7 9 -30 9 -50 0 -35 23 -69 37\n-56 3 4 6 20 5 37 0 16 2 30 6 30 4 0 43 -23 87 -50 72 -44 81 -48 93 -33 6 9\n12 20 12 24 0 6 -174 115 -232 146 -4 2 -11 -5 -17 -15z"
      }, null, 8, _hoisted_315),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15098 5412 c-15 -26 -39 -66 -53 -88 l-25 -42 121 -72 c67 -40 124\n-68 128 -64 15 17 101 165 101 173 0 7 -23 21 -35 21 -2 0 -17 -24 -34 -52\n-51 -87 -45 -83 -80 -62 -17 10 -31 22 -31 26 0 4 14 30 31 58 30 49 33 80 7\n80 -7 0 -28 -25 -46 -55 -35 -57 -45 -63 -75 -41 -17 13 -16 18 22 80 38 62\n39 66 21 76 -25 13 -22 16 -52 -38z"
      }, null, 8, _hoisted_316),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14966 5179 c-58 -45 -72 -114 -31 -154 35 -36 66 -31 126 20 59 50\n73 54 89 25 8 -15 7 -27 -5 -50 -15 -28 -28 -35 -66 -32 -9 1 -21 -10 -27 -23\n-10 -22 -9 -25 13 -31 56 -14 116 28 136 96 14 46 -1 84 -41 105 -39 20 -62\n13 -121 -36 -53 -45 -79 -50 -79 -16 0 27 28 57 53 57 18 0 49 39 41 52 -10\n15 -61 8 -88 -13z"
      }, null, 8, _hoisted_317),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M1845 5119 c-77 -44 -144 -84 -148 -88 -10 -10 24 -71 40 -71 13 0\n74 -100 67 -111 -2 -4 -29 -21 -59 -38 l-55 -31 15 -30 c8 -16 19 -31 23 -34\n5 -3 34 10 65 29 l57 34 23 -37 c36 -56 45 -76 40 -88 -2 -7 4 -26 14 -42 l19\n-31 144 84 c80 47 149 86 155 88 5 2 -15 46 -44 97 -52 92 -53 94 -34 110 19\n15 19 18 4 48 -10 22 -21 32 -31 29 -8 -3 -21 -6 -27 -8 -7 -2 -34 33 -61 80\n-27 47 -53 86 -58 88 -5 2 -72 -33 -149 -78z m168 -68 c34 -61 34 -67 -1 -85\nl-28 -15 -32 59 -33 59 28 15 c15 8 30 15 33 16 3 0 17 -22 33 -49z m-110 -76\nl29 -49 -22 -18 c-34 -28 -46 -22 -79 35 l-30 52 22 17 c32 26 47 19 80 -37z\nm220 -114 c34 -61 34 -67 0 -85 -27 -14 -28 -13 -60 41 -18 30 -33 58 -33 62\n0 8 38 29 55 30 6 1 22 -21 38 -48z m-105 -143 c-13 -9 -28 -18 -35 -18 -11 0\n-79 108 -72 114 2 2 17 10 34 19 l29 15 34 -56 34 -56 -24 -18z"
      }, null, 8, _hoisted_318),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M1335 5005 c-29 -28 -30 -44 -10 -111 19 -62 19 -69 -1 -88 -22 -22\n-31 -20 -65 13 -30 31 -40 86 -19 107 6 6 8 18 4 28 -6 16 -8 16 -25 0 -45\n-41 -22 -147 40 -178 40 -21 53 -20 85 5 30 23 32 44 14 132 -11 54 -11 60 6\n73 25 18 52 3 73 -41 15 -31 15 -36 0 -58 -14 -22 -14 -27 -2 -37 11 -9 17 -5\n30 21 22 42 7 97 -36 133 -38 32 -63 33 -94 1z"
      }, null, 8, _hoisted_319),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M1420 4769 c-118 -68 -125 -73 -116 -88 5 -7 31 2 76 27 54 29 73 35\n86 26 30 -18 40 -42 28 -61 -10 -16 -99 -75 -129 -87 -6 -2 -6 -8 2 -16 9 -10\n24 -6 70 20 77 43 93 58 93 89 0 32 -26 71 -47 71 -23 0 0 25 38 40 28 12 35\n30 13 37 -5 2 -56 -24 -114 -58z"
      }, null, 8, _hoisted_320),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M1516 4579 c-43 -12 -86 -57 -86 -91 0 -59 55 -115 97 -101 19 7 3\n33 -21 33 -42 0 -60 46 -36 91 17 30 27 23 62 -41 18 -33 38 -60 44 -60 24 0\n58 51 57 86 -2 62 -54 99 -117 83z m79 -49 c15 -16 17 -26 9 -47 -14 -41 -28\n-37 -58 17 l-27 50 29 0 c16 0 37 -9 47 -20z"
      }, null, 8, _hoisted_321),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M1612 4375 c-84 -49 -97 -59 -88 -74 4 -6 31 3 71 25 71 39 99 39\n117 -2 14 -31 2 -45 -73 -86 -33 -18 -59 -36 -59 -40 0 -22 29 -15 90 22 49\n28 72 48 76 66 8 31 -12 71 -38 80 -13 4 -17 12 -13 24 10 31 -8 28 -83 -15z"
      }, null, 8, _hoisted_322),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15776 5218 c-31 -50 -236 -407 -236 -412 0 -3 55 -38 123 -77 81\n-48 145 -96 192 -141 38 -37 72 -68 75 -68 3 0 15 9 28 18 l24 18 -45 55 c-25\n30 -63 68 -86 84 -44 32 -49 46 -27 65 12 9 28 4 80 -25 37 -20 66 -39 66 -41\n0 -3 -7 -18 -15 -35 -15 -28 -15 -30 10 -39 15 -6 30 -10 34 -10 7 0 49 92 87\n189 17 44 17 44 -6 63 -12 10 -21 20 -19 21 2 2 27 13 54 25 28 13 61 31 73\n41 23 17 23 18 8 56 l-16 38 -23 -20 c-12 -11 -37 -28 -54 -37 l-33 -17 0 51\nc0 52 -4 55 -48 43 -22 -5 -24 -9 -17 -58 l6 -52 -31 -7 c-18 -3 -36 -4 -40\n-1 -5 3 11 39 35 79 l44 75 -26 16 c-16 11 -28 13 -32 7 -3 -6 -49 -86 -101\n-177 -52 -92 -100 -169 -106 -171 -12 -5 -124 56 -124 67 0 4 47 89 105 190\n58 100 104 183 103 184 -2 1 -13 7 -25 14 -19 10 -24 8 -37 -11z m274 -344 c0\n-5 -42 -99 -45 -102 -2 -3 -33 12 -70 32 -54 31 -64 40 -56 54 7 14 24 17 90\n17 45 0 81 0 81 -1z"
      }, null, 8, _hoisted_323),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15847 5138 c-41 -65 -167 -289 -167 -295 0 -9 40 -36 45 -31 10 10\n186 320 183 323 -2 1 -13 7 -25 14 -19 10 -24 8 -36 -11z"
      }, null, 8, _hoisted_324),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M16455 5016 c-16 -16 -25 -36 -25 -56 0 -17 -5 -29 -11 -27 -6 1 -13\n-3 -16 -9 -4 -11 145 -104 167 -104 26 0 5 29 -38 53 -69 38 -88 61 -76 95 14\n39 44 39 114 -2 57 -33 80 -38 80 -16 0 9 -112 74 -147 84 -17 5 -29 1 -48\n-18z"
      }, null, 8, _hoisted_325),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M16336 4809 c-14 -17 -26 -43 -26 -58 0 -54 57 -101 124 -101 61 0\n105 76 75 131 -15 30 -31 12 -23 -27 5 -26 2 -40 -11 -54 -17 -19 -64 -27 -78\n-14 -3 3 10 32 29 64 38 66 40 75 18 84 -40 16 -82 6 -108 -25z m84 -8 c0 -8\n-34 -73 -47 -90 -7 -9 -33 23 -33 41 0 36 19 58 50 58 17 0 30 -4 30 -9z"
      }, null, 8, _hoisted_326),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M16253 4649 c-25 -9 -43 -38 -43 -68 0 -26 -7 -26 -48 -1 -39 24 -38\n24 -45 6 -4 -10 29 -34 110 -80 64 -36 120 -66 124 -66 26 0 2 29 -51 62 -64\n39 -79 61 -63 86 24 38 41 38 112 0 62 -34 81 -38 81 -17 0 8 -91 62 -130 77\n-14 5 -35 6 -47 1z"
      }, null, 8, _hoisted_327),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M16062 4474 c-45 -31 -64 -101 -43 -157 13 -33 72 -77 117 -87 80\n-18 154 40 154 120 0 44 -32 92 -50 74 -8 -8 -6 -19 6 -40 20 -36 14 -74 -18\n-104 -57 -53 -188 12 -188 94 1 42 29 76 70 85 18 3 35 12 38 19 6 18 -59 15\n-86 -4z"
      }, null, 8, _hoisted_328),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3440 4140 c-27 -27 -25 -59 7 -124 30 -62 26 -89 -13 -84 -39 4 -68\n47 -55 80 8 21 6 29 -10 44 -17 16 -22 16 -30 4 -15 -25 -22 -59 -15 -85 8\n-33 68 -91 99 -97 38 -7 82 16 96 50 11 27 9 37 -17 98 -32 72 -32 84 -3 84\n27 0 55 -37 53 -69 -1 -16 5 -34 14 -42 14 -11 18 -10 30 6 18 24 18 49 -1 85\n-34 66 -113 92 -155 50z"
      }, null, 8, _hoisted_329),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3585 3896 c-42 -65 -75 -125 -73 -133 8 -40 34 -37 123 11 48 26 89\n45 92 43 2 -3 -20 -43 -50 -89 -53 -82 -54 -85 -36 -106 9 -12 20 -22 23 -22\n6 0 236 128 245 137 3 2 -4 12 -15 23 -19 18 -20 18 -101 -31 -46 -27 -83 -47\n-83 -44 0 2 23 41 51 85 l52 81 -23 24 -23 25 -83 -45 c-45 -25 -85 -45 -88\n-45 -4 0 19 36 50 81 l57 81 -21 20 -21 21 -76 -117z"
      }, null, 8, _hoisted_330),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3893 3687 c-19 -10 -20 -14 -8 -30 9 -13 20 -17 35 -12 25 8 50 -10\n50 -35 0 -34 -28 -44 -113 -42 -49 1 -94 -4 -112 -12 l-30 -13 67 -69 c64 -66\n68 -68 85 -52 16 17 15 20 -22 58 l-39 40 82 0 c75 0 85 2 107 25 35 34 34 83\n-2 117 -34 33 -71 42 -100 25z"
      }, null, 8, _hoisted_331),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14119 4049 c-30 -33 -36 -66 -18 -100 10 -19 12 -20 29 -4 10 9 16\n24 13 36 -11 42 46 68 67 30 5 -11 10 -57 10 -103 1 -46 6 -93 13 -105 12 -22\n14 -21 82 42 67 60 69 64 53 81 -17 17 -19 17 -57 -20 l-39 -38 -3 80 c-4 68\n-8 84 -28 106 -35 38 -84 35 -122 -5z"
      }, null, 8, _hoisted_332),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13942 3877 l-72 -72 99 -99 99 -99 76 68 c42 38 76 72 76 75 0 4 -7\n13 -16 20 -13 11 -23 5 -70 -41 l-54 -53 -27 27 -27 27 49 50 c47 47 48 51 32\n67 -16 16 -20 15 -67 -32 l-50 -49 -22 22 -22 22 53 54 c46 47 52 57 41 70 -7\n9 -15 16 -19 16 -4 0 -39 -33 -79 -73z"
      }, null, 8, _hoisted_333),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13783 3724 c-64 -32 -92 -115 -53 -154 27 -27 73 -25 131 6 54 30\n79 26 79 -10 0 -34 -43 -67 -79 -60 -18 4 -32 0 -41 -11 -12 -15 -12 -19 5\n-31 62 -45 185 42 170 121 -6 33 -47 75 -73 75 -9 0 -46 -14 -80 -30 -66 -31\n-82 -31 -82 -1 0 27 35 54 64 49 29 -6 66 26 50 42 -18 18 -60 20 -91 4z"
      }, null, 8, _hoisted_334),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14500 3495 c-64 -64 -72 -76 -60 -90 12 -14 19 -11 65 35 42 42 54\n48 63 37 9 -10 1 -24 -38 -62 l-50 -49 43 -44 c37 -38 46 -42 74 -37 50 9 50\n-13 -1 -63 -33 -34 -49 -43 -57 -35 -8 8 -8 17 1 32 22 42 -13 92 -49 70 -14\n-10 -18 -20 -14 -39 4 -22 -2 -33 -33 -58 -36 -30 -39 -31 -56 -15 -18 16 -17\n19 32 68 l50 51 -43 42 -43 42 -74 -75 c-64 -64 -72 -76 -60 -90 12 -14 19\n-11 65 35 42 42 54 48 63 37 9 -10 1 -24 -38 -62 l-50 -49 42 -43 c49 -50 71\n-53 110 -16 22 21 31 24 40 15 9 -9 3 -21 -27 -52 -37 -38 -38 -41 -22 -57 16\n-16 19 -15 56 21 36 36 61 41 61 13 0 -6 -19 -31 -42 -54 -40 -41 -41 -44 -25\n-60 16 -16 20 -14 78 42 49 48 60 55 54 35 -4 -14 -20 -47 -36 -73 -35 -59\n-35 -61 -4 -75 23 -11 26 -8 58 46 51 86 63 122 46 133 -8 5 -21 9 -29 9 -8 0\n10 24 40 55 30 30 58 55 62 55 4 0 8 -11 8 -25 0 -14 2 -25 4 -25 16 0 91 34\n134 60 44 27 52 36 46 54 -11 38 -20 37 -89 -3 -38 -22 -71 -38 -74 -35 -3 2\n21 31 52 62 55 56 57 59 39 75 -17 16 -20 15 -57 -23 -22 -22 -45 -40 -51 -40\n-29 0 -24 24 12 61 36 37 37 40 21 56 -16 16 -19 15 -57 -22 -30 -29 -43 -36\n-51 -28 -9 9 -4 21 20 48 36 41 38 54 13 85 -16 20 -21 21 -39 9 -16 -10 -20\n-20 -16 -39 4 -22 -2 -33 -33 -58 -36 -30 -39 -31 -56 -15 -18 16 -17 19 32\n68 l50 51 -43 42 -43 42 -74 -75z m197 -281 c4 -10 -9 -31 -38 -60 -38 -39\n-45 -42 -58 -29 -14 13 -10 20 29 60 48 49 58 53 67 29z"
      }, null, 8, _hoisted_335),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M15108 3106 c-12 -6 -30 -25 -38 -42 -9 -17 -21 -29 -27 -27 -33 11\n-14 -22 52 -87 60 -60 75 -70 81 -57 4 13 -9 33 -45 72 -28 29 -51 58 -51 62\n0 18 32 53 48 53 9 0 40 -23 68 -51 38 -38 57 -50 70 -45 15 6 8 16 -41 66\n-64 64 -82 73 -117 56z"
      }, null, 8, _hoisted_336),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14967 2963 c-4 -3 16 -30 43 -59 50 -53 62 -88 38 -112 -23 -23 -53\n-12 -105 40 -43 42 -55 50 -65 39 -11 -10 -1 -24 50 -72 34 -32 71 -59 81 -59\n30 0 71 39 71 66 0 14 4 22 10 19 6 -3 15 -3 21 1 7 4 -16 33 -57 75 -69 70\n-75 74 -87 62z"
      }, null, 8, _hoisted_337),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M14764 2876 c-3 -8 -1 -42 4 -75 10 -69 13 -66 -68 -51 -39 7 -57 7\n-67 -2 -13 -10 -12 -13 4 -19 11 -4 45 -10 77 -14 67 -9 71 -15 81 -108 8 -70\n16 -85 33 -64 7 8 7 28 2 57 -5 25 -9 57 -10 71 l0 26 68 -13 c56 -11 69 -11\n81 1 18 18 14 19 -86 35 -39 6 -74 17 -76 24 -3 7 -8 43 -12 79 -7 64 -19 84\n-31 53z"
      }, null, 8, _hoisted_338),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3205 3510 c-35 -36 -40 -38 -55 -25 -21 19 -34 19 -50 0 -10 -13 -9\n-19 6 -36 18 -20 17 -21 -49 -87 l-67 -67 -30 17 c-29 17 -30 16 -50 -12 l-20\n-28 42 -25 c24 -13 63 -35 87 -47 l45 -22 19 23 c18 23 18 23 -5 41 l-23 17\n58 58 c52 53 59 57 78 45 18 -11 24 -11 40 4 18 16 18 18 2 36 -16 18 -15 21\n25 61 l42 43 -23 22 c-13 12 -25 22 -28 22 -3 0 -22 -18 -44 -40z"
      }, null, 8, _hoisted_339),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M3200 3295 l-114 -114 23 -25 c13 -14 28 -23 33 -20 5 3 18 -2 29\n-12 19 -17 19 -19 -38 -76 l-57 -58 27 -27 27 -27 58 57 c57 57 59 57 76 38\n10 -11 15 -24 12 -29 -3 -5 6 -20 20 -33 l25 -23 114 114 115 114 -45 46 -45\n46 20 20 20 20 -28 27 -29 27 -18 -20 c-19 -21 -19 -21 -65 25 l-46 45 -114\n-115z m144 -3 c15 -18 15 -20 -4 -37 -19 -17 -21 -17 -40 0 -19 17 -19 19 -4\n37 10 10 20 18 24 18 4 0 14 -8 24 -18z m-81 -80 c16 -17 15 -20 -6 -40 l-24\n-22 -18 20 c-17 19 -17 21 0 40 22 25 28 25 48 2z m172 -52 l-19 -21 -20 20\nc-19 20 -19 21 -1 41 l19 21 20 -20 c19 -20 19 -21 1 -41z m-82 -82 c-22 -21\n-23 -21 -43 -3 l-20 18 22 24 22 23 20 -20 20 -20 -21 -22z"
      }, null, 8, _hoisted_340),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2630 3075 c-74 -74 -92 -97 -82 -107 9 -9 19 -5 45 20 23 22 42 32\n65 32 37 0 37 -1 21 -100 -10 -55 -9 -73 1 -85 7 -9 14 -14 16 -12 2 1 8 34\n14 72 21 138 10 125 102 125 70 0 79 2 68 15 -10 11 -36 15 -111 15 -55 0 -99\n4 -99 8 0 4 20 28 45 52 42 41 49 60 22 60 -7 0 -55 -43 -107 -95z"
      }, null, 8, _hoisted_341),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2797 2871 c-33 -34 -57 -69 -57 -81 0 -27 43 -70 69 -70 13 0 19 -5\n15 -14 -14 -36 19 -19 80 43 83 83 83 119 1 42 -54 -51 -89 -63 -113 -39 -23\n23 -12 53 39 104 45 45 56 74 30 74 -4 0 -33 -27 -64 -59z"
      }, null, 8, _hoisted_342),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M2946 2701 c-83 -83 -82 -117 1 -41 32 29 64 50 77 50 22 0 56 -28\n56 -45 0 -5 -26 -35 -57 -67 -46 -47 -55 -60 -45 -70 11 -11 25 -1 73 49 39\n40 59 69 59 85 0 30 -39 68 -69 68 -19 0 -21 3 -12 13 10 13 6 27 -8 27 -4 0\n-37 -31 -75 -69z"
      }, null, 8, _hoisted_343),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8196 3714 c-10 -27 -7 -52 8 -57 20 -8 26 2 26 40 0 35 -23 47 -34\n17z"
      }, null, 8, _hoisted_344),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9564 3708 c3 -13 6 -31 6 -41 0 -12 6 -17 18 -15 9 2 17 9 16 16 -1\n6 -2 23 -2 37 -2 18 -8 25 -23 25 -17 0 -20 -4 -15 -22z"
      }, null, 8, _hoisted_345),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8178 3576 c-3 -26 0 -36 13 -39 12 -3 19 4 23 25 9 45 8 48 -13 48\n-14 0 -20 -9 -23 -34z"
      }, null, 8, _hoisted_346),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9580 3586 c0 -36 10 -55 26 -49 8 3 14 19 14 39 0 27 -4 34 -20 34\n-14 0 -20 -7 -20 -24z"
      }, null, 8, _hoisted_347),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8166 3477 c-11 -41 -7 -57 14 -57 16 0 20 7 20 34 0 40 -25 56 -34\n23z"
      }, null, 8, _hoisted_348),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9598 3455 c3 -26 9 -35 23 -35 10 0 19 6 19 13 0 31 -14 57 -29 57\n-13 0 -16 -7 -13 -35z"
      }, null, 8, _hoisted_349),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8150 3356 c0 -13 -3 -31 -6 -40 -4 -11 0 -16 14 -16 24 0 40 59 20\n72 -21 13 -28 9 -28 -16z"
      }, null, 8, _hoisted_350),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9610 3358 c0 -32 14 -58 29 -58 13 0 16 7 13 35 -3 26 -9 35 -23 35\n-10 0 -19 -6 -19 -12z"
      }, null, 8, _hoisted_351),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8136 3244 c-13 -34 -7 -64 14 -64 17 0 20 7 20 40 0 41 -21 57 -34\n24z"
      }, null, 8, _hoisted_352),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9637 3253 c-4 -3 -7 -21 -7 -40 0 -26 4 -33 20 -33 14 0 20 7 20 24\n0 44 -16 67 -33 49z"
      }, null, 8, _hoisted_353),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8120 3116 c0 -13 -3 -31 -6 -40 -4 -11 0 -16 14 -16 14 0 21 9 26\n31 9 46 8 49 -14 49 -14 0 -20 -7 -20 -24z"
      }, null, 8, _hoisted_354),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9647 3133 c-3 -5 -2 -23 0 -40 4 -25 10 -33 25 -33 16 0 19 5 14 23\n-3 12 -6 30 -6 40 0 17 -25 24 -33 10z"
      }, null, 8, _hoisted_355),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8107 3013 c-4 -3 -7 -22 -7 -40 0 -27 4 -34 18 -31 22 4 31 78 9 78\n-7 0 -17 -3 -20 -7z"
      }, null, 8, _hoisted_356),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9660 2997 c0 -36 10 -57 27 -57 22 0 13 74 -9 78 -13 3 -18 -3 -18\n-21z"
      }, null, 8, _hoisted_357),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8090 2883 c0 -10 -3 -28 -6 -40 -5 -19 -2 -23 15 -23 13 0 21 6 21\n18 0 9 3 27 6 40 5 18 2 22 -15 22 -13 0 -21 -6 -21 -17z"
      }, null, 8, _hoisted_358),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9679 2895 c-3 -2 -3 -20 -1 -40 3 -27 9 -35 24 -35 18 0 20 5 14 31\n-3 17 -6 35 -6 40 0 9 -23 12 -31 4z"
      }, null, 8, _hoisted_359),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8077 2773 c-4 -3 -7 -22 -7 -40 0 -27 4 -34 18 -31 22 4 31 78 9 78\n-7 0 -17 -3 -20 -7z"
      }, null, 8, _hoisted_360),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9695 2743 c8 -45 10 -47 28 -40 9 3 12 17 9 41 -3 28 -9 36 -24 36\n-18 0 -19 -4 -13 -37z"
      }, null, 8, _hoisted_361),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8056 2628 c-4 -21 -2 -34 6 -40 21 -13 28 -9 28 16 0 13 3 31 6 40\n4 11 0 16 -14 16 -14 0 -21 -9 -26 -32z"
      }, null, 8, _hoisted_362),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9712 2623 c3 -38 24 -56 34 -29 9 24 -4 66 -22 66 -11 0 -14 -9 -12\n-37z"
      }, null, 8, _hoisted_363),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4876 2919 c-43 -34 -34 -79 30 -151 36 -40 36 -63 2 -74 -30 -9 -72\n26 -76 64 -3 30 -32 59 -46 45 -14 -14 -5 -81 14 -106 25 -31 100 -62 129 -52\n34 11 61 46 61 80 0 23 -13 46 -45 84 -25 30 -44 59 -42 65 11 34 87 2 87 -37\n0 -29 39 -55 51 -35 22 34 -7 91 -61 118 -50 25 -71 25 -104 -1z"
      }, null, 8, _hoisted_364),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5058 2700 l-45 -137 25 -16 c26 -15 27 -14 100 54 41 38 77 68 79\n65 3 -2 -9 -47 -25 -100 l-30 -95 25 -17 c26 -16 26 -16 129 87 99 99 102 103\n83 117 -20 14 -26 10 -96 -59 -42 -41 -74 -67 -71 -59 3 8 17 52 33 98 15 46\n25 84 24 86 -51 38 -47 39 -122 -30 -38 -35 -71 -63 -73 -62 -1 2 10 41 27 86\n16 46 29 87 29 91 0 4 -10 13 -23 18 -23 11 -24 8 -69 -127z"
      }, null, 8, _hoisted_365),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M5495 2570 c-11 -5 -34 -9 -50 -9 -30 -1 -55 -16 -55 -33 0 -4 18 -8\n40 -8 l39 0 -54 -87 c-54 -85 -54 -87 -34 -101 11 -8 24 -10 28 -6 17 20 141\n224 141 233 0 7 -26 23 -33 20 -1 0 -11 -4 -22 -9z"
      }, null, 8, _hoisted_366),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12666 2838 c-28 -26 -39 -57 -27 -76 10 -17 41 -4 41 18 0 23 26 44\n45 36 23 -8 29 -35 13 -54 -8 -9 -13 -25 -11 -34 5 -21 8 -21 32 -8 13 6 24 5\n39 -6 47 -32 10 -100 -39 -73 -17 9 -25 8 -38 -6 -15 -15 -15 -17 3 -31 55\n-40 146 9 146 78 0 37 -33 78 -62 78 -12 0 -16 9 -15 36 1 25 -5 41 -18 50\n-29 21 -80 17 -109 -8z"
      }, null, 8, _hoisted_367),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12463 2731 l-82 -47 66 -119 c36 -66 67 -122 69 -123 5 -7 184 93\n184 103 0 6 -4 16 -8 23 -7 10 -23 5 -71 -23 -35 -19 -67 -35 -72 -35 -9 0\n-43 60 -37 65 2 1 29 17 60 35 50 28 56 34 48 51 -10 18 -13 18 -70 -11 -33\n-17 -61 -30 -64 -30 -2 0 -11 11 -20 25 -16 24 -16 24 50 61 44 25 64 41 62\n53 -5 27 -30 21 -115 -28z"
      }, null, 8, _hoisted_368),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12255 2625 c-48 -17 -85 -57 -85 -91 0 -14 12 -37 26 -51 27 -27 39\n-27 145 -8 32 6 38 4 44 -15 14 -43 -49 -83 -89 -56 -21 13 -26 13 -45 -1 -21\n-14 -21 -16 -5 -34 27 -30 75 -34 122 -10 49 25 72 55 72 96 -1 65 -48 89\n-138 70 -52 -11 -63 -10 -74 2 -24 29 40 67 82 49 9 -3 24 0 35 8 18 13 18 16\n5 29 -24 24 -52 27 -95 12z"
      }, null, 8, _hoisted_369),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8700 2196 l0 -146 25 0 c22 0 24 4 27 58 3 50 6 57 26 60 14 2 24\n-3 28 -15 25 -81 64 -113 138 -113 89 0 138 78 116 184 -14 69 -52 106 -113\n113 -73 9 -114 -23 -141 -109 -3 -10 -14 -18 -25 -18 -18 0 -20 8 -23 63 -3\n59 -4 62 -30 65 l-28 3 0 -145z m265 88 c38 -15 59 -110 34 -157 -16 -30 -28\n-37 -65 -37 -48 0 -69 31 -69 100 0 82 37 118 100 94z"
      }, null, 8, _hoisted_370),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9119 2333 c-3 -20 2 -164 7 -220 6 -61 7 -63 35 -63 26 0 27 3 24\n33 -2 17 -6 71 -9 119 l-5 86 70 7 c57 6 69 10 67 24 -3 13 -19 17 -96 19 -50\n1 -92 -1 -93 -5z"
      }, null, 8, _hoisted_371),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4762 2175 c-7 -14 -12 -27 -12 -29 0 -2 34 -23 75 -47 41 -23 75\n-47 75 -51 0 -16 -20 -48 -30 -48 -6 0 -51 23 -100 51 -87 50 -91 51 -105 33\n-8 -11 -15 -24 -15 -30 0 -7 34 -31 76 -55 l76 -44 -43 -13 c-24 -7 -83 -16\n-131 -19 l-88 -6 0 -33 0 -34 88 0 c48 0 105 5 127 10 22 5 41 7 43 5 2 -2 -7\n-20 -21 -42 -13 -21 -31 -52 -41 -70 l-16 -32 30 -16 c17 -9 35 -13 39 -10 5\n3 26 35 47 72 31 56 39 64 45 48 67 -183 84 -211 120 -202 49 13 54 22 30 56\n-36 50 -99 201 -85 201 3 0 40 -20 82 -45 l77 -46 18 22 c9 12 17 25 17 29 0\n4 -42 31 -92 60 -51 29 -95 55 -97 56 -4 4 20 64 26 64 2 0 40 -21 85 -47 l81\n-46 18 24 c23 30 23 35 3 43 -8 3 -46 24 -84 46 l-69 40 20 34 c21 36 19 41\n-28 65 -19 9 -24 7 -42 -24 l-20 -34 -78 44 c-43 25 -81 45 -84 45 -3 0 -11\n-11 -17 -25z"
      }, null, 8, _hoisted_372),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4407 1734 c-7 -27 -25 -91 -38 -142 -21 -81 -22 -94 -9 -102 11 -7\n37 12 109 83 51 51 91 83 87 73 -4 -11 -18 -66 -33 -123 -37 -148 -28 -150 99\n-27 56 54 102 101 102 104 0 3 -7 6 -15 8 -8 1 -50 -33 -93 -78 -43 -44 -79\n-80 -80 -80 -2 0 11 50 28 110 28 104 29 111 13 127 -16 16 -22 12 -107 -72\n-50 -49 -90 -87 -90 -85 0 3 16 54 35 115 29 94 32 112 20 124 -11 12 -16 6\n-28 -35z"
      }, null, 8, _hoisted_373),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4698 1475 c-50 -28 -76 -116 -45 -156 29 -37 103 -53 126 -26 16 20\n3 27 -39 21 -27 -4 -41 -2 -53 11 -19 18 -23 75 -6 75 6 0 37 -16 70 -35 56\n-32 59 -33 69 -15 43 80 -44 168 -122 125z m84 -32 c19 -17 25 -63 8 -63 -11\n0 -51 20 -79 39 -12 8 -12 12 -2 25 17 21 50 20 73 -1z"
      }, null, 8, _hoisted_374),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4934 1465 c-9 -22 5 -38 22 -24 18 15 18 25 -1 33 -9 3 -18 -1 -21\n-9z"
      }, null, 8, _hoisted_375),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M4856 1330 c-48 -82 -52 -95 -37 -105 12 -7 113 163 105 176 -11 19\n-24 6 -68 -71z"
      }, null, 8, _hoisted_376),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M12800 2145 c-107 -63 -194 -119 -192 -125 4 -20 214 -375 226 -383\n25 -17 89 4 192 63 237 137 244 144 203 226 -27 54 -36 59 -73 45 l-27 -11 21\n-40 21 -41 -23 -20 c-34 -30 -226 -139 -250 -142 -16 -1 -30 14 -60 62 -21 34\n-37 68 -36 73 5 13 234 148 251 148 7 0 26 9 44 20 l32 19 -59 102 c-33 56\n-63 105 -67 110 -4 4 -96 -44 -203 -106z m193 -31 c16 -26 25 -50 20 -55 -4\n-4 -48 -31 -98 -59 -49 -28 -104 -60 -121 -71 l-32 -19 -26 44 c-14 25 -26 49\n-26 54 0 9 236 152 250 152 3 0 18 -21 33 -46z"
      }, null, 8, _hoisted_377),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13224 1689 c-8 -14 11 -33 25 -25 11 7 4 36 -9 36 -5 0 -12 -5 -16\n-11z"
      }, null, 8, _hoisted_378),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13260 1618 c0 -22 91 -169 101 -166 18 6 14 18 -32 99 -40 71 -69\n100 -69 67z"
      }, null, 8, _hoisted_379),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M13084 1606 c-37 -16 -64 -51 -64 -82 0 -65 34 -80 130 -57 65 16 72\n16 86 1 49 -49 -51 -123 -117 -88 -11 6 -24 8 -29 5 -16 -10 0 -33 31 -45 24\n-11 37 -10 74 4 76 29 106 92 69 144 -18 26 -49 28 -136 10 -67 -14 -84 -5\n-74 37 4 16 19 32 41 42 30 14 38 15 60 3 36 -19 56 1 24 24 -28 19 -54 20\n-95 2z"
      }, null, 8, _hoisted_380),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M6812 2027 c-41 -44 -26 -92 42 -132 54 -32 68 -48 60 -68 -15 -41\n-89 -25 -107 23 -8 21 -18 30 -34 30 -33 0 -30 -42 5 -81 24 -27 37 -33 86\n-37 49 -4 60 -2 81 18 18 17 25 34 25 60 0 40 -14 56 -87 103 -48 30 -52 41\n-24 57 26 13 71 -4 78 -30 6 -22 40 -37 54 -23 6 6 6 20 0 36 -24 62 -136 90\n-179 44z"
      }, null, 8, _hoisted_381),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M7069 1960 c-24 -20 -24 -20 -5 -35 17 -13 22 -13 37 1 20 18 46 13\n55 -11 8 -19 -13 -45 -36 -45 -10 0 -21 -7 -24 -16 -8 -22 -8 -24 8 -24 45 0\n44 -75 -1 -86 -24 -6 -43 6 -55 36 -2 4 -14 11 -27 15 -22 7 -23 5 -17 -21 27\n-105 186 -99 186 7 0 15 -7 32 -15 39 -13 11 -12 15 10 36 73 67 -40 169 -116\n104z"
      }, null, 8, _hoisted_382),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M10850 2036 c0 -8 -13 -30 -30 -49 -21 -24 -27 -40 -23 -56 l6 -22\n28 27 28 27 9 -24 c5 -13 17 -57 27 -96 19 -72 26 -81 54 -64 13 8 9 29 -20\n138 -30 113 -37 128 -56 131 -15 2 -23 -2 -23 -12z"
      }, null, 8, _hoisted_383),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M10593 1979 c-39 -11 -63 -43 -63 -85 0 -47 27 -65 112 -72 59 -6 73\n-10 76 -25 9 -45 -56 -70 -98 -38 -17 12 -36 18 -49 14 -25 -6 -26 -12 -6 -41\n30 -42 113 -45 171 -7 30 19 44 52 37 87 -9 46 -37 62 -114 66 -76 5 -99 22\n-64 48 24 18 54 18 74 0 11 -9 23 -11 39 -5 29 11 28 23 -4 48 -28 22 -59 25\n-111 10z"
      }, null, 8, _hoisted_384),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8704 1760 c-26 -10 -54 -48 -54 -71 0 -34 39 -66 99 -83 32 -9 62\n-23 65 -31 7 -19 -27 -55 -52 -55 -25 0 -62 28 -62 47 0 11 -6 14 -22 9 -13\n-3 -26 -6 -30 -6 -14 0 15 -61 35 -75 45 -31 165 -11 181 30 10 27 7 70 -7 89\n-7 9 -42 27 -77 40 -50 17 -65 26 -65 41 0 30 69 34 85 6 11 -22 44 -28 55\n-11 11 18 -6 50 -35 65 -32 16 -83 19 -116 5z"
      }, null, 8, _hoisted_385),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8973 1763 c-24 -5 -63 -47 -63 -69 0 -22 48 -17 60 7 17 31 64 22\n68 -13 3 -22 -10 -41 -62 -97 -37 -39 -66 -79 -66 -91 0 -19 6 -20 90 -20 89\n0 90 0 90 25 0 23 -3 25 -52 25 l-52 0 41 43 c62 64 78 111 53 157 -8 16 -63\n42 -79 39 -3 -1 -16 -4 -28 -6z"
      }, null, 8, _hoisted_386),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M10913 1373 c-252 -69 -255 -70 -238 -116 5 -11 23 -9 108 14 56 16\n107 28 113 29 7 0 14 -11 16 -25 6 -27 -5 -32 -144 -66 -33 -8 -48 -16 -48\n-28 0 -19 87 -341 93 -348 3 -2 21 -1 40 2 l35 7 -19 71 c-10 40 -19 74 -19\n76 0 2 8 -4 19 -13 18 -16 20 -15 55 25 19 23 43 61 52 85 l16 43 34 -25 c18\n-14 55 -34 82 -44 l49 -19 13 27 13 27 8 -25 c14 -50 11 -59 -31 -70 l-39 -11\n16 -35 c10 -19 22 -33 29 -30 7 3 31 10 52 16 45 12 65 30 64 63 0 28 -72 299\n-83 311 -4 5 -51 -3 -105 -18 -54 -14 -99 -24 -101 -23 -1 2 -4 14 -5 27 -3\n23 4 26 108 55 107 29 110 31 104 55 -3 15 -14 26 -25 27 -11 1 -129 -28 -262\n-64z m249 -195 c9 -35 15 -65 13 -66 -14 -14 -155 76 -155 98 0 4 19 12 43 17\n80 20 81 19 99 -49z m-243 -38 c-9 -41 -55 -120 -70 -120 -8 0 -39 97 -39 123\n0 14 96 49 111 41 4 -2 3 -22 -2 -44z"
      }, null, 8, _hoisted_387),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M11434 792 c4 -7 -6 -9 -28 -5 -30 5 -40 1 -67 -26 -28 -28 -31 -37\n-26 -73 11 -84 67 -121 132 -88 l36 18 -3 -36 c-2 -30 -8 -38 -31 -46 -20 -7\n-34 -7 -47 2 -26 16 -40 15 -40 -3 0 -33 82 -41 121 -12 39 29 40 50 11 164\n-21 84 -31 109 -46 111 -11 2 -16 0 -12 -6z m-8 -40 c37 -24 45 -99 14 -127\n-33 -29 -72 -10 -89 43 -11 37 -11 45 3 67 16 24 49 32 72 17z"
      }, null, 8, _hoisted_388),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M11003 763 c-14 -5 -17 -29 -5 -37 4 -2 13 -2 19 2 14 9 1 40 -14 35z"
      }, null, 8, _hoisted_389),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M11145 710 c-14 -16 -20 -17 -26 -8 -5 8 -11 9 -17 3 -13 -14 38\n-195 55 -195 17 0 16 9 -2 82 -18 67 -13 96 18 107 35 14 55 -5 72 -67 23 -82\n28 -93 42 -84 10 6 8 25 -8 82 -11 41 -25 80 -31 87 -17 21 -82 16 -103 -7z"
      }, null, 8, _hoisted_390),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M10797 705 c-27 -7 -51 -16 -53 -18 -6 -6 56 -248 66 -259 9 -11 138\n27 160 47 37 33 19 110 -30 127 -9 3 -9 10 1 31 11 24 10 31 -8 55 -24 32 -64\n37 -136 17z m101 -27 c14 -14 16 -54 2 -63 -5 -3 -30 -12 -55 -19 l-45 -14\n-11 40 c-12 46 -11 48 33 58 49 12 63 11 76 -2z m42 -118 c25 -25 25 -42 3\n-62 -15 -13 -82 -38 -104 -38 -7 0 -32 90 -27 95 3 3 81 21 101 24 4 1 16 -8\n27 -19z"
      }, null, 8, _hoisted_391),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M11015 680 c-6 -9 38 -176 49 -187 4 -4 11 -2 16 3 6 6 4 28 -5 59\n-8 28 -19 69 -25 93 -10 41 -23 52 -35 32z"
      }, null, 8, _hoisted_392),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M6628 1423 c-3 -4 -8 -19 -11 -33 -6 -25 -4 -26 103 -54 72 -19 110\n-33 110 -42 0 -8 -13 -62 -29 -121 -16 -60 -34 -128 -41 -152 -11 -43 -12 -43\n-48 -38 -20 3 -43 6 -51 8 -10 3 -17 -8 -21 -34 -4 -21 -4 -39 -1 -41 3 -3 34\n-10 68 -17 102 -21 102 -21 157 188 26 98 51 182 56 186 4 5 51 -4 105 -18 53\n-15 99 -25 101 -23 2 3 6 18 10 34 l6 30 -234 62 c-128 35 -243 65 -254 68\n-12 3 -24 2 -26 -3z"
      }, null, 8, _hoisted_393),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M6341 750 c-17 -66 -34 -126 -37 -134 -4 -9 14 -18 60 -30 36 -9 77\n-16 92 -16 51 0 114 90 114 163 0 11 -7 34 -16 53 -16 33 -68 61 -150 78 l-31\n7 -32 -121z m150 54 c15 -7 29 -21 33 -29 19 -50 -6 -133 -48 -160 -22 -15\n-32 -15 -76 -5 -34 8 -50 17 -50 28 0 13 31 138 46 180 5 15 52 9 95 -14z"
      }, null, 8, _hoisted_394),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M6640 780 c0 -11 7 -20 15 -20 8 0 15 9 15 20 0 11 -7 20 -15 20 -8\n0 -15 -9 -15 -20z"
      }, null, 8, _hoisted_395),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M6602 645 c-12 -46 -25 -91 -28 -100 -4 -10 0 -15 13 -15 15 0 23 17\n41 90 22 83 22 110 3 110 -4 0 -17 -38 -29 -85z"
      }, null, 8, _hoisted_396),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M6706 690 c-10 -30 -46 -170 -46 -180 0 -6 6 -10 14 -10 9 0 21 25\n32 66 22 81 49 106 89 80 30 -20 30 -23 6 -108 -16 -55 -17 -67 -5 -72 7 -3\n15 -2 18 2 9 15 36 131 36 156 0 34 -39 60 -82 54 -23 -4 -36 0 -45 11 -10 14\n-12 14 -17 1z"
      }, null, 8, _hoisted_397),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M6934 629 c-42 -21 -68 -102 -48 -154 10 -24 60 -46 89 -39 21 5 24\n3 19 -12 -19 -52 -72 -62 -100 -19 -16 24 -44 34 -44 16 0 -4 9 -20 20 -34 39\n-50 127 -43 149 11 6 15 22 69 35 120 l25 94 -24 -6 c-14 -4 -25 -2 -25 3 0 5\n-14 14 -31 20 -37 13 -38 13 -65 0z m77 -40 c16 -16 20 -28 15 -52 -9 -47 -33\n-77 -61 -77 -38 0 -58 27 -52 73 10 70 57 97 98 56z"
      }, null, 8, _hoisted_398),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8744 1114 c-14 -41 -65 -147 -83 -173 l-20 -27 29 -17 c15 -9 31\n-17 34 -17 4 0 22 25 42 56 l35 55 47 -3 47 -3 3 -67 3 -68 -121 0 -120 0 0\n-35 0 -35 120 0 120 0 0 -90 0 -90 40 0 40 0 0 90 0 90 110 0 110 0 0 35 0 35\n-110 0 -110 0 0 70 0 70 100 0 100 0 0 30 0 30 -168 0 c-93 0 -171 3 -175 6\n-3 3 -1 17 4 31 12 31 13 30 -33 38 -32 6 -39 4 -44 -11z"
      }, null, 8, _hoisted_399),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M8630 483 c0 -4 11 -51 25 -103 14 -52 30 -112 36 -132 7 -26 15 -38\n28 -38 14 0 24 23 51 121 19 69 36 115 40 108 4 -8 20 -62 36 -121 22 -85 32\n-108 46 -108 12 0 21 13 28 43 7 23 22 81 36 129 28 102 29 108 9 108 -15 0\n-25 -29 -52 -152 -9 -43 -18 -76 -20 -74 -3 3 -24 75 -53 184 -9 34 -15 42\n-34 42 -21 0 -26 -10 -51 -107 -15 -60 -31 -111 -35 -116 -3 -4 -17 43 -31\n105 -19 86 -29 114 -42 116 -9 2 -17 0 -17 -5z"
      }, null, 8, _hoisted_400),
      _createElementVNode("path", {
        fill: __props.color,
        d: "M9010 332 c0 -92 15 -122 61 -122 17 0 39 5 50 10 13 7 19 7 19 0 0\n-5 7 -10 15 -10 12 0 15 18 15 100 0 81 -3 100 -15 100 -11 0 -15 -18 -17 -77\n-3 -71 -5 -78 -28 -90 -20 -10 -29 -10 -45 1 -17 11 -20 26 -23 90 -2 59 -6\n76 -17 76 -12 0 -15 -16 -15 -78z"
      }, null, 8, _hoisted_401)
    ])
  ]))
}
}

})